webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(658),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43875175",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = {
	"firebase": {
		"apiKey": "AIzaSyAY5PSHQgvClm9lCxnIbkBC1LrlqG4Dzc0",
		"authDomain": "mamamia-pwa-staging.firebaseapp.com",
		"databaseURL": "https://mamamia-pwa-staging.firebaseio.com",
		"projectId": "mamamia-pwa-staging",
		"storageBucket": "mamamia-pwa-staging.appspot.com",
		"messagingSenderId": "939919331930"
	},
	"previewUrl": "https://mamamia-pwa.firebaseapp.com/article-preview/",
	"froalaKey": "zEG4iA3C7C6B5F4A3g1pC-7ralkbF4fijD3hD-16wD1D1D1G1F1I4A9B1B6B5==",
	"apiAdmin": "https://us-central1-mamamia-admin.cloudfunctions.net",
	"apiFrontend": "https://us-central1-mamamia-pwa.cloudfunctions.net"
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(665),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(449)
  __webpack_require__(450)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(630),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-187c813c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(674),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(477)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(647),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var ace = __webpack_require__(374);

module.exports = {
    render: function render(h) {
        var height = this.height ? this.px(this.height) : '400px';
        var width = this.width ? this.px(this.width) : '840px';
        return h('div', {
            attrs: {
                style: "margin:10px auto; height: " + height + '; width: ' + width
            }
        });
    },
    props: {
        value: {
            type: String,
            required: true
        },
        lang: String,
        theme: String,
        height: true,
        width: true,
        options: Object
    },
    data: function data() {
        return {
            editor: null,
            contentBackup: ""
        };
    },
    methods: {
        px: function px(n) {
            if (/^\d*$/.test(n)) {
                return n + "px";
            }
            return n;
        }
    },
    watch: {
        value: function value(val) {
            if (this.contentBackup !== val) {
                this.editor.session.setValue(val, 1);
                this.contentBackup = val;
            }
        },
        theme: function theme(newTheme) {
            this.editor.setTheme('ace/theme/' + newTheme);
        },
        lang: function lang(newLang) {
            this.editor.getSession().setMode('ace/mode/' + newLang);
        },
        options: function options(newOption) {
            this.editor.setOptions(newOption);
        },
        height: function height() {
            this.$nextTick(function () {
                this.editor.resize();
            });
        },
        width: function width() {
            this.$nextTick(function () {
                this.editor.resize();
            });
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.editor.destroy();
        this.editor.container.remove();
    },
    mounted: function mounted() {
        var vm = this;
        var lang = this.lang || 'text';
        var theme = this.theme || 'chrome';

        __webpack_require__(372);
        __webpack_require__(373); //language extension prerequsite...
        __webpack_require__(375);
        __webpack_require__(376); //language
        __webpack_require__(377); //language
        __webpack_require__(378);
        __webpack_require__(380);
        __webpack_require__(379); //snippet

        var editor = vm.editor = ace.edit(this.$el);

        this.$emit('init', editor);

        editor.$blockScrolling = Infinity;
        //editor.setOption("enableEmmet", true);
        editor.getSession().setMode('ace/mode/' + lang);
        editor.setTheme('ace/theme/' + theme);
        editor.setValue(this.value, 1);
        this.contentBackup = this.value;

        editor.on('change', function () {
            var content = editor.getValue();
            vm.$emit('input', content);
            vm.contentBackup = content;
        });
        if (vm.options) editor.setOptions(vm.options);
    }
};

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Abreve": "Ă",
	"abreve": "ă",
	"ac": "∾",
	"acd": "∿",
	"acE": "∾̳",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"Acy": "А",
	"acy": "а",
	"AElig": "Æ",
	"aelig": "æ",
	"af": "⁡",
	"Afr": "𝔄",
	"afr": "𝔞",
	"Agrave": "À",
	"agrave": "à",
	"alefsym": "ℵ",
	"aleph": "ℵ",
	"Alpha": "Α",
	"alpha": "α",
	"Amacr": "Ā",
	"amacr": "ā",
	"amalg": "⨿",
	"amp": "&",
	"AMP": "&",
	"andand": "⩕",
	"And": "⩓",
	"and": "∧",
	"andd": "⩜",
	"andslope": "⩘",
	"andv": "⩚",
	"ang": "∠",
	"ange": "⦤",
	"angle": "∠",
	"angmsdaa": "⦨",
	"angmsdab": "⦩",
	"angmsdac": "⦪",
	"angmsdad": "⦫",
	"angmsdae": "⦬",
	"angmsdaf": "⦭",
	"angmsdag": "⦮",
	"angmsdah": "⦯",
	"angmsd": "∡",
	"angrt": "∟",
	"angrtvb": "⊾",
	"angrtvbd": "⦝",
	"angsph": "∢",
	"angst": "Å",
	"angzarr": "⍼",
	"Aogon": "Ą",
	"aogon": "ą",
	"Aopf": "𝔸",
	"aopf": "𝕒",
	"apacir": "⩯",
	"ap": "≈",
	"apE": "⩰",
	"ape": "≊",
	"apid": "≋",
	"apos": "'",
	"ApplyFunction": "⁡",
	"approx": "≈",
	"approxeq": "≊",
	"Aring": "Å",
	"aring": "å",
	"Ascr": "𝒜",
	"ascr": "𝒶",
	"Assign": "≔",
	"ast": "*",
	"asymp": "≈",
	"asympeq": "≍",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"awconint": "∳",
	"awint": "⨑",
	"backcong": "≌",
	"backepsilon": "϶",
	"backprime": "‵",
	"backsim": "∽",
	"backsimeq": "⋍",
	"Backslash": "∖",
	"Barv": "⫧",
	"barvee": "⊽",
	"barwed": "⌅",
	"Barwed": "⌆",
	"barwedge": "⌅",
	"bbrk": "⎵",
	"bbrktbrk": "⎶",
	"bcong": "≌",
	"Bcy": "Б",
	"bcy": "б",
	"bdquo": "„",
	"becaus": "∵",
	"because": "∵",
	"Because": "∵",
	"bemptyv": "⦰",
	"bepsi": "϶",
	"bernou": "ℬ",
	"Bernoullis": "ℬ",
	"Beta": "Β",
	"beta": "β",
	"beth": "ℶ",
	"between": "≬",
	"Bfr": "𝔅",
	"bfr": "𝔟",
	"bigcap": "⋂",
	"bigcirc": "◯",
	"bigcup": "⋃",
	"bigodot": "⨀",
	"bigoplus": "⨁",
	"bigotimes": "⨂",
	"bigsqcup": "⨆",
	"bigstar": "★",
	"bigtriangledown": "▽",
	"bigtriangleup": "△",
	"biguplus": "⨄",
	"bigvee": "⋁",
	"bigwedge": "⋀",
	"bkarow": "⤍",
	"blacklozenge": "⧫",
	"blacksquare": "▪",
	"blacktriangle": "▴",
	"blacktriangledown": "▾",
	"blacktriangleleft": "◂",
	"blacktriangleright": "▸",
	"blank": "␣",
	"blk12": "▒",
	"blk14": "░",
	"blk34": "▓",
	"block": "█",
	"bne": "=⃥",
	"bnequiv": "≡⃥",
	"bNot": "⫭",
	"bnot": "⌐",
	"Bopf": "𝔹",
	"bopf": "𝕓",
	"bot": "⊥",
	"bottom": "⊥",
	"bowtie": "⋈",
	"boxbox": "⧉",
	"boxdl": "┐",
	"boxdL": "╕",
	"boxDl": "╖",
	"boxDL": "╗",
	"boxdr": "┌",
	"boxdR": "╒",
	"boxDr": "╓",
	"boxDR": "╔",
	"boxh": "─",
	"boxH": "═",
	"boxhd": "┬",
	"boxHd": "╤",
	"boxhD": "╥",
	"boxHD": "╦",
	"boxhu": "┴",
	"boxHu": "╧",
	"boxhU": "╨",
	"boxHU": "╩",
	"boxminus": "⊟",
	"boxplus": "⊞",
	"boxtimes": "⊠",
	"boxul": "┘",
	"boxuL": "╛",
	"boxUl": "╜",
	"boxUL": "╝",
	"boxur": "└",
	"boxuR": "╘",
	"boxUr": "╙",
	"boxUR": "╚",
	"boxv": "│",
	"boxV": "║",
	"boxvh": "┼",
	"boxvH": "╪",
	"boxVh": "╫",
	"boxVH": "╬",
	"boxvl": "┤",
	"boxvL": "╡",
	"boxVl": "╢",
	"boxVL": "╣",
	"boxvr": "├",
	"boxvR": "╞",
	"boxVr": "╟",
	"boxVR": "╠",
	"bprime": "‵",
	"breve": "˘",
	"Breve": "˘",
	"brvbar": "¦",
	"bscr": "𝒷",
	"Bscr": "ℬ",
	"bsemi": "⁏",
	"bsim": "∽",
	"bsime": "⋍",
	"bsolb": "⧅",
	"bsol": "\\",
	"bsolhsub": "⟈",
	"bull": "•",
	"bullet": "•",
	"bump": "≎",
	"bumpE": "⪮",
	"bumpe": "≏",
	"Bumpeq": "≎",
	"bumpeq": "≏",
	"Cacute": "Ć",
	"cacute": "ć",
	"capand": "⩄",
	"capbrcup": "⩉",
	"capcap": "⩋",
	"cap": "∩",
	"Cap": "⋒",
	"capcup": "⩇",
	"capdot": "⩀",
	"CapitalDifferentialD": "ⅅ",
	"caps": "∩︀",
	"caret": "⁁",
	"caron": "ˇ",
	"Cayleys": "ℭ",
	"ccaps": "⩍",
	"Ccaron": "Č",
	"ccaron": "č",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"Ccirc": "Ĉ",
	"ccirc": "ĉ",
	"Cconint": "∰",
	"ccups": "⩌",
	"ccupssm": "⩐",
	"Cdot": "Ċ",
	"cdot": "ċ",
	"cedil": "¸",
	"Cedilla": "¸",
	"cemptyv": "⦲",
	"cent": "¢",
	"centerdot": "·",
	"CenterDot": "·",
	"cfr": "𝔠",
	"Cfr": "ℭ",
	"CHcy": "Ч",
	"chcy": "ч",
	"check": "✓",
	"checkmark": "✓",
	"Chi": "Χ",
	"chi": "χ",
	"circ": "ˆ",
	"circeq": "≗",
	"circlearrowleft": "↺",
	"circlearrowright": "↻",
	"circledast": "⊛",
	"circledcirc": "⊚",
	"circleddash": "⊝",
	"CircleDot": "⊙",
	"circledR": "®",
	"circledS": "Ⓢ",
	"CircleMinus": "⊖",
	"CirclePlus": "⊕",
	"CircleTimes": "⊗",
	"cir": "○",
	"cirE": "⧃",
	"cire": "≗",
	"cirfnint": "⨐",
	"cirmid": "⫯",
	"cirscir": "⧂",
	"ClockwiseContourIntegral": "∲",
	"CloseCurlyDoubleQuote": "”",
	"CloseCurlyQuote": "’",
	"clubs": "♣",
	"clubsuit": "♣",
	"colon": ":",
	"Colon": "∷",
	"Colone": "⩴",
	"colone": "≔",
	"coloneq": "≔",
	"comma": ",",
	"commat": "@",
	"comp": "∁",
	"compfn": "∘",
	"complement": "∁",
	"complexes": "ℂ",
	"cong": "≅",
	"congdot": "⩭",
	"Congruent": "≡",
	"conint": "∮",
	"Conint": "∯",
	"ContourIntegral": "∮",
	"copf": "𝕔",
	"Copf": "ℂ",
	"coprod": "∐",
	"Coproduct": "∐",
	"copy": "©",
	"COPY": "©",
	"copysr": "℗",
	"CounterClockwiseContourIntegral": "∳",
	"crarr": "↵",
	"cross": "✗",
	"Cross": "⨯",
	"Cscr": "𝒞",
	"cscr": "𝒸",
	"csub": "⫏",
	"csube": "⫑",
	"csup": "⫐",
	"csupe": "⫒",
	"ctdot": "⋯",
	"cudarrl": "⤸",
	"cudarrr": "⤵",
	"cuepr": "⋞",
	"cuesc": "⋟",
	"cularr": "↶",
	"cularrp": "⤽",
	"cupbrcap": "⩈",
	"cupcap": "⩆",
	"CupCap": "≍",
	"cup": "∪",
	"Cup": "⋓",
	"cupcup": "⩊",
	"cupdot": "⊍",
	"cupor": "⩅",
	"cups": "∪︀",
	"curarr": "↷",
	"curarrm": "⤼",
	"curlyeqprec": "⋞",
	"curlyeqsucc": "⋟",
	"curlyvee": "⋎",
	"curlywedge": "⋏",
	"curren": "¤",
	"curvearrowleft": "↶",
	"curvearrowright": "↷",
	"cuvee": "⋎",
	"cuwed": "⋏",
	"cwconint": "∲",
	"cwint": "∱",
	"cylcty": "⌭",
	"dagger": "†",
	"Dagger": "‡",
	"daleth": "ℸ",
	"darr": "↓",
	"Darr": "↡",
	"dArr": "⇓",
	"dash": "‐",
	"Dashv": "⫤",
	"dashv": "⊣",
	"dbkarow": "⤏",
	"dblac": "˝",
	"Dcaron": "Ď",
	"dcaron": "ď",
	"Dcy": "Д",
	"dcy": "д",
	"ddagger": "‡",
	"ddarr": "⇊",
	"DD": "ⅅ",
	"dd": "ⅆ",
	"DDotrahd": "⤑",
	"ddotseq": "⩷",
	"deg": "°",
	"Del": "∇",
	"Delta": "Δ",
	"delta": "δ",
	"demptyv": "⦱",
	"dfisht": "⥿",
	"Dfr": "𝔇",
	"dfr": "𝔡",
	"dHar": "⥥",
	"dharl": "⇃",
	"dharr": "⇂",
	"DiacriticalAcute": "´",
	"DiacriticalDot": "˙",
	"DiacriticalDoubleAcute": "˝",
	"DiacriticalGrave": "`",
	"DiacriticalTilde": "˜",
	"diam": "⋄",
	"diamond": "⋄",
	"Diamond": "⋄",
	"diamondsuit": "♦",
	"diams": "♦",
	"die": "¨",
	"DifferentialD": "ⅆ",
	"digamma": "ϝ",
	"disin": "⋲",
	"div": "÷",
	"divide": "÷",
	"divideontimes": "⋇",
	"divonx": "⋇",
	"DJcy": "Ђ",
	"djcy": "ђ",
	"dlcorn": "⌞",
	"dlcrop": "⌍",
	"dollar": "$",
	"Dopf": "𝔻",
	"dopf": "𝕕",
	"Dot": "¨",
	"dot": "˙",
	"DotDot": "⃜",
	"doteq": "≐",
	"doteqdot": "≑",
	"DotEqual": "≐",
	"dotminus": "∸",
	"dotplus": "∔",
	"dotsquare": "⊡",
	"doublebarwedge": "⌆",
	"DoubleContourIntegral": "∯",
	"DoubleDot": "¨",
	"DoubleDownArrow": "⇓",
	"DoubleLeftArrow": "⇐",
	"DoubleLeftRightArrow": "⇔",
	"DoubleLeftTee": "⫤",
	"DoubleLongLeftArrow": "⟸",
	"DoubleLongLeftRightArrow": "⟺",
	"DoubleLongRightArrow": "⟹",
	"DoubleRightArrow": "⇒",
	"DoubleRightTee": "⊨",
	"DoubleUpArrow": "⇑",
	"DoubleUpDownArrow": "⇕",
	"DoubleVerticalBar": "∥",
	"DownArrowBar": "⤓",
	"downarrow": "↓",
	"DownArrow": "↓",
	"Downarrow": "⇓",
	"DownArrowUpArrow": "⇵",
	"DownBreve": "̑",
	"downdownarrows": "⇊",
	"downharpoonleft": "⇃",
	"downharpoonright": "⇂",
	"DownLeftRightVector": "⥐",
	"DownLeftTeeVector": "⥞",
	"DownLeftVectorBar": "⥖",
	"DownLeftVector": "↽",
	"DownRightTeeVector": "⥟",
	"DownRightVectorBar": "⥗",
	"DownRightVector": "⇁",
	"DownTeeArrow": "↧",
	"DownTee": "⊤",
	"drbkarow": "⤐",
	"drcorn": "⌟",
	"drcrop": "⌌",
	"Dscr": "𝒟",
	"dscr": "𝒹",
	"DScy": "Ѕ",
	"dscy": "ѕ",
	"dsol": "⧶",
	"Dstrok": "Đ",
	"dstrok": "đ",
	"dtdot": "⋱",
	"dtri": "▿",
	"dtrif": "▾",
	"duarr": "⇵",
	"duhar": "⥯",
	"dwangle": "⦦",
	"DZcy": "Џ",
	"dzcy": "џ",
	"dzigrarr": "⟿",
	"Eacute": "É",
	"eacute": "é",
	"easter": "⩮",
	"Ecaron": "Ě",
	"ecaron": "ě",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"ecir": "≖",
	"ecolon": "≕",
	"Ecy": "Э",
	"ecy": "э",
	"eDDot": "⩷",
	"Edot": "Ė",
	"edot": "ė",
	"eDot": "≑",
	"ee": "ⅇ",
	"efDot": "≒",
	"Efr": "𝔈",
	"efr": "𝔢",
	"eg": "⪚",
	"Egrave": "È",
	"egrave": "è",
	"egs": "⪖",
	"egsdot": "⪘",
	"el": "⪙",
	"Element": "∈",
	"elinters": "⏧",
	"ell": "ℓ",
	"els": "⪕",
	"elsdot": "⪗",
	"Emacr": "Ē",
	"emacr": "ē",
	"empty": "∅",
	"emptyset": "∅",
	"EmptySmallSquare": "◻",
	"emptyv": "∅",
	"EmptyVerySmallSquare": "▫",
	"emsp13": " ",
	"emsp14": " ",
	"emsp": " ",
	"ENG": "Ŋ",
	"eng": "ŋ",
	"ensp": " ",
	"Eogon": "Ę",
	"eogon": "ę",
	"Eopf": "𝔼",
	"eopf": "𝕖",
	"epar": "⋕",
	"eparsl": "⧣",
	"eplus": "⩱",
	"epsi": "ε",
	"Epsilon": "Ε",
	"epsilon": "ε",
	"epsiv": "ϵ",
	"eqcirc": "≖",
	"eqcolon": "≕",
	"eqsim": "≂",
	"eqslantgtr": "⪖",
	"eqslantless": "⪕",
	"Equal": "⩵",
	"equals": "=",
	"EqualTilde": "≂",
	"equest": "≟",
	"Equilibrium": "⇌",
	"equiv": "≡",
	"equivDD": "⩸",
	"eqvparsl": "⧥",
	"erarr": "⥱",
	"erDot": "≓",
	"escr": "ℯ",
	"Escr": "ℰ",
	"esdot": "≐",
	"Esim": "⩳",
	"esim": "≂",
	"Eta": "Η",
	"eta": "η",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"euro": "€",
	"excl": "!",
	"exist": "∃",
	"Exists": "∃",
	"expectation": "ℰ",
	"exponentiale": "ⅇ",
	"ExponentialE": "ⅇ",
	"fallingdotseq": "≒",
	"Fcy": "Ф",
	"fcy": "ф",
	"female": "♀",
	"ffilig": "ﬃ",
	"fflig": "ﬀ",
	"ffllig": "ﬄ",
	"Ffr": "𝔉",
	"ffr": "𝔣",
	"filig": "ﬁ",
	"FilledSmallSquare": "◼",
	"FilledVerySmallSquare": "▪",
	"fjlig": "fj",
	"flat": "♭",
	"fllig": "ﬂ",
	"fltns": "▱",
	"fnof": "ƒ",
	"Fopf": "𝔽",
	"fopf": "𝕗",
	"forall": "∀",
	"ForAll": "∀",
	"fork": "⋔",
	"forkv": "⫙",
	"Fouriertrf": "ℱ",
	"fpartint": "⨍",
	"frac12": "½",
	"frac13": "⅓",
	"frac14": "¼",
	"frac15": "⅕",
	"frac16": "⅙",
	"frac18": "⅛",
	"frac23": "⅔",
	"frac25": "⅖",
	"frac34": "¾",
	"frac35": "⅗",
	"frac38": "⅜",
	"frac45": "⅘",
	"frac56": "⅚",
	"frac58": "⅝",
	"frac78": "⅞",
	"frasl": "⁄",
	"frown": "⌢",
	"fscr": "𝒻",
	"Fscr": "ℱ",
	"gacute": "ǵ",
	"Gamma": "Γ",
	"gamma": "γ",
	"Gammad": "Ϝ",
	"gammad": "ϝ",
	"gap": "⪆",
	"Gbreve": "Ğ",
	"gbreve": "ğ",
	"Gcedil": "Ģ",
	"Gcirc": "Ĝ",
	"gcirc": "ĝ",
	"Gcy": "Г",
	"gcy": "г",
	"Gdot": "Ġ",
	"gdot": "ġ",
	"ge": "≥",
	"gE": "≧",
	"gEl": "⪌",
	"gel": "⋛",
	"geq": "≥",
	"geqq": "≧",
	"geqslant": "⩾",
	"gescc": "⪩",
	"ges": "⩾",
	"gesdot": "⪀",
	"gesdoto": "⪂",
	"gesdotol": "⪄",
	"gesl": "⋛︀",
	"gesles": "⪔",
	"Gfr": "𝔊",
	"gfr": "𝔤",
	"gg": "≫",
	"Gg": "⋙",
	"ggg": "⋙",
	"gimel": "ℷ",
	"GJcy": "Ѓ",
	"gjcy": "ѓ",
	"gla": "⪥",
	"gl": "≷",
	"glE": "⪒",
	"glj": "⪤",
	"gnap": "⪊",
	"gnapprox": "⪊",
	"gne": "⪈",
	"gnE": "≩",
	"gneq": "⪈",
	"gneqq": "≩",
	"gnsim": "⋧",
	"Gopf": "𝔾",
	"gopf": "𝕘",
	"grave": "`",
	"GreaterEqual": "≥",
	"GreaterEqualLess": "⋛",
	"GreaterFullEqual": "≧",
	"GreaterGreater": "⪢",
	"GreaterLess": "≷",
	"GreaterSlantEqual": "⩾",
	"GreaterTilde": "≳",
	"Gscr": "𝒢",
	"gscr": "ℊ",
	"gsim": "≳",
	"gsime": "⪎",
	"gsiml": "⪐",
	"gtcc": "⪧",
	"gtcir": "⩺",
	"gt": ">",
	"GT": ">",
	"Gt": "≫",
	"gtdot": "⋗",
	"gtlPar": "⦕",
	"gtquest": "⩼",
	"gtrapprox": "⪆",
	"gtrarr": "⥸",
	"gtrdot": "⋗",
	"gtreqless": "⋛",
	"gtreqqless": "⪌",
	"gtrless": "≷",
	"gtrsim": "≳",
	"gvertneqq": "≩︀",
	"gvnE": "≩︀",
	"Hacek": "ˇ",
	"hairsp": " ",
	"half": "½",
	"hamilt": "ℋ",
	"HARDcy": "Ъ",
	"hardcy": "ъ",
	"harrcir": "⥈",
	"harr": "↔",
	"hArr": "⇔",
	"harrw": "↭",
	"Hat": "^",
	"hbar": "ℏ",
	"Hcirc": "Ĥ",
	"hcirc": "ĥ",
	"hearts": "♥",
	"heartsuit": "♥",
	"hellip": "…",
	"hercon": "⊹",
	"hfr": "𝔥",
	"Hfr": "ℌ",
	"HilbertSpace": "ℋ",
	"hksearow": "⤥",
	"hkswarow": "⤦",
	"hoarr": "⇿",
	"homtht": "∻",
	"hookleftarrow": "↩",
	"hookrightarrow": "↪",
	"hopf": "𝕙",
	"Hopf": "ℍ",
	"horbar": "―",
	"HorizontalLine": "─",
	"hscr": "𝒽",
	"Hscr": "ℋ",
	"hslash": "ℏ",
	"Hstrok": "Ħ",
	"hstrok": "ħ",
	"HumpDownHump": "≎",
	"HumpEqual": "≏",
	"hybull": "⁃",
	"hyphen": "‐",
	"Iacute": "Í",
	"iacute": "í",
	"ic": "⁣",
	"Icirc": "Î",
	"icirc": "î",
	"Icy": "И",
	"icy": "и",
	"Idot": "İ",
	"IEcy": "Е",
	"iecy": "е",
	"iexcl": "¡",
	"iff": "⇔",
	"ifr": "𝔦",
	"Ifr": "ℑ",
	"Igrave": "Ì",
	"igrave": "ì",
	"ii": "ⅈ",
	"iiiint": "⨌",
	"iiint": "∭",
	"iinfin": "⧜",
	"iiota": "℩",
	"IJlig": "Ĳ",
	"ijlig": "ĳ",
	"Imacr": "Ī",
	"imacr": "ī",
	"image": "ℑ",
	"ImaginaryI": "ⅈ",
	"imagline": "ℐ",
	"imagpart": "ℑ",
	"imath": "ı",
	"Im": "ℑ",
	"imof": "⊷",
	"imped": "Ƶ",
	"Implies": "⇒",
	"incare": "℅",
	"in": "∈",
	"infin": "∞",
	"infintie": "⧝",
	"inodot": "ı",
	"intcal": "⊺",
	"int": "∫",
	"Int": "∬",
	"integers": "ℤ",
	"Integral": "∫",
	"intercal": "⊺",
	"Intersection": "⋂",
	"intlarhk": "⨗",
	"intprod": "⨼",
	"InvisibleComma": "⁣",
	"InvisibleTimes": "⁢",
	"IOcy": "Ё",
	"iocy": "ё",
	"Iogon": "Į",
	"iogon": "į",
	"Iopf": "𝕀",
	"iopf": "𝕚",
	"Iota": "Ι",
	"iota": "ι",
	"iprod": "⨼",
	"iquest": "¿",
	"iscr": "𝒾",
	"Iscr": "ℐ",
	"isin": "∈",
	"isindot": "⋵",
	"isinE": "⋹",
	"isins": "⋴",
	"isinsv": "⋳",
	"isinv": "∈",
	"it": "⁢",
	"Itilde": "Ĩ",
	"itilde": "ĩ",
	"Iukcy": "І",
	"iukcy": "і",
	"Iuml": "Ï",
	"iuml": "ï",
	"Jcirc": "Ĵ",
	"jcirc": "ĵ",
	"Jcy": "Й",
	"jcy": "й",
	"Jfr": "𝔍",
	"jfr": "𝔧",
	"jmath": "ȷ",
	"Jopf": "𝕁",
	"jopf": "𝕛",
	"Jscr": "𝒥",
	"jscr": "𝒿",
	"Jsercy": "Ј",
	"jsercy": "ј",
	"Jukcy": "Є",
	"jukcy": "є",
	"Kappa": "Κ",
	"kappa": "κ",
	"kappav": "ϰ",
	"Kcedil": "Ķ",
	"kcedil": "ķ",
	"Kcy": "К",
	"kcy": "к",
	"Kfr": "𝔎",
	"kfr": "𝔨",
	"kgreen": "ĸ",
	"KHcy": "Х",
	"khcy": "х",
	"KJcy": "Ќ",
	"kjcy": "ќ",
	"Kopf": "𝕂",
	"kopf": "𝕜",
	"Kscr": "𝒦",
	"kscr": "𝓀",
	"lAarr": "⇚",
	"Lacute": "Ĺ",
	"lacute": "ĺ",
	"laemptyv": "⦴",
	"lagran": "ℒ",
	"Lambda": "Λ",
	"lambda": "λ",
	"lang": "⟨",
	"Lang": "⟪",
	"langd": "⦑",
	"langle": "⟨",
	"lap": "⪅",
	"Laplacetrf": "ℒ",
	"laquo": "«",
	"larrb": "⇤",
	"larrbfs": "⤟",
	"larr": "←",
	"Larr": "↞",
	"lArr": "⇐",
	"larrfs": "⤝",
	"larrhk": "↩",
	"larrlp": "↫",
	"larrpl": "⤹",
	"larrsim": "⥳",
	"larrtl": "↢",
	"latail": "⤙",
	"lAtail": "⤛",
	"lat": "⪫",
	"late": "⪭",
	"lates": "⪭︀",
	"lbarr": "⤌",
	"lBarr": "⤎",
	"lbbrk": "❲",
	"lbrace": "{",
	"lbrack": "[",
	"lbrke": "⦋",
	"lbrksld": "⦏",
	"lbrkslu": "⦍",
	"Lcaron": "Ľ",
	"lcaron": "ľ",
	"Lcedil": "Ļ",
	"lcedil": "ļ",
	"lceil": "⌈",
	"lcub": "{",
	"Lcy": "Л",
	"lcy": "л",
	"ldca": "⤶",
	"ldquo": "“",
	"ldquor": "„",
	"ldrdhar": "⥧",
	"ldrushar": "⥋",
	"ldsh": "↲",
	"le": "≤",
	"lE": "≦",
	"LeftAngleBracket": "⟨",
	"LeftArrowBar": "⇤",
	"leftarrow": "←",
	"LeftArrow": "←",
	"Leftarrow": "⇐",
	"LeftArrowRightArrow": "⇆",
	"leftarrowtail": "↢",
	"LeftCeiling": "⌈",
	"LeftDoubleBracket": "⟦",
	"LeftDownTeeVector": "⥡",
	"LeftDownVectorBar": "⥙",
	"LeftDownVector": "⇃",
	"LeftFloor": "⌊",
	"leftharpoondown": "↽",
	"leftharpoonup": "↼",
	"leftleftarrows": "⇇",
	"leftrightarrow": "↔",
	"LeftRightArrow": "↔",
	"Leftrightarrow": "⇔",
	"leftrightarrows": "⇆",
	"leftrightharpoons": "⇋",
	"leftrightsquigarrow": "↭",
	"LeftRightVector": "⥎",
	"LeftTeeArrow": "↤",
	"LeftTee": "⊣",
	"LeftTeeVector": "⥚",
	"leftthreetimes": "⋋",
	"LeftTriangleBar": "⧏",
	"LeftTriangle": "⊲",
	"LeftTriangleEqual": "⊴",
	"LeftUpDownVector": "⥑",
	"LeftUpTeeVector": "⥠",
	"LeftUpVectorBar": "⥘",
	"LeftUpVector": "↿",
	"LeftVectorBar": "⥒",
	"LeftVector": "↼",
	"lEg": "⪋",
	"leg": "⋚",
	"leq": "≤",
	"leqq": "≦",
	"leqslant": "⩽",
	"lescc": "⪨",
	"les": "⩽",
	"lesdot": "⩿",
	"lesdoto": "⪁",
	"lesdotor": "⪃",
	"lesg": "⋚︀",
	"lesges": "⪓",
	"lessapprox": "⪅",
	"lessdot": "⋖",
	"lesseqgtr": "⋚",
	"lesseqqgtr": "⪋",
	"LessEqualGreater": "⋚",
	"LessFullEqual": "≦",
	"LessGreater": "≶",
	"lessgtr": "≶",
	"LessLess": "⪡",
	"lesssim": "≲",
	"LessSlantEqual": "⩽",
	"LessTilde": "≲",
	"lfisht": "⥼",
	"lfloor": "⌊",
	"Lfr": "𝔏",
	"lfr": "𝔩",
	"lg": "≶",
	"lgE": "⪑",
	"lHar": "⥢",
	"lhard": "↽",
	"lharu": "↼",
	"lharul": "⥪",
	"lhblk": "▄",
	"LJcy": "Љ",
	"ljcy": "љ",
	"llarr": "⇇",
	"ll": "≪",
	"Ll": "⋘",
	"llcorner": "⌞",
	"Lleftarrow": "⇚",
	"llhard": "⥫",
	"lltri": "◺",
	"Lmidot": "Ŀ",
	"lmidot": "ŀ",
	"lmoustache": "⎰",
	"lmoust": "⎰",
	"lnap": "⪉",
	"lnapprox": "⪉",
	"lne": "⪇",
	"lnE": "≨",
	"lneq": "⪇",
	"lneqq": "≨",
	"lnsim": "⋦",
	"loang": "⟬",
	"loarr": "⇽",
	"lobrk": "⟦",
	"longleftarrow": "⟵",
	"LongLeftArrow": "⟵",
	"Longleftarrow": "⟸",
	"longleftrightarrow": "⟷",
	"LongLeftRightArrow": "⟷",
	"Longleftrightarrow": "⟺",
	"longmapsto": "⟼",
	"longrightarrow": "⟶",
	"LongRightArrow": "⟶",
	"Longrightarrow": "⟹",
	"looparrowleft": "↫",
	"looparrowright": "↬",
	"lopar": "⦅",
	"Lopf": "𝕃",
	"lopf": "𝕝",
	"loplus": "⨭",
	"lotimes": "⨴",
	"lowast": "∗",
	"lowbar": "_",
	"LowerLeftArrow": "↙",
	"LowerRightArrow": "↘",
	"loz": "◊",
	"lozenge": "◊",
	"lozf": "⧫",
	"lpar": "(",
	"lparlt": "⦓",
	"lrarr": "⇆",
	"lrcorner": "⌟",
	"lrhar": "⇋",
	"lrhard": "⥭",
	"lrm": "‎",
	"lrtri": "⊿",
	"lsaquo": "‹",
	"lscr": "𝓁",
	"Lscr": "ℒ",
	"lsh": "↰",
	"Lsh": "↰",
	"lsim": "≲",
	"lsime": "⪍",
	"lsimg": "⪏",
	"lsqb": "[",
	"lsquo": "‘",
	"lsquor": "‚",
	"Lstrok": "Ł",
	"lstrok": "ł",
	"ltcc": "⪦",
	"ltcir": "⩹",
	"lt": "<",
	"LT": "<",
	"Lt": "≪",
	"ltdot": "⋖",
	"lthree": "⋋",
	"ltimes": "⋉",
	"ltlarr": "⥶",
	"ltquest": "⩻",
	"ltri": "◃",
	"ltrie": "⊴",
	"ltrif": "◂",
	"ltrPar": "⦖",
	"lurdshar": "⥊",
	"luruhar": "⥦",
	"lvertneqq": "≨︀",
	"lvnE": "≨︀",
	"macr": "¯",
	"male": "♂",
	"malt": "✠",
	"maltese": "✠",
	"Map": "⤅",
	"map": "↦",
	"mapsto": "↦",
	"mapstodown": "↧",
	"mapstoleft": "↤",
	"mapstoup": "↥",
	"marker": "▮",
	"mcomma": "⨩",
	"Mcy": "М",
	"mcy": "м",
	"mdash": "—",
	"mDDot": "∺",
	"measuredangle": "∡",
	"MediumSpace": " ",
	"Mellintrf": "ℳ",
	"Mfr": "𝔐",
	"mfr": "𝔪",
	"mho": "℧",
	"micro": "µ",
	"midast": "*",
	"midcir": "⫰",
	"mid": "∣",
	"middot": "·",
	"minusb": "⊟",
	"minus": "−",
	"minusd": "∸",
	"minusdu": "⨪",
	"MinusPlus": "∓",
	"mlcp": "⫛",
	"mldr": "…",
	"mnplus": "∓",
	"models": "⊧",
	"Mopf": "𝕄",
	"mopf": "𝕞",
	"mp": "∓",
	"mscr": "𝓂",
	"Mscr": "ℳ",
	"mstpos": "∾",
	"Mu": "Μ",
	"mu": "μ",
	"multimap": "⊸",
	"mumap": "⊸",
	"nabla": "∇",
	"Nacute": "Ń",
	"nacute": "ń",
	"nang": "∠⃒",
	"nap": "≉",
	"napE": "⩰̸",
	"napid": "≋̸",
	"napos": "ŉ",
	"napprox": "≉",
	"natural": "♮",
	"naturals": "ℕ",
	"natur": "♮",
	"nbsp": " ",
	"nbump": "≎̸",
	"nbumpe": "≏̸",
	"ncap": "⩃",
	"Ncaron": "Ň",
	"ncaron": "ň",
	"Ncedil": "Ņ",
	"ncedil": "ņ",
	"ncong": "≇",
	"ncongdot": "⩭̸",
	"ncup": "⩂",
	"Ncy": "Н",
	"ncy": "н",
	"ndash": "–",
	"nearhk": "⤤",
	"nearr": "↗",
	"neArr": "⇗",
	"nearrow": "↗",
	"ne": "≠",
	"nedot": "≐̸",
	"NegativeMediumSpace": "​",
	"NegativeThickSpace": "​",
	"NegativeThinSpace": "​",
	"NegativeVeryThinSpace": "​",
	"nequiv": "≢",
	"nesear": "⤨",
	"nesim": "≂̸",
	"NestedGreaterGreater": "≫",
	"NestedLessLess": "≪",
	"NewLine": "\n",
	"nexist": "∄",
	"nexists": "∄",
	"Nfr": "𝔑",
	"nfr": "𝔫",
	"ngE": "≧̸",
	"nge": "≱",
	"ngeq": "≱",
	"ngeqq": "≧̸",
	"ngeqslant": "⩾̸",
	"nges": "⩾̸",
	"nGg": "⋙̸",
	"ngsim": "≵",
	"nGt": "≫⃒",
	"ngt": "≯",
	"ngtr": "≯",
	"nGtv": "≫̸",
	"nharr": "↮",
	"nhArr": "⇎",
	"nhpar": "⫲",
	"ni": "∋",
	"nis": "⋼",
	"nisd": "⋺",
	"niv": "∋",
	"NJcy": "Њ",
	"njcy": "њ",
	"nlarr": "↚",
	"nlArr": "⇍",
	"nldr": "‥",
	"nlE": "≦̸",
	"nle": "≰",
	"nleftarrow": "↚",
	"nLeftarrow": "⇍",
	"nleftrightarrow": "↮",
	"nLeftrightarrow": "⇎",
	"nleq": "≰",
	"nleqq": "≦̸",
	"nleqslant": "⩽̸",
	"nles": "⩽̸",
	"nless": "≮",
	"nLl": "⋘̸",
	"nlsim": "≴",
	"nLt": "≪⃒",
	"nlt": "≮",
	"nltri": "⋪",
	"nltrie": "⋬",
	"nLtv": "≪̸",
	"nmid": "∤",
	"NoBreak": "⁠",
	"NonBreakingSpace": " ",
	"nopf": "𝕟",
	"Nopf": "ℕ",
	"Not": "⫬",
	"not": "¬",
	"NotCongruent": "≢",
	"NotCupCap": "≭",
	"NotDoubleVerticalBar": "∦",
	"NotElement": "∉",
	"NotEqual": "≠",
	"NotEqualTilde": "≂̸",
	"NotExists": "∄",
	"NotGreater": "≯",
	"NotGreaterEqual": "≱",
	"NotGreaterFullEqual": "≧̸",
	"NotGreaterGreater": "≫̸",
	"NotGreaterLess": "≹",
	"NotGreaterSlantEqual": "⩾̸",
	"NotGreaterTilde": "≵",
	"NotHumpDownHump": "≎̸",
	"NotHumpEqual": "≏̸",
	"notin": "∉",
	"notindot": "⋵̸",
	"notinE": "⋹̸",
	"notinva": "∉",
	"notinvb": "⋷",
	"notinvc": "⋶",
	"NotLeftTriangleBar": "⧏̸",
	"NotLeftTriangle": "⋪",
	"NotLeftTriangleEqual": "⋬",
	"NotLess": "≮",
	"NotLessEqual": "≰",
	"NotLessGreater": "≸",
	"NotLessLess": "≪̸",
	"NotLessSlantEqual": "⩽̸",
	"NotLessTilde": "≴",
	"NotNestedGreaterGreater": "⪢̸",
	"NotNestedLessLess": "⪡̸",
	"notni": "∌",
	"notniva": "∌",
	"notnivb": "⋾",
	"notnivc": "⋽",
	"NotPrecedes": "⊀",
	"NotPrecedesEqual": "⪯̸",
	"NotPrecedesSlantEqual": "⋠",
	"NotReverseElement": "∌",
	"NotRightTriangleBar": "⧐̸",
	"NotRightTriangle": "⋫",
	"NotRightTriangleEqual": "⋭",
	"NotSquareSubset": "⊏̸",
	"NotSquareSubsetEqual": "⋢",
	"NotSquareSuperset": "⊐̸",
	"NotSquareSupersetEqual": "⋣",
	"NotSubset": "⊂⃒",
	"NotSubsetEqual": "⊈",
	"NotSucceeds": "⊁",
	"NotSucceedsEqual": "⪰̸",
	"NotSucceedsSlantEqual": "⋡",
	"NotSucceedsTilde": "≿̸",
	"NotSuperset": "⊃⃒",
	"NotSupersetEqual": "⊉",
	"NotTilde": "≁",
	"NotTildeEqual": "≄",
	"NotTildeFullEqual": "≇",
	"NotTildeTilde": "≉",
	"NotVerticalBar": "∤",
	"nparallel": "∦",
	"npar": "∦",
	"nparsl": "⫽⃥",
	"npart": "∂̸",
	"npolint": "⨔",
	"npr": "⊀",
	"nprcue": "⋠",
	"nprec": "⊀",
	"npreceq": "⪯̸",
	"npre": "⪯̸",
	"nrarrc": "⤳̸",
	"nrarr": "↛",
	"nrArr": "⇏",
	"nrarrw": "↝̸",
	"nrightarrow": "↛",
	"nRightarrow": "⇏",
	"nrtri": "⋫",
	"nrtrie": "⋭",
	"nsc": "⊁",
	"nsccue": "⋡",
	"nsce": "⪰̸",
	"Nscr": "𝒩",
	"nscr": "𝓃",
	"nshortmid": "∤",
	"nshortparallel": "∦",
	"nsim": "≁",
	"nsime": "≄",
	"nsimeq": "≄",
	"nsmid": "∤",
	"nspar": "∦",
	"nsqsube": "⋢",
	"nsqsupe": "⋣",
	"nsub": "⊄",
	"nsubE": "⫅̸",
	"nsube": "⊈",
	"nsubset": "⊂⃒",
	"nsubseteq": "⊈",
	"nsubseteqq": "⫅̸",
	"nsucc": "⊁",
	"nsucceq": "⪰̸",
	"nsup": "⊅",
	"nsupE": "⫆̸",
	"nsupe": "⊉",
	"nsupset": "⊃⃒",
	"nsupseteq": "⊉",
	"nsupseteqq": "⫆̸",
	"ntgl": "≹",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"ntlg": "≸",
	"ntriangleleft": "⋪",
	"ntrianglelefteq": "⋬",
	"ntriangleright": "⋫",
	"ntrianglerighteq": "⋭",
	"Nu": "Ν",
	"nu": "ν",
	"num": "#",
	"numero": "№",
	"numsp": " ",
	"nvap": "≍⃒",
	"nvdash": "⊬",
	"nvDash": "⊭",
	"nVdash": "⊮",
	"nVDash": "⊯",
	"nvge": "≥⃒",
	"nvgt": ">⃒",
	"nvHarr": "⤄",
	"nvinfin": "⧞",
	"nvlArr": "⤂",
	"nvle": "≤⃒",
	"nvlt": "<⃒",
	"nvltrie": "⊴⃒",
	"nvrArr": "⤃",
	"nvrtrie": "⊵⃒",
	"nvsim": "∼⃒",
	"nwarhk": "⤣",
	"nwarr": "↖",
	"nwArr": "⇖",
	"nwarrow": "↖",
	"nwnear": "⤧",
	"Oacute": "Ó",
	"oacute": "ó",
	"oast": "⊛",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"ocir": "⊚",
	"Ocy": "О",
	"ocy": "о",
	"odash": "⊝",
	"Odblac": "Ő",
	"odblac": "ő",
	"odiv": "⨸",
	"odot": "⊙",
	"odsold": "⦼",
	"OElig": "Œ",
	"oelig": "œ",
	"ofcir": "⦿",
	"Ofr": "𝔒",
	"ofr": "𝔬",
	"ogon": "˛",
	"Ograve": "Ò",
	"ograve": "ò",
	"ogt": "⧁",
	"ohbar": "⦵",
	"ohm": "Ω",
	"oint": "∮",
	"olarr": "↺",
	"olcir": "⦾",
	"olcross": "⦻",
	"oline": "‾",
	"olt": "⧀",
	"Omacr": "Ō",
	"omacr": "ō",
	"Omega": "Ω",
	"omega": "ω",
	"Omicron": "Ο",
	"omicron": "ο",
	"omid": "⦶",
	"ominus": "⊖",
	"Oopf": "𝕆",
	"oopf": "𝕠",
	"opar": "⦷",
	"OpenCurlyDoubleQuote": "“",
	"OpenCurlyQuote": "‘",
	"operp": "⦹",
	"oplus": "⊕",
	"orarr": "↻",
	"Or": "⩔",
	"or": "∨",
	"ord": "⩝",
	"order": "ℴ",
	"orderof": "ℴ",
	"ordf": "ª",
	"ordm": "º",
	"origof": "⊶",
	"oror": "⩖",
	"orslope": "⩗",
	"orv": "⩛",
	"oS": "Ⓢ",
	"Oscr": "𝒪",
	"oscr": "ℴ",
	"Oslash": "Ø",
	"oslash": "ø",
	"osol": "⊘",
	"Otilde": "Õ",
	"otilde": "õ",
	"otimesas": "⨶",
	"Otimes": "⨷",
	"otimes": "⊗",
	"Ouml": "Ö",
	"ouml": "ö",
	"ovbar": "⌽",
	"OverBar": "‾",
	"OverBrace": "⏞",
	"OverBracket": "⎴",
	"OverParenthesis": "⏜",
	"para": "¶",
	"parallel": "∥",
	"par": "∥",
	"parsim": "⫳",
	"parsl": "⫽",
	"part": "∂",
	"PartialD": "∂",
	"Pcy": "П",
	"pcy": "п",
	"percnt": "%",
	"period": ".",
	"permil": "‰",
	"perp": "⊥",
	"pertenk": "‱",
	"Pfr": "𝔓",
	"pfr": "𝔭",
	"Phi": "Φ",
	"phi": "φ",
	"phiv": "ϕ",
	"phmmat": "ℳ",
	"phone": "☎",
	"Pi": "Π",
	"pi": "π",
	"pitchfork": "⋔",
	"piv": "ϖ",
	"planck": "ℏ",
	"planckh": "ℎ",
	"plankv": "ℏ",
	"plusacir": "⨣",
	"plusb": "⊞",
	"pluscir": "⨢",
	"plus": "+",
	"plusdo": "∔",
	"plusdu": "⨥",
	"pluse": "⩲",
	"PlusMinus": "±",
	"plusmn": "±",
	"plussim": "⨦",
	"plustwo": "⨧",
	"pm": "±",
	"Poincareplane": "ℌ",
	"pointint": "⨕",
	"popf": "𝕡",
	"Popf": "ℙ",
	"pound": "£",
	"prap": "⪷",
	"Pr": "⪻",
	"pr": "≺",
	"prcue": "≼",
	"precapprox": "⪷",
	"prec": "≺",
	"preccurlyeq": "≼",
	"Precedes": "≺",
	"PrecedesEqual": "⪯",
	"PrecedesSlantEqual": "≼",
	"PrecedesTilde": "≾",
	"preceq": "⪯",
	"precnapprox": "⪹",
	"precneqq": "⪵",
	"precnsim": "⋨",
	"pre": "⪯",
	"prE": "⪳",
	"precsim": "≾",
	"prime": "′",
	"Prime": "″",
	"primes": "ℙ",
	"prnap": "⪹",
	"prnE": "⪵",
	"prnsim": "⋨",
	"prod": "∏",
	"Product": "∏",
	"profalar": "⌮",
	"profline": "⌒",
	"profsurf": "⌓",
	"prop": "∝",
	"Proportional": "∝",
	"Proportion": "∷",
	"propto": "∝",
	"prsim": "≾",
	"prurel": "⊰",
	"Pscr": "𝒫",
	"pscr": "𝓅",
	"Psi": "Ψ",
	"psi": "ψ",
	"puncsp": " ",
	"Qfr": "𝔔",
	"qfr": "𝔮",
	"qint": "⨌",
	"qopf": "𝕢",
	"Qopf": "ℚ",
	"qprime": "⁗",
	"Qscr": "𝒬",
	"qscr": "𝓆",
	"quaternions": "ℍ",
	"quatint": "⨖",
	"quest": "?",
	"questeq": "≟",
	"quot": "\"",
	"QUOT": "\"",
	"rAarr": "⇛",
	"race": "∽̱",
	"Racute": "Ŕ",
	"racute": "ŕ",
	"radic": "√",
	"raemptyv": "⦳",
	"rang": "⟩",
	"Rang": "⟫",
	"rangd": "⦒",
	"range": "⦥",
	"rangle": "⟩",
	"raquo": "»",
	"rarrap": "⥵",
	"rarrb": "⇥",
	"rarrbfs": "⤠",
	"rarrc": "⤳",
	"rarr": "→",
	"Rarr": "↠",
	"rArr": "⇒",
	"rarrfs": "⤞",
	"rarrhk": "↪",
	"rarrlp": "↬",
	"rarrpl": "⥅",
	"rarrsim": "⥴",
	"Rarrtl": "⤖",
	"rarrtl": "↣",
	"rarrw": "↝",
	"ratail": "⤚",
	"rAtail": "⤜",
	"ratio": "∶",
	"rationals": "ℚ",
	"rbarr": "⤍",
	"rBarr": "⤏",
	"RBarr": "⤐",
	"rbbrk": "❳",
	"rbrace": "}",
	"rbrack": "]",
	"rbrke": "⦌",
	"rbrksld": "⦎",
	"rbrkslu": "⦐",
	"Rcaron": "Ř",
	"rcaron": "ř",
	"Rcedil": "Ŗ",
	"rcedil": "ŗ",
	"rceil": "⌉",
	"rcub": "}",
	"Rcy": "Р",
	"rcy": "р",
	"rdca": "⤷",
	"rdldhar": "⥩",
	"rdquo": "”",
	"rdquor": "”",
	"rdsh": "↳",
	"real": "ℜ",
	"realine": "ℛ",
	"realpart": "ℜ",
	"reals": "ℝ",
	"Re": "ℜ",
	"rect": "▭",
	"reg": "®",
	"REG": "®",
	"ReverseElement": "∋",
	"ReverseEquilibrium": "⇋",
	"ReverseUpEquilibrium": "⥯",
	"rfisht": "⥽",
	"rfloor": "⌋",
	"rfr": "𝔯",
	"Rfr": "ℜ",
	"rHar": "⥤",
	"rhard": "⇁",
	"rharu": "⇀",
	"rharul": "⥬",
	"Rho": "Ρ",
	"rho": "ρ",
	"rhov": "ϱ",
	"RightAngleBracket": "⟩",
	"RightArrowBar": "⇥",
	"rightarrow": "→",
	"RightArrow": "→",
	"Rightarrow": "⇒",
	"RightArrowLeftArrow": "⇄",
	"rightarrowtail": "↣",
	"RightCeiling": "⌉",
	"RightDoubleBracket": "⟧",
	"RightDownTeeVector": "⥝",
	"RightDownVectorBar": "⥕",
	"RightDownVector": "⇂",
	"RightFloor": "⌋",
	"rightharpoondown": "⇁",
	"rightharpoonup": "⇀",
	"rightleftarrows": "⇄",
	"rightleftharpoons": "⇌",
	"rightrightarrows": "⇉",
	"rightsquigarrow": "↝",
	"RightTeeArrow": "↦",
	"RightTee": "⊢",
	"RightTeeVector": "⥛",
	"rightthreetimes": "⋌",
	"RightTriangleBar": "⧐",
	"RightTriangle": "⊳",
	"RightTriangleEqual": "⊵",
	"RightUpDownVector": "⥏",
	"RightUpTeeVector": "⥜",
	"RightUpVectorBar": "⥔",
	"RightUpVector": "↾",
	"RightVectorBar": "⥓",
	"RightVector": "⇀",
	"ring": "˚",
	"risingdotseq": "≓",
	"rlarr": "⇄",
	"rlhar": "⇌",
	"rlm": "‏",
	"rmoustache": "⎱",
	"rmoust": "⎱",
	"rnmid": "⫮",
	"roang": "⟭",
	"roarr": "⇾",
	"robrk": "⟧",
	"ropar": "⦆",
	"ropf": "𝕣",
	"Ropf": "ℝ",
	"roplus": "⨮",
	"rotimes": "⨵",
	"RoundImplies": "⥰",
	"rpar": ")",
	"rpargt": "⦔",
	"rppolint": "⨒",
	"rrarr": "⇉",
	"Rrightarrow": "⇛",
	"rsaquo": "›",
	"rscr": "𝓇",
	"Rscr": "ℛ",
	"rsh": "↱",
	"Rsh": "↱",
	"rsqb": "]",
	"rsquo": "’",
	"rsquor": "’",
	"rthree": "⋌",
	"rtimes": "⋊",
	"rtri": "▹",
	"rtrie": "⊵",
	"rtrif": "▸",
	"rtriltri": "⧎",
	"RuleDelayed": "⧴",
	"ruluhar": "⥨",
	"rx": "℞",
	"Sacute": "Ś",
	"sacute": "ś",
	"sbquo": "‚",
	"scap": "⪸",
	"Scaron": "Š",
	"scaron": "š",
	"Sc": "⪼",
	"sc": "≻",
	"sccue": "≽",
	"sce": "⪰",
	"scE": "⪴",
	"Scedil": "Ş",
	"scedil": "ş",
	"Scirc": "Ŝ",
	"scirc": "ŝ",
	"scnap": "⪺",
	"scnE": "⪶",
	"scnsim": "⋩",
	"scpolint": "⨓",
	"scsim": "≿",
	"Scy": "С",
	"scy": "с",
	"sdotb": "⊡",
	"sdot": "⋅",
	"sdote": "⩦",
	"searhk": "⤥",
	"searr": "↘",
	"seArr": "⇘",
	"searrow": "↘",
	"sect": "§",
	"semi": ";",
	"seswar": "⤩",
	"setminus": "∖",
	"setmn": "∖",
	"sext": "✶",
	"Sfr": "𝔖",
	"sfr": "𝔰",
	"sfrown": "⌢",
	"sharp": "♯",
	"SHCHcy": "Щ",
	"shchcy": "щ",
	"SHcy": "Ш",
	"shcy": "ш",
	"ShortDownArrow": "↓",
	"ShortLeftArrow": "←",
	"shortmid": "∣",
	"shortparallel": "∥",
	"ShortRightArrow": "→",
	"ShortUpArrow": "↑",
	"shy": "­",
	"Sigma": "Σ",
	"sigma": "σ",
	"sigmaf": "ς",
	"sigmav": "ς",
	"sim": "∼",
	"simdot": "⩪",
	"sime": "≃",
	"simeq": "≃",
	"simg": "⪞",
	"simgE": "⪠",
	"siml": "⪝",
	"simlE": "⪟",
	"simne": "≆",
	"simplus": "⨤",
	"simrarr": "⥲",
	"slarr": "←",
	"SmallCircle": "∘",
	"smallsetminus": "∖",
	"smashp": "⨳",
	"smeparsl": "⧤",
	"smid": "∣",
	"smile": "⌣",
	"smt": "⪪",
	"smte": "⪬",
	"smtes": "⪬︀",
	"SOFTcy": "Ь",
	"softcy": "ь",
	"solbar": "⌿",
	"solb": "⧄",
	"sol": "/",
	"Sopf": "𝕊",
	"sopf": "𝕤",
	"spades": "♠",
	"spadesuit": "♠",
	"spar": "∥",
	"sqcap": "⊓",
	"sqcaps": "⊓︀",
	"sqcup": "⊔",
	"sqcups": "⊔︀",
	"Sqrt": "√",
	"sqsub": "⊏",
	"sqsube": "⊑",
	"sqsubset": "⊏",
	"sqsubseteq": "⊑",
	"sqsup": "⊐",
	"sqsupe": "⊒",
	"sqsupset": "⊐",
	"sqsupseteq": "⊒",
	"square": "□",
	"Square": "□",
	"SquareIntersection": "⊓",
	"SquareSubset": "⊏",
	"SquareSubsetEqual": "⊑",
	"SquareSuperset": "⊐",
	"SquareSupersetEqual": "⊒",
	"SquareUnion": "⊔",
	"squarf": "▪",
	"squ": "□",
	"squf": "▪",
	"srarr": "→",
	"Sscr": "𝒮",
	"sscr": "𝓈",
	"ssetmn": "∖",
	"ssmile": "⌣",
	"sstarf": "⋆",
	"Star": "⋆",
	"star": "☆",
	"starf": "★",
	"straightepsilon": "ϵ",
	"straightphi": "ϕ",
	"strns": "¯",
	"sub": "⊂",
	"Sub": "⋐",
	"subdot": "⪽",
	"subE": "⫅",
	"sube": "⊆",
	"subedot": "⫃",
	"submult": "⫁",
	"subnE": "⫋",
	"subne": "⊊",
	"subplus": "⪿",
	"subrarr": "⥹",
	"subset": "⊂",
	"Subset": "⋐",
	"subseteq": "⊆",
	"subseteqq": "⫅",
	"SubsetEqual": "⊆",
	"subsetneq": "⊊",
	"subsetneqq": "⫋",
	"subsim": "⫇",
	"subsub": "⫕",
	"subsup": "⫓",
	"succapprox": "⪸",
	"succ": "≻",
	"succcurlyeq": "≽",
	"Succeeds": "≻",
	"SucceedsEqual": "⪰",
	"SucceedsSlantEqual": "≽",
	"SucceedsTilde": "≿",
	"succeq": "⪰",
	"succnapprox": "⪺",
	"succneqq": "⪶",
	"succnsim": "⋩",
	"succsim": "≿",
	"SuchThat": "∋",
	"sum": "∑",
	"Sum": "∑",
	"sung": "♪",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"sup": "⊃",
	"Sup": "⋑",
	"supdot": "⪾",
	"supdsub": "⫘",
	"supE": "⫆",
	"supe": "⊇",
	"supedot": "⫄",
	"Superset": "⊃",
	"SupersetEqual": "⊇",
	"suphsol": "⟉",
	"suphsub": "⫗",
	"suplarr": "⥻",
	"supmult": "⫂",
	"supnE": "⫌",
	"supne": "⊋",
	"supplus": "⫀",
	"supset": "⊃",
	"Supset": "⋑",
	"supseteq": "⊇",
	"supseteqq": "⫆",
	"supsetneq": "⊋",
	"supsetneqq": "⫌",
	"supsim": "⫈",
	"supsub": "⫔",
	"supsup": "⫖",
	"swarhk": "⤦",
	"swarr": "↙",
	"swArr": "⇙",
	"swarrow": "↙",
	"swnwar": "⤪",
	"szlig": "ß",
	"Tab": "\t",
	"target": "⌖",
	"Tau": "Τ",
	"tau": "τ",
	"tbrk": "⎴",
	"Tcaron": "Ť",
	"tcaron": "ť",
	"Tcedil": "Ţ",
	"tcedil": "ţ",
	"Tcy": "Т",
	"tcy": "т",
	"tdot": "⃛",
	"telrec": "⌕",
	"Tfr": "𝔗",
	"tfr": "𝔱",
	"there4": "∴",
	"therefore": "∴",
	"Therefore": "∴",
	"Theta": "Θ",
	"theta": "θ",
	"thetasym": "ϑ",
	"thetav": "ϑ",
	"thickapprox": "≈",
	"thicksim": "∼",
	"ThickSpace": "  ",
	"ThinSpace": " ",
	"thinsp": " ",
	"thkap": "≈",
	"thksim": "∼",
	"THORN": "Þ",
	"thorn": "þ",
	"tilde": "˜",
	"Tilde": "∼",
	"TildeEqual": "≃",
	"TildeFullEqual": "≅",
	"TildeTilde": "≈",
	"timesbar": "⨱",
	"timesb": "⊠",
	"times": "×",
	"timesd": "⨰",
	"tint": "∭",
	"toea": "⤨",
	"topbot": "⌶",
	"topcir": "⫱",
	"top": "⊤",
	"Topf": "𝕋",
	"topf": "𝕥",
	"topfork": "⫚",
	"tosa": "⤩",
	"tprime": "‴",
	"trade": "™",
	"TRADE": "™",
	"triangle": "▵",
	"triangledown": "▿",
	"triangleleft": "◃",
	"trianglelefteq": "⊴",
	"triangleq": "≜",
	"triangleright": "▹",
	"trianglerighteq": "⊵",
	"tridot": "◬",
	"trie": "≜",
	"triminus": "⨺",
	"TripleDot": "⃛",
	"triplus": "⨹",
	"trisb": "⧍",
	"tritime": "⨻",
	"trpezium": "⏢",
	"Tscr": "𝒯",
	"tscr": "𝓉",
	"TScy": "Ц",
	"tscy": "ц",
	"TSHcy": "Ћ",
	"tshcy": "ћ",
	"Tstrok": "Ŧ",
	"tstrok": "ŧ",
	"twixt": "≬",
	"twoheadleftarrow": "↞",
	"twoheadrightarrow": "↠",
	"Uacute": "Ú",
	"uacute": "ú",
	"uarr": "↑",
	"Uarr": "↟",
	"uArr": "⇑",
	"Uarrocir": "⥉",
	"Ubrcy": "Ў",
	"ubrcy": "ў",
	"Ubreve": "Ŭ",
	"ubreve": "ŭ",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ucy": "У",
	"ucy": "у",
	"udarr": "⇅",
	"Udblac": "Ű",
	"udblac": "ű",
	"udhar": "⥮",
	"ufisht": "⥾",
	"Ufr": "𝔘",
	"ufr": "𝔲",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uHar": "⥣",
	"uharl": "↿",
	"uharr": "↾",
	"uhblk": "▀",
	"ulcorn": "⌜",
	"ulcorner": "⌜",
	"ulcrop": "⌏",
	"ultri": "◸",
	"Umacr": "Ū",
	"umacr": "ū",
	"uml": "¨",
	"UnderBar": "_",
	"UnderBrace": "⏟",
	"UnderBracket": "⎵",
	"UnderParenthesis": "⏝",
	"Union": "⋃",
	"UnionPlus": "⊎",
	"Uogon": "Ų",
	"uogon": "ų",
	"Uopf": "𝕌",
	"uopf": "𝕦",
	"UpArrowBar": "⤒",
	"uparrow": "↑",
	"UpArrow": "↑",
	"Uparrow": "⇑",
	"UpArrowDownArrow": "⇅",
	"updownarrow": "↕",
	"UpDownArrow": "↕",
	"Updownarrow": "⇕",
	"UpEquilibrium": "⥮",
	"upharpoonleft": "↿",
	"upharpoonright": "↾",
	"uplus": "⊎",
	"UpperLeftArrow": "↖",
	"UpperRightArrow": "↗",
	"upsi": "υ",
	"Upsi": "ϒ",
	"upsih": "ϒ",
	"Upsilon": "Υ",
	"upsilon": "υ",
	"UpTeeArrow": "↥",
	"UpTee": "⊥",
	"upuparrows": "⇈",
	"urcorn": "⌝",
	"urcorner": "⌝",
	"urcrop": "⌎",
	"Uring": "Ů",
	"uring": "ů",
	"urtri": "◹",
	"Uscr": "𝒰",
	"uscr": "𝓊",
	"utdot": "⋰",
	"Utilde": "Ũ",
	"utilde": "ũ",
	"utri": "▵",
	"utrif": "▴",
	"uuarr": "⇈",
	"Uuml": "Ü",
	"uuml": "ü",
	"uwangle": "⦧",
	"vangrt": "⦜",
	"varepsilon": "ϵ",
	"varkappa": "ϰ",
	"varnothing": "∅",
	"varphi": "ϕ",
	"varpi": "ϖ",
	"varpropto": "∝",
	"varr": "↕",
	"vArr": "⇕",
	"varrho": "ϱ",
	"varsigma": "ς",
	"varsubsetneq": "⊊︀",
	"varsubsetneqq": "⫋︀",
	"varsupsetneq": "⊋︀",
	"varsupsetneqq": "⫌︀",
	"vartheta": "ϑ",
	"vartriangleleft": "⊲",
	"vartriangleright": "⊳",
	"vBar": "⫨",
	"Vbar": "⫫",
	"vBarv": "⫩",
	"Vcy": "В",
	"vcy": "в",
	"vdash": "⊢",
	"vDash": "⊨",
	"Vdash": "⊩",
	"VDash": "⊫",
	"Vdashl": "⫦",
	"veebar": "⊻",
	"vee": "∨",
	"Vee": "⋁",
	"veeeq": "≚",
	"vellip": "⋮",
	"verbar": "|",
	"Verbar": "‖",
	"vert": "|",
	"Vert": "‖",
	"VerticalBar": "∣",
	"VerticalLine": "|",
	"VerticalSeparator": "❘",
	"VerticalTilde": "≀",
	"VeryThinSpace": " ",
	"Vfr": "𝔙",
	"vfr": "𝔳",
	"vltri": "⊲",
	"vnsub": "⊂⃒",
	"vnsup": "⊃⃒",
	"Vopf": "𝕍",
	"vopf": "𝕧",
	"vprop": "∝",
	"vrtri": "⊳",
	"Vscr": "𝒱",
	"vscr": "𝓋",
	"vsubnE": "⫋︀",
	"vsubne": "⊊︀",
	"vsupnE": "⫌︀",
	"vsupne": "⊋︀",
	"Vvdash": "⊪",
	"vzigzag": "⦚",
	"Wcirc": "Ŵ",
	"wcirc": "ŵ",
	"wedbar": "⩟",
	"wedge": "∧",
	"Wedge": "⋀",
	"wedgeq": "≙",
	"weierp": "℘",
	"Wfr": "𝔚",
	"wfr": "𝔴",
	"Wopf": "𝕎",
	"wopf": "𝕨",
	"wp": "℘",
	"wr": "≀",
	"wreath": "≀",
	"Wscr": "𝒲",
	"wscr": "𝓌",
	"xcap": "⋂",
	"xcirc": "◯",
	"xcup": "⋃",
	"xdtri": "▽",
	"Xfr": "𝔛",
	"xfr": "𝔵",
	"xharr": "⟷",
	"xhArr": "⟺",
	"Xi": "Ξ",
	"xi": "ξ",
	"xlarr": "⟵",
	"xlArr": "⟸",
	"xmap": "⟼",
	"xnis": "⋻",
	"xodot": "⨀",
	"Xopf": "𝕏",
	"xopf": "𝕩",
	"xoplus": "⨁",
	"xotime": "⨂",
	"xrarr": "⟶",
	"xrArr": "⟹",
	"Xscr": "𝒳",
	"xscr": "𝓍",
	"xsqcup": "⨆",
	"xuplus": "⨄",
	"xutri": "△",
	"xvee": "⋁",
	"xwedge": "⋀",
	"Yacute": "Ý",
	"yacute": "ý",
	"YAcy": "Я",
	"yacy": "я",
	"Ycirc": "Ŷ",
	"ycirc": "ŷ",
	"Ycy": "Ы",
	"ycy": "ы",
	"yen": "¥",
	"Yfr": "𝔜",
	"yfr": "𝔶",
	"YIcy": "Ї",
	"yicy": "ї",
	"Yopf": "𝕐",
	"yopf": "𝕪",
	"Yscr": "𝒴",
	"yscr": "𝓎",
	"YUcy": "Ю",
	"yucy": "ю",
	"yuml": "ÿ",
	"Yuml": "Ÿ",
	"Zacute": "Ź",
	"zacute": "ź",
	"Zcaron": "Ž",
	"zcaron": "ž",
	"Zcy": "З",
	"zcy": "з",
	"Zdot": "Ż",
	"zdot": "ż",
	"zeetrf": "ℨ",
	"ZeroWidthSpace": "​",
	"Zeta": "Ζ",
	"zeta": "ζ",
	"zfr": "𝔷",
	"Zfr": "ℨ",
	"ZHcy": "Ж",
	"zhcy": "ж",
	"zigrarr": "⇝",
	"zopf": "𝕫",
	"Zopf": "ℤ",
	"Zscr": "𝒵",
	"zscr": "𝓏",
	"zwj": "‍",
	"zwnj": "‌"
};

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};

/***/ }),
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(504)
  __webpack_require__(505)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(666),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-664a782c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(642),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-32910378",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(652),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e793ba7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(664),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61036800",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SignUp__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SignUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_SignUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '*',
    redirect: '/login'
  }, {
    path: '/',
    redirect: '/login'
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login___default.a
  }, {
    path: '/sign-up',
    name: 'SignUp',
    component: __WEBPACK_IMPORTED_MODULE_4__components_SignUp___default.a
  }, {
    path: '/hello',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a,
    meta: {
      requiresAuth: true
    }
  }]
});

router.beforeEach(function (to, from, next) {
  var currentUser = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().currentUser;
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });

  if (requiresAuth && !currentUser) next('login');else if (!requiresAuth && currentUser) next('hello');else next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(526)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(681),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app"
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_videos__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_videos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_videos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_podcasts__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_podcasts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_podcasts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_seo__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_seo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_seo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_categories__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_categories___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_categories__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widgets_gridX__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widgets_gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__widgets_gridX__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_branded__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_branded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_branded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_users__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_authors__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_authors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_authors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_tags__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_images__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_competitions__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_competitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_competitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_articleList__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_articleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_articleList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_createArticle__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_createArticle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_createArticle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_redirects__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_redirects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_redirects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_widgets__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_widgets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_widgets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config_json__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(4);
var firestore;























/* harmony default export */ __webpack_exports__["default"] = ({
  name: "hello",
  components: {
    users: __WEBPACK_IMPORTED_MODULE_10__pages_users___default.a,
    authors: __WEBPACK_IMPORTED_MODULE_11__pages_authors___default.a,
    videos: __WEBPACK_IMPORTED_MODULE_4__pages_videos___default.a,
    podcasts: __WEBPACK_IMPORTED_MODULE_5__pages_podcasts___default.a,
    branded: __WEBPACK_IMPORTED_MODULE_9__pages_branded___default.a,
    redirects: __WEBPACK_IMPORTED_MODULE_17__pages_redirects___default.a,
    seo: __WEBPACK_IMPORTED_MODULE_6__pages_seo___default.a,
    createArticle: __WEBPACK_IMPORTED_MODULE_16__pages_createArticle___default.a,
    widgets: __WEBPACK_IMPORTED_MODULE_18__pages_widgets___default.a,
    categories: __WEBPACK_IMPORTED_MODULE_7__pages_categories___default.a,
    gridX: __WEBPACK_IMPORTED_MODULE_8__widgets_gridX___default.a,
    images: __WEBPACK_IMPORTED_MODULE_13__pages_images___default.a,
    competitions: __WEBPACK_IMPORTED_MODULE_14__pages_competitions___default.a,
    articleList: __WEBPACK_IMPORTED_MODULE_15__pages_articleList___default.a,
    tags: __WEBPACK_IMPORTED_MODULE_12__pages_tags___default.a
  },
  data: function data() {
    var _ref;

    firestore = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();
    return _ref = {
      menuVisible: false,
      pages: [],
      editData: {},
      showModalCreate: {
        add: false,
        edit: false
      },
      permission: [],
      permissionRestrictions: {

        // Admin Permissions
        "users": ["admin"],
        "authors": ["admin"],

        // Podcast Permissions
        "podcastsSection": ["admin", "podcast"],
        "podcasts": ["admin", "podcast"],

        // Writer Permissions
        "articlesSection": ["admin", "editor", "writer"],
        "create-article": ["admin", "editor", "writer"],
        "articleList": ["admin", "editor", "writer"],
        "branded": ["admin", "branded"],
        "competitionsSection": ["admin", "editor", "writer"],
        "competitions": ["admin", "editor", "writer", "branded"],

        // Video Team Permissions
        "videosSection": ["admin", "video"],
        "videos": ["admin", "video"],

        // Editor Permissions
        "verticalsSection": ["admin", "editor", "writer"],
        "adminSection": ["admin", "editor", "writer"],
        "tags": ["admin", "editor"],
        "widgets": ["admin", "editor"],
        "redirects": ["admin", "editor"],
        "seo": ["admin", "editor"],
        "categories": ["admin", "editor"]

      },
      previewImage: "",
      showModalEdit: false,
      currentTab: "widgets",
      updateWidgetMessage: null
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "permission", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "showCreateNewPage", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "newWidgetButton", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "showTitle", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "infiniteScroll", false), _ref;
  },

  methods: {
    processPreviewImage: function processPreviewImage(event) {
      var _this = this;

      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          console.log(e);
          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this, "previewImage", e.target.result);
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this, "previewImage", "");
      }
    },

    permissionLookup: function permissionLookup(type) {
      var _this2 = this;

      var permissionApproved = false;
      console.log(type);
      this.permissionRestrictions[type].forEach(function (restrictions) {
        _this2.permission.forEach(function (userPermission) {
          if (restrictions.indexOf(userPermission) > -1) permissionApproved = true;
        });
      });
      return permissionApproved;
    },

    logout: function logout() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signOut().then(function () {
        _this3.$router.replace("login");
      });
    },

    refreshSlug: function refreshSlug() {
      var retVal = prompt("Enter the slug of the ARTICLE page to refresh. Do not use this for refreshing widget pages, it wont work. ", "enter slug here");
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_19__config_json___default.a.apiFrontend + "/refreshPage?slug=" + retVal + "&type=page&cachebuster=" + Date.now()).then(function (response) {
        alert(response.data);
      });
    }

  },
  mounted: function mounted() {
    var _this4 = this;

    firestore.collection("users").doc(__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid).get().then(function (snap) {
      var data = snap.data();
      console.log(data, data.permission);
      _this4.permission = data.permission;
      window.globalUser = data;
    });
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "login",
  data: function data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    signIn: function signIn() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithEmailAndPassword(this.email, this.password).then(function (user) {
        _this.$router.replace("hello");
      }, function (err) {
        alert("Oops. " + err.message);
      });
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ic_firebase_uploader__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ic_firebase_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ic_firebase_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ic_firebase_uploader_dist_ic_firebase_uploader_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import request from "axios";



__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var firestore;


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "ic-firebase-upload": __WEBPACK_IMPORTED_MODULE_3_ic_firebase_uploader___default.a
  },
  name: 'modal',
  firestore: function firestore() {
    return {};
  },

  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {
      newAuthor: {
        aboutAuthor: "",
        authorSeoDesc: "",
        authorSeoTitle: "",
        authorTagline: "",
        customAvatar: "",
        displayName: "",
        slug: ""
      },
      storage: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage()
    };
  },
  methods: {
    addNewAuthor: function addNewAuthor() {
      var _this = this;

      firestore.collection("authors").doc(this.newAuthor.slug).get().then(function (data) {
        if (data.exists) {
          //The slug exists. Ask them to update slug to new value.
          alert('The slug ' + _this.newAuthor.slug + ' already exists. Please modify the slug');
        } else {
          //Update Firestore
          firestore.collection("authors").doc(_this.newAuthor.slug).set(_this.newAuthor);
          alert("Author created");
          _this.newAuthor = {
            aboutAuthor: "",
            authorSeoDesc: "",
            authorSeoTitle: "",
            authorTagline: "",
            customAvatar: "",
            displayName: "",
            slug: ""
          };
          _this.$emit('update:modal');
        }
      });
    },

    fillSlug: function fillSlug() {
      var generateSlug = this.newAuthor.displayName.replace(/\s+/g, '-').toLowerCase();
      this.newAuthor.slug = generateSlug;
    },
    closeTheModal: function closeTheModal() {
      this.$emit('update:modal');
    },

    onUpload: function onUpload(e) {
      e.doUpload();
    },
    onDelete: function onDelete(e) {
      e.doDelete();
    },
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    onUploadedAuthorImage: function onUploadedAuthorImage(e) {
      var _this2 = this;

      e.getDownloadURL().then(function (url) {
        _this2.newAuthor.customAvatar = url;
      });
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var firestore;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  props: {
    passedObject: {
      type: Object
    }
  },
  firestore: function firestore() {
    return {};
  },

  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {};
  },
  methods: {
    deleteAuthor: function deleteAuthor() {
      firestore.collection("authors").doc(this.$props.passedObject['.key']).delete();
      alert("Author deleted");
      this.$emit('update:modal');
    },
    closeTheModal: function closeTheModal() {
      this.$emit('update:modal');
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ic_firebase_uploader__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ic_firebase_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ic_firebase_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ic_firebase_uploader_dist_ic_firebase_uploader_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var firestore;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  components: { "ic-firebase-upload": __WEBPACK_IMPORTED_MODULE_3_ic_firebase_uploader___default.a },
  props: {
    passedObject: {
      type: Object
    }
  },
  firestore: function firestore() {
    return {};
  },

  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {
      storage: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage()
    };
  },
  methods: {
    editAuthor: function editAuthor() {
      if (!this.passedObject.authorSeoTitle) {
        this.passedObject.authorSeoTitle = "";
      }

      if (!this.passedObject.authorSeoDesc) {
        this.passedObject.authorSeoDesc = "";
      }

      if (!this.passedObject.customAvatar) {
        this.passedObject.customAvatar = "";
      }
      firestore.collection("authors").doc(this.passedObject.slug).update({
        displayName: this.passedObject.displayName,
        aboutAuthor: this.passedObject.aboutAuthor,
        authorTagline: this.passedObject.authorTagline,
        authorSeoTitle: this.passedObject.authorSeoTitle,
        authorSeoDesc: this.passedObject.authorSeoDesc,
        customAvatar: this.passedObject.customAvatar
      });
      alert("User updated");
      this.$emit('update:modal');
    },
    closeTheModal: function closeTheModal() {
      this.$emit('update:modal');
    },

    onUpload: function onUpload(e) {
      e.doUpload();
    },
    onDelete: function onDelete(e) {
      e.doDelete();
    },
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    onUploadedAuthorImage: function onUploadedAuthorImage(e) {
      var _this = this;

      e.getDownloadURL().then(function (url) {
        _this.passedObject.customAvatar = url;
      });
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalPodcast_vue__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalPodcast_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ModalPodcast_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modalButton',
  props: {
    passedItem: {
      type: Object
    }
  },
  components: { ModalPodcast: __WEBPACK_IMPORTED_MODULE_1__ModalPodcast_vue___default.a },
  data: function data() {
    return {
      showPodModal: false,
      objectToPass: null
    };
  },
  methods: {
    showModalPodcast: function showModalPodcast(item) {
      this.showPodModal = true;
      this.objectToPass = this.$props.passedItem;
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalMultiAuthor__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalMultiAuthor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ModalMultiAuthor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalMultiArticle__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalMultiArticle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalMultiArticle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalSingleArticle__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalSingleArticle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalSingleArticle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "modal",
  props: ["podcasts", "storage", "videos", "currentWidget", "mode"],
  components: {
    ModalMultiAuthor: __WEBPACK_IMPORTED_MODULE_2__ModalMultiAuthor___default.a,
    ModalMultiArticle: __WEBPACK_IMPORTED_MODULE_3__ModalMultiArticle___default.a,
    ModalSingleArticle: __WEBPACK_IMPORTED_MODULE_4__ModalSingleArticle___default.a
  },
  data: function data() {
    return {
      newWidgetOrder: "",
      searchTerm: "",
      overrideImage: false,
      previewImage: "",
      searchResults: [],
      selectedItem: {
        slug: "",
        title: "",
        image: "",
        socialImage: "",
        created: "",
        authorName: "",
        authorImage: "",
        overrideImage: ""
      },
      videoPlaylist: {
        id: "",
        title: "",
        playlist: []
      },
      videoPlaylistPreview: [],
      podcastPlaylist: {
        id: "",
        title: "",
        url: "",
        slug: ""
      },
      podcastPlaylistPreview: [],
      uploaderKey: 1
    };
  },
  mounted: function mounted() {
    var client = algoliasearch("U5GL740LVM", "ee79df2ed46df0e29f0a0e05d9d2466f");
    this.algolia = client.initIndex("posts");
    if (this.currentWidget.type == "hero" && this.currentWidget.items) {
      this.selectedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.currentWidget.items[0]);
    }
  },
  methods: {
    updateAuthors: function updateAuthors() {
      if (this.newWidgetOrder) this.$emit('update', this.newWidgetOrder);else this.$emit('update', this.currentWidget.items);
    },
    reorder: function reorder(e) {
      this.newWidgetOrder = e;
      console.log(this.newWidgetOrder);
    },
    onSelected: function onSelected(e) {
      this.searchResults = 0;
      this.searchTerm = "";
      this.previewImage = this.selectedItem.image;
    },
    emitArticle: function emitArticle() {
      var obj = {
        postid: this.selectedItem.postid,
        title: this.selectedItem.title,
        image: this.selectedItem.image
      };
      if (this.selectedItem.overrideImage) {
        obj.image = this.selectedItem.overrideImage;
      }
      if (this.newWidgetOrder.length > 0) {
        obj.reorder = this.newWidgetOrder;
      }
      console.log(obj);
      if (this.mode.edit && this.newWidgetOrder.length < 1) {
        this.$emit("edit", obj);
      } else {
        this.$emit("create", obj);
      }
    },
    searchForTerm: function searchForTerm() {
      var _this = this;

      var query = this.searchTerm;
      this.algolia.search({
        query: query
      }).then(function (responses) {
        _this.searchResults = [];
        var searchResults = [];
        console.log(responses);
        responses.hits.forEach(function (hit) {
          if (searchResults.length < 5) {
            searchResults.push({
              postid: hit.objectID,
              slug: hit.slug,
              image: hit.image,
              title: hit.title,
              algoliaTitle: hit._highlightResult.title.value,
              content: hit._snippetResult.content.value
            });
          }
        });

        // To avoid DOM redraws repeatedly
        // Is this needed? Is Vue smart enough to not redraw when lots of pushes happen?
        _this.searchResults = searchResults;
      });
    },
    checkType: function checkType(type, check) {
      var podcastType = ["menu-podcasts", "listen", "all-podcasts", "podcast-carousel"];
      var authorType = ['author-carousel'];
      var articleType = ["curatedArticles", "hero", "top-stories", "vertical-article-block", "three-row-column", "grid-three", "grid-four", "horizontal-scroller"];
      var videoType = ["menu-video-playlists", "all-video-topics"];
      // Maybe move consts to data function
      if (check == "author" && authorType.includes(type)) {
        return true;
      } else if (check == "article" && articleType.includes(type)) {
        return true;
      } else if (check == "podcast" && podcastType.includes(type)) {
        return true;
      } else if (check == "video" && videoType.includes(type)) {
        return true;
      }
      return false;
    },
    restrictCharacters: function restrictCharacters(string) {
      if (string.length > 30) return string.substring(0, 30) + "...";
      return string;
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalAuthordelete_vue__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalAuthordelete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ModalAuthordelete_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modalDelauthor',
  props: {
    passedItem: {
      type: Object
    }
  },
  components: { ModalAuthordelete: __WEBPACK_IMPORTED_MODULE_1__ModalAuthordelete_vue___default.a },
  data: function data() {
    return {
      showAuthorDeleteModal: false,
      objectToPass: null
    };
  },
  methods: {
    showModalDeleteAuthor: function showModalDeleteAuthor() {
      this.showAuthorDeleteModal = true;
      this.objectToPass = this.$props.passedItem;
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalUserdelete_vue__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalUserdelete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ModalUserdelete_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modalDeluser',
  props: {
    passedItem: {
      type: Object
    }
  },
  components: { ModalUserdelete: __WEBPACK_IMPORTED_MODULE_1__ModalUserdelete_vue___default.a },
  data: function data() {
    return {
      showUserDeleteModal: false,
      objectToPass: null
    };
  },
  methods: {
    showModalDeleteUser: function showModalDeleteUser() {
      this.showUserDeleteModal = true;
      this.objectToPass = this.$props.passedItem;
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalAuthoredit_vue__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalAuthoredit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ModalAuthoredit_vue__);

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modalEditauthor',
  props: {
    passedItem: {
      type: Object
    }
  },
  components: { ModalAuthoredit: __WEBPACK_IMPORTED_MODULE_2__ModalAuthoredit_vue___default.a },
  data: function data() {
    return {
      showAuthorEditModal: false,
      objectToPass: null
    };
  },
  methods: {
    showModalEditAuthor: function showModalEditAuthor() {
      this.showAuthorEditModal = true;
      this.objectToPass = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$props.passedItem);
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalUseredit_vue__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalUseredit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ModalUseredit_vue__);

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modalEdituser',
  props: {
    passedItem: {
      type: Object
    }
  },
  components: { ModalUseredit: __WEBPACK_IMPORTED_MODULE_2__ModalUseredit_vue___default.a },
  data: function data() {
    return {
      showUserEditModal: false,
      objectToPass: null
    };
  },
  methods: {
    showModalEditUser: function showModalEditUser() {
      this.showUserEditModal = true;
      this.objectToPass = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$props.passedItem);
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_authorCarousel__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_authorCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_authorCarousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_latestStoryPreview__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_latestStoryPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__widgets_latestStoryPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_lifestylePreview__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_lifestylePreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_lifestylePreview__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["currentWidget", "selectedItem", "newWidgetOrder", "mode", "storage"],
  components: {
    authorCarousel: __WEBPACK_IMPORTED_MODULE_0__widgets_authorCarousel___default.a,
    latestStoryPreview: __WEBPACK_IMPORTED_MODULE_1__widgets_latestStoryPreview___default.a,
    lifestylePreview: __WEBPACK_IMPORTED_MODULE_2__widgets_lifestylePreview___default.a
  },
  mounted: function mounted() {
    if (this.mode.add && this.selectedItem.slug.length > 0) {
      // Only going to work if one child appears
      this.$children[0].newItem();
      this.mode.add = false;
      this.mode.edit = true;
    }
  },

  methods: {
    orderChange: function orderChange(e) {
      this.$emit("reorder", e);
    },
    addItem: function addItem() {
      this.mode.add = true;
    }
  },
  watch: {
    selectedItem: function selectedItem() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.selectedItem.slug.length > 0) {
          _this.$children[0].newItem();
          _this.mode.add = false;
          _this.mode.edit = true;
        }
      });
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_authorCarousel__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_authorCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_authorCarousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_latestStoryPreview__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_latestStoryPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__widgets_latestStoryPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_lifestylePreview__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_lifestylePreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_lifestylePreview__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["currentWidget", "selectedItem", "newWidgetOrder", "mode", "storage"],
  components: {
    authorCarousel: __WEBPACK_IMPORTED_MODULE_0__widgets_authorCarousel___default.a,
    latestStoryPreview: __WEBPACK_IMPORTED_MODULE_1__widgets_latestStoryPreview___default.a,
    lifestylePreview: __WEBPACK_IMPORTED_MODULE_2__widgets_lifestylePreview___default.a
  },
  mounted: function mounted() {
    if (this.mode.add && this.selectedItem.slug.length > 0) {
      // Only going to work if one child appears
      this.$children[0].newItem();
      this.mode.add = false;
      this.mode.edit = true;
    }
  },

  methods: {
    orderChange: function orderChange(e) {
      console.log(e);
      this.$emit("reorder", e);
    },
    addItem: function addItem() {
      this.mode.add = true;
    }
  },
  watch: {
    selectedItem: function selectedItem() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.selectedItem.slug.length > 0) {
          _this.$children[0].newItem();
          _this.mode.add = false;
          _this.mode.edit = true;
        }
      });
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var firestore;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  props: {
    passedObject: {
      type: Object
    }
  },
  components: {},
  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {};
  },
  methods: {
    saveEpisodeSeo: function saveEpisodeSeo() {
      firestore.collection("podcastEpisodes").doc(this.$props.passedObject['.key']).update({
        podSeoTitle: this.passedObject.podSeoTitle,
        podSeoDesc: this.passedObject.podSeoDesc
      });
      this.$emit('update:modal');
    },
    closeTheModal: function closeTheModal() {
      this.$emit('update:modal');
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ic_firebase_uploader__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ic_firebase_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ic_firebase_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ic_firebase_uploader_dist_ic_firebase_uploader_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_heroPreview__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_heroPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_heroPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["selectedItem", "previewImage", "storage", "mode"],
  components: {
    heroPreview: __WEBPACK_IMPORTED_MODULE_2__widgets_heroPreview___default.a,
    "ic-firebase-upload": __WEBPACK_IMPORTED_MODULE_0_ic_firebase_uploader___default.a
  },
  data: function data() {
    return {
      item: {}
    };
  },
  methods: {
    onUpload: function onUpload(e) {
      var _this = this;

      console.log("upload", e);
      e.doUpload();
      this.searchResults = 0;
      if (e.file) {
        console.log("if upload");
        var reader = new FileReader();
        reader.readAsDataURL(e.file);
        reader.onloadend = function () {
          console.log("reader callback");
          _this.$emit('input', reader.result);
        };
      }
    },
    onDelete: function onDelete(e) {
      console.log("delete", e);
      this.$refs.upload.$refs.loader.value = "";
      this.$emit('input', this.selectedItem.image);
      e.doDelete();
      this.uploaderKey += 1;
    },
    onUploaded: function onUploaded(e) {
      var _this2 = this;

      console.log("uploaded", e);
      e.getDownloadURL().then(function (url) {
        _this2.selectedItem.overrideImage = url;
      });
    },
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import request from "axios";



__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var firestore;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  // props: {
  //   passedObject: {
  //       type: Object
  //   }
  // },
  firestore: function firestore() {
    return {};
  },

  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {
      newUser: {
        admin: false,
        email: "",
        permission: []
      }
    };
  },
  methods: {
    addNewUser: function addNewUser() {
      firestore.collection("users").add(this.newUser);
      alert("User created");
      this.newUser = {
        admin: false,
        email: "",
        permission: []
      };
      this.$emit('update:modal');
    },
    closeTheModal: function closeTheModal() {
      this.$emit('update:modal');
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var firestore;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  props: {
    passedObject: {
      type: Object
    }
  },
  firestore: function firestore() {
    return {};
  },

  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {};
  },
  methods: {
    deleteUser: function deleteUser() {
      firestore.collection("users").doc(this.$props.passedObject['.key']).delete();
      alert("User deleted");
      this.$emit('update:modal');
    },
    closeTheModal: function closeTheModal() {
      this.$emit('update:modal');
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_firestore___default.a);
var firestore;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  },
  props: {
    passedObject: {
      type: Object
    }
  },
  firestore: function firestore() {
    return {};
  },

  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();
    return {
      authors: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.passedObject.defaultAuthor) {
      firestore.collection("authors").doc(this.passedObject.defaultAuthor).get().then(function (snap) {
        var data = snap.data();
        if (data) _this.authors = [data];
      });
    }
    if (!this.passedObject.permission) {
      this.passedObject.permission = [];
    }
  },
  methods: {
    getAuthors: function getAuthors(searchTerm) {
      this.authors = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!searchTerm) {
          resolve([]);
        } else {
          searchTerm = searchTerm.toLowerCase().replace(/\s/g, '-').replace(/[^a-z0-9\-]+/gi, '');
          var strlength = searchTerm.length;
          var strFrontCode = searchTerm.slice(0, strlength - 1);
          var strEndCode = searchTerm.slice(strlength - 1, searchTerm.length);

          var startcode = searchTerm;
          var endcode = strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);
          console.log(searchTerm);
          firestore.collection("authors").where('slug', '>=', startcode).where('slug', '<', endcode).limit(20).get().then(function (snap) {
            var data = snap.docs.map(function (documentSnapshot) {
              return documentSnapshot.data().slug;
            });
            console.log(data);
            resolve(data);
          });
        }
      });
    },
    editUser: function editUser() {
      firestore.collection("users").doc(this.$props.passedObject['.key']).update({
        permission: this.passedObject.permission,
        defaultAuthor: this.passedObject.defaultAuthor
      });
      alert("User updated");
      this.$emit('update:modal');
    },
    closeTheModal: function closeTheModal() {
      this.$emit('update:modal');
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'signUp',
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    signUp: function signUp() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().createUserWithEmailAndPassword(this.email, this.password).then(function (user) {
        _this.$router.replace('hello');
      }, function (err) {
        alert('Oops. ' + err.message);
      });
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_gridX__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_gridX__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_json__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_atoms_TagInput__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_atoms_TagInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_atoms_TagInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiselect__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modals_history_vue__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modals_history_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modals_history_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modals_articlePreview_vue__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modals_articlePreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__modals_articlePreview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modals_imageWorkflow_vue__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modals_imageWorkflow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__modals_imageWorkflow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__articleWidgets_Froala__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__articleWidgets_Froala___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__articleWidgets_Froala__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__articleWidgets_CodeEditor__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__articleWidgets_CodeEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__articleWidgets_CodeEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__articleWidgets_imageFullWidth__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__articleWidgets_imageFullWidth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__articleWidgets_imageFullWidth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__articleWidgets_videoFullWidth__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__articleWidgets_videoFullWidth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__articleWidgets_videoFullWidth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__articleWidgets_videoScroller__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__articleWidgets_videoScroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__articleWidgets_videoScroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__articleWidgets_imageDouble__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__articleWidgets_imageDouble___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__articleWidgets_imageDouble__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__articleWidgets_imageFeatured__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__articleWidgets_imageFeatured___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__articleWidgets_imageFeatured__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__articleWidgets_imageStandard__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__articleWidgets_imageStandard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__articleWidgets_imageStandard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__articleWidgets_imageCircle__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__articleWidgets_imageCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__articleWidgets_imageCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__articleWidgets_FeaturedQuote__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__articleWidgets_FeaturedQuote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__articleWidgets_FeaturedQuote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__articleWidgets_GooglePreview__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__articleWidgets_GooglePreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__articleWidgets_GooglePreview__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  TODO:
    Create post button pieces together html and creates a post object
      Implement Form render outputting HTML for the above
      Prevent slug collisions
    Save to posts database
      Save format for form builder / froala content
    Data validation
    View Results
      Preview of data in table (first 20 rows?)
        Ability to delete a row (test data)
      Export all data to CSV
*/

























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    gridX: __WEBPACK_IMPORTED_MODULE_5__common_gridX___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default.a,
    FroalaEditor: __WEBPACK_IMPORTED_MODULE_13__articleWidgets_Froala___default.a,
    CodeEditor: __WEBPACK_IMPORTED_MODULE_14__articleWidgets_CodeEditor___default.a,
    imageFullWidth: __WEBPACK_IMPORTED_MODULE_15__articleWidgets_imageFullWidth___default.a,
    videoFullWidth: __WEBPACK_IMPORTED_MODULE_16__articleWidgets_videoFullWidth___default.a,
    videoScroller: __WEBPACK_IMPORTED_MODULE_17__articleWidgets_videoScroller___default.a,
    imageDouble: __WEBPACK_IMPORTED_MODULE_18__articleWidgets_imageDouble___default.a,
    imageFeatured: __WEBPACK_IMPORTED_MODULE_19__articleWidgets_imageFeatured___default.a,
    imageStandard: __WEBPACK_IMPORTED_MODULE_20__articleWidgets_imageStandard___default.a,
    imageCircle: __WEBPACK_IMPORTED_MODULE_21__articleWidgets_imageCircle___default.a,
    FeaturedQuote: __WEBPACK_IMPORTED_MODULE_22__articleWidgets_FeaturedQuote___default.a,
    GooglePreview: __WEBPACK_IMPORTED_MODULE_23__articleWidgets_GooglePreview___default.a,
    ModalHistory: __WEBPACK_IMPORTED_MODULE_10__modals_history_vue___default.a,
    ModalArticlePreview: __WEBPACK_IMPORTED_MODULE_11__modals_articlePreview_vue___default.a,
    ModalImageWorkflow: __WEBPACK_IMPORTED_MODULE_12__modals_imageWorkflow_vue___default.a,
    TagInput: __WEBPACK_IMPORTED_MODULE_8__common_atoms_TagInput___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_9_vue_multiselect___default.a
  },
  props: [],
  data: function data() {
    var _ref;

    return _ref = {
      article: {
        sponsored_post_data: false,
        layout: "article-layout-default",
        widgets: [],
        meta: {
          title: "",
          description: ""
        }
      },
      results: [],
      authors: [],
      articleObject: false,
      articleKey: "",
      newPost: {
        layout: "article-layout-default",
        newPost: "draft",
        type: "post",
        tags: [],
        widgets: [],
        seoPhrase: "",
        status: "draft",
        slug: "",
        meta: {
          title: "",
          description: ""
        }
      },

      scorecard: [],
      storage: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage(),
      sourceFroala: null,
      imagesModalOpen: false,
      formBuilder: null,
      //article: false,
      currentTab: "post",
      showNewPost: false,
      autosaved: false,
      categoryChanged: false,
      newWidgetType: false,
      debounceSlug: false,
      checkSlugRandom: null,
      autosaver: null,
      showTags: true,
      slugValid: "",
      lastArticleData: {},
      changeCat: false,
      photopeaCallback: false,
      photopeaImageUrl: "",
      photopeaModalOpen: false,
      historyModalOpen: false,
      articlePreviewModalOpen: false,
      layouts: ["article-layout-default", "article-layout-evergreen", "article-layout-featured"],
      categories: [],
      tags: [],
      subCategories: null,
      showCategory: false
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showTags", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "cropRatio", "article"), _ref;
  },
  mounted: function mounted() {
    var _this = this;

    this.showCategory = false;
    this.showTags = false;
    this.tags = [];
    if (window.globalUser && !this.article.authorSlug) {
      this.article.authorSlug = window.globalUser.defaultAuthor;
    }

    __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("categories").get().then(function (querySnap) {
      querySnap.forEach(function (catSnap) {
        _this.categories.push(catSnap.id);
      });
      _this.showCategory = true;
    });
    __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("tags").get().then(function (querySnap) {
      querySnap.forEach(function (tagSnap) {
        _this.tags.push(tagSnap.id);
      });
      _this.showTags = true;
    });
  },
  destroyed: function destroyed() {
    clearInterval(this.autosaver);
    clearInterval(this.seoScorecardInterval);
  },
  // watch: {
  //   article: {
  //     handler: function() {

  //     },
  //     deep: true
  //   }
  // },
  methods: {
    loadArticle: function loadArticle(key) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("postContent").doc(key).get().then(function (doc) {
        var postData = doc.data();
        if (!postData) {
          alert("Article not found!");
          _this2.$emit("not-found");
          throw 1;
        } else {
          __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("autosaves").doc(key).get().then(function (doc) {
            var autosaveData = doc.data();
            console.log(autosaveData);
            console.log("vs");
            console.log(postData);
            if (autosaveData && autosaveData.lastAutosave && autosaveData.lastAutosave.timestamp > postData.lastUpdated) {
              _this2.autosaved = true;
              _this2.articleKey = key;
              _this2.article = autosaveData;
            } else {
              _this2.articleKey = key;
              _this2.article = postData;
            }
            _this2.lastArticleData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.article);
            _this2.initialiseArticle();
          });
        }
      });
    },
    createTableOfContents: function createTableOfContents() {
      var toc = [];
      var tocCount = 0;
      this.article.widgets.forEach(function (widget) {
        if (widget.type == "froala-editor") {
          console.log(widget.content);
          var ele = $("<div>" + widget.content + "</div>");
          ele.find("h2, h3").each(function (index) {
            console.log("found h2/h3", $(this));
            var id = "toc-pos-" + tocCount;
            tocCount++;
            $(this).attr("id", id);
            console.log($(this).prop('nodeName'));
            switch ($(this).prop('nodeName')) {
              case "H2":
                toc.push({
                  title: $(this).text(),
                  anchor: "#" + id,
                  subContents: []
                });
                break;
              case "H3":
                if (toc.length == 0) {
                  alert("The table of contents requires the first heading to be a h2, not a h3");
                  throw 1;
                }
                toc[toc.length - 1].subContents.push({
                  title: $(this).text(),
                  anchor: "#" + id
                });
                break;
            }
          });
          widget.content = ele.html();
        }
      });
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(this.article, "toc", toc);

      console.log(this.article);
    },
    changeImage: function changeImage(imageObject, item) {
      console.log(this.$refs['imageWorkflow']);
      console.log(imageObject, item);
      this.$refs['imageWorkflow'].process(imageObject.callback, item);
    },
    completeEditImage: function completeEditImage(imageUrl) {
      this.photopeaCallback(imageUrl);
    },
    changeWidgetsTab: function changeWidgetsTab(tab) {
      this.currentTab = tab;
    },
    openPreviewModal: function openPreviewModal() {
      var _this3 = this;

      if (!this.article.password) {
        this.article.password = Math.round(Math.random() * 99999999);
        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("posts").doc(this.articleKey).update({
          password: this.article.password
        });
        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("postContent").doc(this.articleKey).update({
          password: this.article.password
        }).then(function () {
          _this3.articlePreviewModalOpen = true;
        });
      } else {
        this.articlePreviewModalOpen = true;
      }
    },
    getAuthors: function getAuthors(searchTerm) {
      this.authors = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!searchTerm) {
          resolve([]);
        } else {
          searchTerm = searchTerm.toLowerCase().replace(/\s/g, '-').replace(/[^a-z0-9\-]+/gi, '');
          var strlength = searchTerm.length;
          var strFrontCode = searchTerm.slice(0, strlength - 1);
          var strEndCode = searchTerm.slice(strlength - 1, searchTerm.length);

          var startcode = searchTerm;
          var endcode = strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);
          console.log(startcode, endcode, searchTerm);
          __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("authors").where('slug', '>=', startcode).where('slug', '<', endcode).limit(20).get().then(function (snap) {
            var data = snap.docs.map(function (documentSnapshot) {
              return documentSnapshot.data().slug;
            });
            console.log(data);
            resolve(data);
          });
        }
      });
    },
    openTrends: function openTrends(trend) {
      window.open("https://trends.google.com/trends/explore?date=now%201-d&geo=AU&q=" + trend, '_blank');
    },
    toggleHistoryModal: function toggleHistoryModal() {
      this.historyModalOpen = !this.historyModalOpen;
    },
    toggleImagesModal: function toggleImagesModal(typeObject) {
      var _this4 = this;

      console.log("toggle 2");
      this.$refs['imageWorkflow'].process(function (image) {
        console.log(image.mobile);
        if (typeObject.type == 'social') {
          __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(_this4.article, "socialImage", image.mobile);
        } else if (typeObject.type == 'preview-article-layout-default' || typeObject.type == 'preview-article-layout-featured' || typeObject.type == 'preview-article-layout-evergreen') {
          __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(_this4.article, "image", image);
        } else if (typeObject.type == 'branded') {
          __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(_this4.article.sponsored_post_data, "brand_image_url", image.mobile);
        } else if (typeObject.callback) {
          typeObject.callback(image);
        }
      }, typeObject);
    },
    updateSubcategories: function updateSubcategories() {
      var _this5 = this;

      this.subCategories = null;
      console.log(this.article.parentCategory);
      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("categories").doc(this.article.parentCategory).get().then(function (docSnap) {
        var data = docSnap.data();
        console.log(data);
        var temp = [];
        data.subcategories.forEach(function (subcat) {
          temp.push(subcat.name);
        });

        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(_this5, "subCategories", temp);
      });
    },
    checkSlug: function checkSlug() {
      var _this6 = this;

      if (this.debounceSlug) clearTimeout(this.debounceSlug);
      this.slugValid = "searching";
      this.debounceSlug = setTimeout(function () {
        var localCheckSlugRandom = Math.random();
        _this6.checkSlugRandom = localCheckSlugRandom;
        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("posts").where("slug", "==", _this6.article.slug).get().then(function (querySnapshot) {
          if (localCheckSlugRandom != _this6.checkSlugRandom) return;
          if (!querySnapshot.empty) {
            var valid = true;
            querySnapshot.forEach(function (doc) {
              if (doc.id != _this6.articleKey) valid = false;
            });
            if (!valid) _this6.slugValid = "invalid";else _this6.slugValid = "valid";
          } else {
            _this6.slugValid = "valid";
          }
        });
      }, 500);
    },
    newImage: function newImage(imageData) {
      console.log("new image", imageData);;
      switch (imageData.type) {
        case "preview":
          __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(this.article, "image", imageData.url);
          break;
        case "social":
          __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(this.article, "socialImage", imageData.url);
          break;
        case "article":
          this.sourceFroala.html.insert("<img src=\"" + imageData.url + "\" />");
          break;
      }
    },
    createWidget: function createWidget() {
      var obj = {};
      switch (this.newWidgetType) {
        case "image-double":
          obj = {
            content: {
              objects: [{ image: { mobile: "" }, caption: "", source: "" }, { image: "", caption: "", source: "" }]
            },
            type: this.newWidgetType
          };
          break;
        case "image-featured":
          obj = {
            content: {
              image: { mobile: "" },
              caption: "",
              source: "",
              wysiwyg: ""
            },
            type: this.newWidgetType
          };
          break;
        case "featured-quote":
          obj = { content: { quote: "", wysiwyg: "" }, type: this.newWidgetType };
          break;
        case "video-full-width":
          obj = { content: { mediaId: "", title: "", subtitle: "", image: { mobile: "" } }, type: this.newWidgetType };
          break;
        case "video-scroller":
          obj = { content: { url: "", thumbnail: "", videoDuration: 0, items: [""] }, type: this.newWidgetType };
          break;
        case "image-circle":
          obj = { content: { image: { mobile: "" }, caption: "", source: "", decorationStyle: "option-1" }, type: this.newWidgetType };
          break;
        case "image-full-width":
          obj = { content: { image: { mobile: "" }, caption: "", source: "", captionStyle: "layout-1" }, type: this.newWidgetType };
          break;
        case "image-standard":
          obj = { content: { image: { mobile: "" }, caption: "", source: "" }, type: this.newWidgetType };
          break;
        default:
          obj = { content: '', type: this.newWidgetType };
          break;
      }
      this.article.widgets ? this.article.widgets.push(obj) : this.article.widgets = [obj];
    },
    initialiseArticle: function initialiseArticle(currentData) {
      var _this7 = this;

      this.showTags = false;
      setTimeout(function () {
        console.log(currentData);
        if (_this7.article.parentCategory) _this7.updateSubcategories();

        _this7.showTags = true;
        _this7.lastArticleData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this7.article);
        console.log(_this7.article);
        _this7.seoScorecard();
        _this7.seoScorecardInterval = setInterval(function () {
          _this7.seoScorecard();
        }, 4000);
        return;
        _this7.autosaver = setInterval(function () {

          console.log("checking");
          // If the object has changed

          var tempObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this7.article);

          if (_this7.lastArticleData != tempObj && (tempObj.title != "" || tempObj.content != "" || tempObj.widgets && tempObj.widgets.length > 0)) {

            tempObj = JSON.parse(tempObj);
            _this7.autosaved = true;
            console.log("AUTOSAVING");

            tempObj.lastAutosave = _this7.article.lastAutosave = {
              timestamp: Math.floor(Date.now() / 1000),
              user: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid

              // If the article doesn't have a key, give it one
            };if (!_this7.articleKey) {
              _this7.articleKey = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("posts").doc().id;
            }

            // Need to save the uploaded object to autosave temp object
            _this7.lastArticleData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(tempObj);

            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("autosaves").doc(_this7.articleKey).set(tempObj);
          }
        }, 6000);
      }, 10);
    },
    activeClass: function activeClass(a, b) {
      if (a == b) return "active";
      return "";
    },
    replaceArticle: function replaceArticle(newData) {
      console.log(newData);
      clearInterval(this.autosaver);
      this.article = newData;
      this.initialiseArticle();
    },
    savePostData: function savePostData() {
      var errorMessage = "";
      if (!this.article["slug"]) {
        errorMessage = "Missing Post Slug";
      }
      if (!this.article.title) {
        errorMessage = "Post Title is missing";
      }
      if (!this.article.parentCategory) {
        errorMessage = "Post Category is missing";
      }
      if (!this.article.subCategory) {
        errorMessage = "Post Subcategory is missing";
      }
      if (!this.article.tags || this.article.tags.length == 0) {
        errorMessage = "You must select at least one tag";
      }
      if (errorMessage) {
        console.log(this.article);
        alert(errorMessage);
        return false;
      }
      switch (this.article.layout) {
        default:
        case "article-layout-default":
          break;
        case "article-layout-evergreen":
          this.createTableOfContents();
        case "article-layout-featured":
          this.article.widgets.forEach(function (widget) {
            switch (widget.type) {
              case "froala-editor":
                var $div = $("<div>" + widget.content + "</div>");
                $div.find('p[data-f-id="pbf"]').remove();
                widget.content = $div.html();
                break;
              case "image-featured":
                var $div = $("<div>" + widget.content.wysiwyg + "</div>");
                $div.find('p[data-f-id="pbf"]').remove();
                widget.content.wysiwyg = $div.html();
                break;
              case "featured-quote":
                var $div = $("<div>" + widget.content.wysiwyg + "</div>");
                $div.find('p[data-f-id="pbf"]').remove();
                widget.content.wysiwyg = $div.html();
                break;
              case "video-scroller":
                widget.content.items.forEach(function (html, index) {
                  var $div = $("<div>" + html + "</div>");
                  $div.find('p[data-f-id="pbf"]').remove();
                  widget.content.items[index] = $div.html();
                });
                break;
            }
          });
          break;
      }

      this.article.lastUpdated = Math.floor(Date.now() / 1000);
      this.article.lastAutosave = false;
      this.article.categories = [this.article.parentCategory, this.article.subCategory];
      this.article.editedBy = {
        timestamp: Math.floor(Date.now() / 1000),
        user: window.globalUser.email,
        uid: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid
      };
      this.lastArticleData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.article);

      var tempObj = JSON.parse(this.lastArticleData);

      if (!this.articleKey) {
        this.articleKey = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("posts").doc().id;
      }

      var promises = [];

      promises.push(__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("postContent").doc(this.articleKey).set(tempObj));

      promises.push(__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("postContent").doc(this.articleKey).collection("history").add(tempObj));

      delete tempObj["widgets"];
      delete tempObj["content"];
      promises.push(__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("posts").doc(this.articleKey).set(tempObj));
      promises.push(__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("autosaves").doc(this.articleKey).delete());
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises);
    },
    onUploadedPostImage: function onUploadedPostImage(e, attrib) {
      var _this8 = this;

      e.getDownloadURL().then(function (url) {
        _this8.article[attrib] = url;
      });
    },
    onUpload: function onUpload(e) {
      e.doUpload();
    },
    onDelete: function onDelete(e) {
      e.doDelete();
    },
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    publishPost: function publishPost() {
      var _this9 = this;

      var result = this.savePostData();
      if (!result) return;
      var published = Math.floor(Date.now() / 1000);
      result.then(function () {
        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("posts").doc(_this9.articleKey).update({
          status: "publish",
          timestamp: published,
          lastUpdated: published
        });
        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("postContent").doc(_this9.articleKey).update({
          status: "publish",
          timestamp: published,
          lastUpdated: published
        }).then(function () {
          _this9.loadArticle(_this9.articleKey);
        });
      });

      // set published true
    },
    unpublishPost: function unpublishPost() {
      var _this10 = this;

      var confirm = window.confirm("Are you sure you would like to UNPUBLISH this post? The page URL will no longer function.");
      var result = this.savePostData();

      if (confirm) {
        result.then(function () {
          __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("posts").doc(_this10.articleKey).update({
            status: "draft",
            lastUpdated: Math.floor(Date.now() / 1000)
          });
          __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("postContent").doc(_this10.articleKey).update({
            status: "draft",
            lastUpdated: Math.floor(Date.now() / 1000)
          }).then(function () {
            _this10.loadArticle(_this10.articleKey);
          });
        });
      }

      // set published false
    },
    removeWidget: function removeWidget(key) {
      var confirm = window.confirm("Are you sure you would like to delete this widget?");
      if (confirm) {
        this.article.widgets.splice(key, 1);
      }
    },
    seoScorecard: function seoScorecard() {
      this.scorecard = [];
      if (this.article.targetPhrase) {
        var basePhrase = this.article.targetPhrase.toLowerCase();
        //Check if Title contains target phrase
        if (this.article.title) {
          var currentTitle = this.article.title.toLowerCase();
          if (currentTitle.includes(basePhrase)) {
            this.scorecard.push('titleContainsPhrase');
          }
        }
        //Check if slug contains target phrase
        if (this.article.slug) {
          var currentSlug = this.article.slug.replace(/-/g, ' ');
          if (currentSlug.includes(basePhrase)) {
            this.scorecard.push('slugContainsPhrase');
          }
        }
        if (this.article.meta.title) {
          //Check if SEO Title contains target phrase
          var currentSeoTitle = this.article.meta.title.toLowerCase();
          if (currentSeoTitle.includes(basePhrase)) {
            this.scorecard.push('seoTitleContainsPhrase');
          }
          //Check if SEO Title starts with target phrase
          if (currentSeoTitle.startsWith(basePhrase)) {
            this.scorecard.push('seoTitleStartsWithPhrase');
          }
        }
        if (this.article.tags && this.article.tags.length > 0) {
          var relatedTagsCount = 0;
          var testPhraseArray = this.article.targetPhrase.split(" ");
          var arrayLength = testPhraseArray.length;
          var tagsLength = this.article.tags.length;

          for (var i = 0; i < arrayLength; i++) {
            for (var z = 0; z < tagsLength; z++) {
              if (this.article.tags[z].includes(testPhraseArray[i].toLowerCase())) {
                relatedTagsCount++;
              }
            }
          }
          if (relatedTagsCount > 0) {
            this.scorecard.push('relatedTags');
          }
        }
      }
      //Check if SEO description is between 120-156 characters
      if (this.article.meta.description) {
        var descCharacters = this.article.meta.description.length;
        // if(descCharacters < 120){
        //   alert('The SEO description is too short');
        // }else if(descCharacters > 156){
        //   alert('The SEO description is too long');
        // } else {
        //   this.scorecard.push('seoDescriptionLength');
        // }
        if (descCharacters > 119 && descCharacters < 157) {
          this.scorecard.push('seoDescriptionLength');
        }
      }
    },
    setTags: function setTags(value) {
      this.article.tags = value;
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Froala__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Froala___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Froala__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_color__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FroalaEditor: __WEBPACK_IMPORTED_MODULE_1__Froala___default.a, 'slider-picker': __WEBPACK_IMPORTED_MODULE_2_vue_color__["Slider"] },
  data: function data() {
    return {};
  },
  created: function created() {
    if (!this.value.backgroundColor) __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.value, "backgroundColor", { hex: "#fff" });
  },

  props: {
    value: {
      type: Object,
      required: true
    }
  }

});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_json__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_json__);



//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tag', 'value', 'config', 'onManualControllerReady', 'tags'],

  watch: {
    value: function value() {
      this.model = this.value;
      this.updateValue();
    }
  },

  created: function created() {
    this.$el = this.$refs['froala'];
    this.model = this.value;
  },

  // After first time render.
  mounted: function mounted() {
    if (this.SPECIAL_TAGS.indexOf(this.currentTag) != -1) {

      this.hasSpecialTag = true;
    }

    if (this.onManualControllerReady) {
      this.generateManualController();
    } else {
      this.createEditor();
    }
  },

  beforeDestroy: function beforeDestroy() {
    console.log("Before destroy");
    this.destroyEditor();
  },

  data: function data() {
    var _this = this;

    return {

      initEvents: [],

      // Tag on which the editor is initialized.
      currentTag: 'div',

      // Editor element.
      _editor: null,

      // Current config.
      currentConfig: null,

      // Editor options config
      defaultConfig: {
        key: __WEBPACK_IMPORTED_MODULE_3__config_json___default.a.froalaKey,
        imageDefaultWidth: 0,
        toolbarSticky: true,
        toggleModal: this.toggleModal,
        enableDropcap: this.enableDropcap,
        toolbarButtons: {
          'moreText': {
            'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'enableDropcap', 'inlineClass', 'inlineStyle', 'clearFormatting']
          },
          'moreParagraph': {
            'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
          },
          'moreRich': {
            'buttons': ['insertLink', 'insertImage', 'imageLibrary', 'tweet', 'instagram', 'jwplayer', 'insertVideo', 'insertTable', 'emoticons', 'specialCharacters', 'embedly', 'insertFile', 'insertHR'],
            'buttonsVisible': 5
          },
          'moreMisc': {
            'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
            'align': 'right',
            'buttonsVisible': 2
          }
        },
        inlineClasses: {
          'fr-class-code': 'Code',
          'pull-quote': 'MM Quote',
          'fr-class-highlighted': 'Highlighted',
          'fr-class-transparency': 'Transparent'
        },
        events: {
          'image.beforeUpload': function imageBeforeUpload(images) {
            if (images.length) {
              _this.storage.ref().child("cms_images").child(Date.now() / 1000 + "_" + images[0].name).put(images[0]).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(snapshot) {
                  var url;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return snapshot.ref.getDownloadURL();

                        case 2:
                          url = _context.sent;

                          // this.froalaEditor.image.insert(url, null, null, editor.image.get());
                          _this._editor.image.insert(url, false, null, null, { link: "#" });

                        case 4:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            }

            _this._editor.popups.hideAll();

            // Stop default upload chain.
            return false;
          }
        },
        immediateVueModelUpdate: false,
        vueIgnoreAttrs: null
      },

      editorInitialized: false,

      SPECIAL_TAGS: ['img', 'button', 'input', 'a'],
      INNER_HTML_ATTR: 'innerHTML',
      hasSpecialTag: false,

      model: null,
      oldModel: null
    };
  },
  methods: {
    enableDropcap: function enableDropcap() {
      this.$emit("toggle-dropcap");
    },

    toggleModal: function toggleModal() {
      var _this2 = this;

      console.log("toggling modal");
      this.$emit("toggle-images-modal", {
        callback: function callback(image) {
          console.log(image.mobile);
          _this2._editor.html.insert('<img src="' + image.mobile + '" />');
        },
        type: 'article'
      });
    },

    updateValue: function updateValue() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.oldModel) == __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model)) {
        return;
      }

      this.setContent();
    },

    createEditor: function createEditor() {
      if (this.editorInitialized) {
        return;
      }

      this.currentConfig = this.config || this.defaultConfig;
      if (!this.currentConfig.key) this.currentConfig.key = __WEBPACK_IMPORTED_MODULE_3__config_json___default.a.froalaKey;
      this.setContent(true);

      // Bind editor events.
      this.registerEvents();
      this.initListeners();

      this._editor = new FroalaEditor(this.$el, this.currentConfig);

      this.editorInitialized = true;
    },

    setContent: function setContent(firstTime) {

      if (!this.editorInitialized && !firstTime) {
        return;
      }

      if (this.model || this.model == '') {

        this.oldModel = this.model;

        if (this.hasSpecialTag) {
          this.setSpecialTagContent();
        } else {
          this.setNormalTagContent(firstTime);
        }
      }
    },

    setNormalTagContent: function setNormalTagContent(firstTime) {

      var self = this;

      function htmlSet() {

        self._editor.html.set(self.model || '');

        //This will reset the undo stack everytime the model changes externally. Can we fix this?

        self._editor.undo.saveStep();
        self._editor.undo.reset();
      }

      if (firstTime) {
        this.registerEvent('initialized', function () {
          htmlSet();
        });
      } else {
        htmlSet();
      }
    },

    setSpecialTagContent: function setSpecialTagContent() {

      var tags = this.model;

      // add tags on element
      if (tags) {

        for (var attr in tags) {
          if (tags.hasOwnProperty(attr) && attr != this.INNER_HTML_ATTR) {
            this.$el.setAttribute(attr, tags[attr]);
          }
        }

        if (tags.hasOwnProperty(this.INNER_HTML_ATTR)) {
          this.$el.innerHTML = tags[this.INNER_HTML_ATTR];
        }
      }
    },

    destroyEditor: function destroyEditor() {
      console.log("Destroying!");
      if (this._editor) {
        if (this._editor.events && this._editor.events.off) {
          this._editor.events.off('contentChanged');
          this._editor.events.off('keyup');
        }
        // this._editor.destroy();
        // this.editorInitialized = false;
        // this._editor = null;
      }
    },

    getEditor: function getEditor() {
      return this._editor;
    },

    generateManualController: function generateManualController() {
      var controls = {
        initialize: this.createEditor,
        destroy: this.destroyEditor,
        getEditor: this.getEditor
      };

      this.onManualControllerReady(controls);
    },

    updateModel: function updateModel() {

      var modelContent = '';

      if (this.hasSpecialTag) {

        var attributeNodes = this.$el[0].attributes;
        var attrs = {};

        for (var i = 0; i < attributeNodes.length; i++) {

          var attrName = attributeNodes[i].name;
          if (this.currentConfig.vueIgnoreAttrs && this.currentConfig.vueIgnoreAttrs.indexOf(attrName) != -1) {
            continue;
          }
          attrs[attrName] = attributeNodes[i].value;
        }

        if (this.$el[0].innerHTML) {
          attrs[this.INNER_HTML_ATTR] = this.$el[0].innerHTML;
        }

        modelContent = attrs;
      } else {

        var returnedHtml = this._editor.html.get();
        if (typeof returnedHtml === 'string') {
          modelContent = returnedHtml;
        }
      }

      this.oldModel = modelContent;

      this.$emit('input', modelContent);
    },

    initListeners: function initListeners() {
      var self = this;
      this.registerEvent('destroy', function () {
        console.log("froala destroy");
      });
      this.registerEvent('initialized', function () {
        if (self._editor.events) {
          // bind contentChange and keyup event to froalaModel
          self._editor.events.on('contentChanged', function () {
            self.updateModel();
          });

          if (self.currentConfig.immediateVueModelUpdate) {
            self._editor.events.on('keyup', function () {
              self.updateModel();
            });
          }
        }
      });
    },

    // register event on editor element
    registerEvent: function registerEvent(eventName, callback) {

      if (!eventName || !callback) {
        return;
      }

      // Initialized event.
      if (eventName == 'initialized') {

        this.initEvents.push(callback);
      } else {
        if (!this.currentConfig.events) {
          this.currentConfig.events = {};
        }

        this.currentConfig.events[eventName] = callback;
      }
    },

    registerEvents: function registerEvents() {
      // Handle initialized on its own.
      this.registerInitialized();

      // Get current events.
      var events = this.currentConfig.events;

      if (!events) {
        return;
      }

      for (var event in events) {
        if (events.hasOwnProperty(event) && event != 'initialized') {
          this.registerEvent(event, events[event]);
        }
      }
    },

    registerInitialized: function registerInitialized() {
      var _this3 = this;

      // Bind initialized.
      if (!this.currentConfig.events) {
        this.currentConfig.events = {};
      }

      // Set original initialized event.
      if (this.currentConfig.events.initialized) {
        this.registerEvent('initialized', this.currentConfig.events.initialized);
      }

      // Bind initialized event.
      this.currentConfig.events.initialized = function () {
        for (var i = 0; i < _this3.initEvents.length; i++) {
          _this3.initEvents[i].call(_this3._editor);
        }
      };
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['slug', 'value'],
    watch: {
        value: function value() {
            this.model = this.value;
            this.$emit('input', this.model);
        }
    },
    // After first time render.
    mounted: function mounted() {},

    data: function data() {

        return {};
    }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      storage: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage()
    };
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    changeImage: function changeImage() {
      var _this = this;

      this.$emit('changeImage', {
        callback: function callback(images) {
          console.log(images);
          _this.value.image = images;
        }
      });
    },
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    }
  }

});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      storage: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage()
    };
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    changeImage: function changeImage(number) {
      var _this = this;

      this.$emit('changeImage', {
        callback: function callback(images) {
          _this.value.objects[number].image = images;
        }
      });
    }
  }

});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Froala__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Froala___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Froala__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_color__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_color__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FroalaEditor: __WEBPACK_IMPORTED_MODULE_2__Froala___default.a, 'slider-picker': __WEBPACK_IMPORTED_MODULE_3_vue_color__["Slider"] },
  data: function data() {
    return {
      storage: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage(),
      froalaConfig: {
        imageDefaultWidth: 0,
        toggleModal: this.toggleModal,
        toolbarButtons: {
          'moreText': {
            'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
          },
          'moreParagraph': {
            'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
          },
          'moreRich': {
            'buttons': ['insertLink', 'insertImage', 'insertTable', 'emoticons', 'specialCharacters', 'insertHR'],
            'buttonsVisible': 3
          },
          'moreMisc': {
            'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
            'align': 'right',
            'buttonsVisible': 2
          }
        },
        immediateVueModelUpdate: false,
        vueIgnoreAttrs: null
      }
    };
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  created: function created() {
    if (!this.value.backgroundColor) __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.value, "backgroundColor", { hex: "#fff" });
  },

  methods: {
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    changeImage: function changeImage() {
      var _this = this;

      this.$emit('changeImage', {
        callback: function callback(images) {
          _this.value.image = images;
        }
      });
    }
  }

});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      storage: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage()
    };
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    changeImage: function changeImage() {
      var _this = this;

      this.$emit('changeImage', {
        callback: function callback(images) {
          _this.value.image = images;
        }
      });
    },
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    }
  }

});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      storage: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage()
    };
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    changeImage: function changeImage() {
      var _this = this;

      this.$emit('changeImage', {
        callback: function callback(images) {
          console.log(images);
          _this.value.image = images;
        }
      });
    }
  }

});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      storage: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage()
    };
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    changeImage: function changeImage() {
      var _this = this;

      this.$emit('changeImage', {
        callback: function callback(images) {
          _this.value.image = images;
        }
      });
    }
  }

});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Froala__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Froala___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Froala__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Froala: __WEBPACK_IMPORTED_MODULE_2__Froala___default.a },
  data: function data() {
    return {
      froalaConfig: {
        imageDefaultWidth: 0,
        toggleModal: this.toggleModal,
        toolbarButtons: {
          'moreText': {
            'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
          },
          'moreParagraph': {
            'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
          },
          'moreRich': {
            'buttons': ['insertLink', 'insertImage', 'insertTable', 'emoticons', 'specialCharacters', 'insertHR'],
            'buttonsVisible': 3
          },
          'moreMisc': {
            'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
            'align': 'right',
            'buttonsVisible': 2
          }
        },
        immediateVueModelUpdate: false,
        vueIgnoreAttrs: null
      }
    };
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    changeImage: function changeImage() {
      var _this = this;

      this.$emit('changeImage', {
        callback: function callback(images) {
          _this.value.image = images;
        }
      });
    }
  }

});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//

// https://vue-multiselect.js.org


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  data: function data() {
    return {
      value: null
    };
  },

  props: {
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String
    }
  },
  watch: {
    value: function value() {
      this.$emit('value', this.value);
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// https://vue-multiselect.js.org/#sub-tagging

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  data: function data() {
    return {
      selectedValue: null
    };
  },

  props: ["options", "placeholder", "value", "multiple"],
  methods: {
    updateValue: function updateValue(tag) {
      this.selectedValue = tag;
      if (this.multiple) {
        var results = this.selectedValue.map(function (item) {
          return item.item;
        });
        this.$emit('value', results);
        console.log(results);
      } else {
        this.$emit('value', tag.item);
      }
    },
    create: function create(newTag) {
      // This method can also be used to create an error message
      this.$emit('create', newTag);
    }
  },
  watch: {
    // Clears displayed tags when value prop changes
    value: function value() {
      this.selectedValue = null;
    }
  },
  computed: {
    // Multiselect paired with :taggable="true" takes options prop as and Object
    formattedOptions: function formattedOptions() {
      if (this.options) {
        return this.options.map(function (option) {
          return { item: option };
        });
      } else {
        return [];
      }
    },
    formattedValue: function formattedValue() {
      if (this.value) {
        return this.value.map(function (tag) {
          return { item: "" + tag };
        });
      }
    },
    selected: function selected() {
      return this.selectedValue;
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["col", "row", "gap"],
  methods: {
    setColumns: function setColumns(col) {
      this.$refs.grid.style.setProperty("--columns", col);
    },
    setRows: function setRows(row) {
      this.$refs.grid.style.setProperty("--rows", row);
    },
    setGap: function setGap(gap) {
      this.$refs.grid.style.setProperty("--gap", gap);
    }
  },
  mounted: function mounted() {
    this.setColumns(this.col);
    this.setRows(this.row);
    this.setGap(this.gap);
  },

  watch: {
    col: function col(val) {
      this.setColumns(val);
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "modal",
  props: ["image", "aspectRatio"],
  components: {},
  data: function data() {
    return {
      cropImageUrl: "",
      cropMode: 'mobile',
      cropper: null,
      parentClass: "",
      crops: {
        mobile: {
          done: false,
          data: false,
          cropBox: false
        },
        desktop: {
          done: false,
          data: false,
          cropBox: false
        }
      }
    };
  },
  watch: {
    cropMode: function cropMode(val, oldVal) {
      var _this = this;

      if (this.cropMode && this.aspectRatio && this.aspectRatio[this.cropMode] && this.cropper) {
        console.log(oldVal);
        this.cropper.crop();
        this.cropper.getCroppedCanvas().toBlob(function (blob) {
          _this.crops[oldVal].data = blob;
          _this.crops[oldVal].done = true;
          _this.crops[oldVal].cropBox = _this.cropper.getCropBoxData();
          if (_this.aspectRatio[_this.cropMode] && _this.aspectRatio[_this.cropMode] != "any") _this.cropper.setAspectRatio(_this.aspectRatio[_this.cropMode]);
          if (_this.crops[val].cropBox) _this.cropper.setCropBoxData(_this.crops[val].cropBox);
        }, "image/jpeg");
      }
    }
  },
  methods: {
    openImageFromUrl: function openImageFromUrl(url) {
      var _this2 = this;

      if (!url) return;
      if (this.cropper) {
        this.cropper.destroy();
      }
      if ($("#image")) $("#image").off('load');
      var aspect = false;
      this.parentClass = '';
      if (this.cropMode && this.aspectRatio && this.aspectRatio[this.cropMode] && this.aspectRatio[this.cropMode] != "any") {
        aspect = this.aspectRatio[this.cropMode];
        if (this.aspectRatio.circle) this.parentClass = 'circle-crop';
      }
      console.log(this.cropMode, this.aspectRatio, aspect);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
        _this2.cropImageUrl = url;
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
          _this2.cropper = new Cropper(document.getElementById("image"), {
            zoomable: false,
            viewMode: 2,
            autoCropArea: 100,
            aspectRatio: aspect,
            crop: function crop(event) {}
          });
        });
      });
    },
    openImageFromData: function openImageFromData(data) {
      var TYPED_ARRAY = new Uint8Array(data);
      var STRING_CHAR = TYPED_ARRAY.reduce(function (data, byte) {
        return data + String.fromCharCode(byte);
      }, '');
      var base64String = btoa(STRING_CHAR);
      this.openImageFromUrl('data:image/jpg;base64, ' + base64String);
    },
    getCropData: function getCropData() {
      var _this3 = this;

      this.cropper.getCroppedCanvas().toBlob(function (blob) {
        _this3.crops[_this3.cropMode].data = blob;
        _this3.crops[_this3.cropMode].done = true;
        _this3.crops[_this3.cropMode].cropBox = _this3.cropper.getCropBoxData();
        _this3.$emit("crop-data", _this3.crops);
      }, "image/jpeg");
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);



//
//
//
//
//
//



__webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "modal",
  props: ["image"],
  components: {},
  watch: {
    initialised: function initialised(val) {
      if (val && this.dataForInitialised) {
        console.log("SENDING DATA");
        this.photopeaWnd.postMessage(this.dataForInitialised, "*");
      }
    }
  },
  data: function data() {
    return {
      openStockImage: false,
      photopeaWnd: null,
      messageCount: 0,
      initialised: false,
      dataForInitialised: false,
      saveAs: "data"
    };
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
    document.body.style.overflowY = "hidden";
    this.photopeaWnd = document.getElementById("photopea").contentWindow;
    window.addEventListener("message", this.ppReady);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.style.overflowY = "scroll";
  },

  methods: {
    ppReady: function ppReady(msg) {
      var _this = this;

      this.messageCount++;
      if (this.messageCount == 2) {
        this.initialised = true;
      }
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(msg.data) == "object") {
        if (this.saveAs == "url") {
          __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage().ref().child("cms_images").child(Date.now() / 1000 + "_edited.jpg").put(msg.data).then(function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(snapshot) {
              var url;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return snapshot.ref.getDownloadURL();

                    case 2:
                      url = _context.sent;

                      console.log('Uploaded array data!', url);
                      // this.froalaEditor.image.insert(url, null, null, editor.image.get());
                      _this.$emit('save-url', { url: url });

                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, _this);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        } else {
          this.$emit('save-data', { nextStep: 'third', bytes: msg.data });
        }
      }
      console.log(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(msg.data));
    },
    openImageUrl: function openImageUrl(url) {
      console.log("app.open(\"" + url + "\", 0, 1)");
      if (this.initialised) this.photopeaWnd.postMessage("app.open(\"" + url + "\", 0, 1)", "*");else this.dataForInitialised = "app.open(\"" + url + "\", 0, 1)";
    },
    openImageData: function openImageData(data) {
      if (this.initialised) this.photopeaWnd.postMessage(data, "*");else this.dataForInitialised = data;
    },
    saveImageData: function saveImageData() {
      this.saveAs = "data";
      this.photopeaWnd.postMessage("activeDocument.saveToOE(\"jpg\")", "*");
    },
    saveImageUrl: function saveImageUrl() {
      this.saveAs = "url";
      this.photopeaWnd.postMessage("activeDocument.saveToOE(\"jpg\")", "*");
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__imageUpload__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__imageUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__imageUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_json__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "modal",
  props: [],
  components: {
    ImageUpload: __WEBPACK_IMPORTED_MODULE_2__imageUpload___default.a
  },
  data: function data() {
    return {
      images: [],
      currentTab: "gettyEditorial",
      searchString: "",
      searchPhrase: "",
      currentMasonry: null,
      associatedText: ""
    };
  },
  watch: {
    phraseimages: function phraseimages(val) {
      this.images = val;
    },
    images: function images(val) {
      var _this = this;

      $(".grid").imagesLoaded(function () {
        console.log("imagesLoaded images changed");
        if (_this.currentMasonry) {
          _this.currentMasonry.masonry('destroy');
          _this.currentMasonry = false;
        }
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
          _this.currentMasonry = $('.grid').masonry({
            // set itemSelector so .grid-sizer is not used in layout
            itemSelector: '.grid-item',
            // use element for option
            columnWidth: '.grid-sizer',
            percentPosition: true,
            gutter: 10,
            transitionDuration: '0.2s'
          });
        });
      });
    },
    searchPhrase: function searchPhrase(query) {
      this.alogoliaSearch(query);
    }
  },
  mounted: function mounted() {
    var client = algoliasearch("U5GL740LVM", "ee79df2ed46df0e29f0a0e05d9d2466f");
    this.algolia = client.initIndex("images");
    this.alogoliaSearch("");
  },
  destroyed: function destroyed() {
    if (this.currentMasonry) this.currentMasonry.masonry('destroy');
  },
  methods: {
    processFileDataEdit: function processFileDataEdit(data) {
      this.$emit("process-file-array", { bytes: data.bytes, associatedText: this.associatedText, nextStep: "second" });
    },
    processFileDataCrop: function processFileDataCrop(data) {
      this.$emit("process-file-array", { bytes: data.bytes, associatedText: this.associatedText, nextStep: "third" });
    },
    alogoliaSearch: function alogoliaSearch(query) {
      var _this2 = this;

      console.log(query);
      if (!query) {
        query = "";
      }
      this.algolia.search({
        query: query
      }).then(function (responses) {
        _this2.images = {
          mmCatalogue: [],
          gettyEditorial: [],
          gettyCreative: [],
          unsplash: []
        };
        var searchResults = [];
        console.log(responses);
        responses.hits.forEach(function (hit) {
          console.log(hit.url);
          searchResults.push({
            url: hit.url,
            searchString: hit.searchString,
            type: "catalogue"
          });
        });

        // To avoid DOM redraws repeatedly
        // Is this needed? Is Vue smart enough to not redraw when lots of pushes happen?
        _this2.images.mmCatalogue = searchResults;
      });
    },
    changeImagesTab: function changeImagesTab(tab) {
      var _this3 = this;

      this.currentTab = tab;
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
        if (_this3.currentMasonry) {
          _this3.currentMasonry.masonry('destroy');
          _this3.currentMasonry = false;
        }
        _this3.currentMasonry = $('.grid').masonry({
          // set itemSelector so .grid-sizer is not used in layout
          itemSelector: '.grid-item',
          // use element for option
          columnWidth: '.grid-sizer',
          percentPosition: true,
          gutter: 10,
          transitionDuration: '0.2s'
        });
        $(".grid").imagesLoaded(function () {
          if (_this3.currentMasonry) {
            _this3.currentMasonry.masonry('layout');
            setTimeout(function () {
              _this3.currentMasonry.masonry('layout');
            }, 1000);
            setTimeout(function () {
              _this3.currentMasonry.masonry('layout');
            }, 2500);
            setTimeout(function () {
              _this3.currentMasonry.masonry('layout');
            }, 5000);
          } else {
            _this3.currentMasonry = $('.grid').masonry({
              // set itemSelector so .grid-sizer is not used in layout
              itemSelector: '.grid-item',
              // use element for option
              columnWidth: '.grid-sizer',
              percentPosition: true,
              gutter: 10,
              transitionDuration: '0.2s'
            });
          }
        });
      });
    },
    buyThenEmit: function buyThenEmit() {
      var _this4 = this;

      var download = window.confirm("This will use up a download from the total Getty download limit, are you sure you'd like to continue?");
      if (download) {
        axios.get(__WEBPACK_IMPORTED_MODULE_3__config_json___default.a.apiAdmin + "/buyGettyImage?id=" + photo.id).then(function (response) {
          // handle success
          console.log(response);
          _this4.$emit("done", { url: response.data.url, searchText: "" });
        });
      }
    },
    buyImage: function buyImage(photo) {
      var _this5 = this;

      var download = window.confirm("This will use up a download from the total Getty download limit, are you sure you'd like to continue?");
      if (download) {
        axios.get(__WEBPACK_IMPORTED_MODULE_3__config_json___default.a.apiAdmin + "/buyGettyImage?id=" + photo.id).then(function (response) {
          // handle success
          console.log(response);
          _this5.$emit("done", { url: response.data.url, searchText: "" });
        });
      }
      console.log(photo);
    },
    search: function search() {
      var _this6 = this;

      var term = document.getElementById("searchTermInput").value;
      axios.get(__WEBPACK_IMPORTED_MODULE_3__config_json___default.a.apiAdmin + "/getImages?phrase=" + (term || "a")).then(function (response) {
        // handle success
        console.log(response);
        for (var key in response.data) {
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this6.images, key, response.data[key]);
        }
      });
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "modal",
  props: ["image"],
  components: {},
  watch: {
    file: function file(_file) {
      var _this = this;

      console.log("watch file", _file);
      var reader = new FileReader();
      reader.onload = function () {
        console.log("loaded");
        var arrayBuffer = reader.result;
        var bytes = arrayBuffer; //new Uint8Array(arrayBuffer);
        console.log("imageUpload", bytes);
        _this.$emit("file-array", { bytes: bytes });
      };
      reader.readAsArrayBuffer(_file);
    }
  },
  data: function data() {
    return {
      files: [],
      fileSelector: null,
      file: null
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var input = document.createElement('input');
    input.type = 'file';
    this.fileSelector = input;
    this.fileSelector.onchange = function (e) {
      console.log(e);
      _this2.file = e.target.files[0];
    };
    ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
      /*
        For each event add an event listener that prevents the default action
        (opening the file in the browser) and stop the propagation of the event (so
        no other elements open the file in the browser)
      */
      this.$refs.fileform.addEventListener(evt, function (e) {
        e.preventDefault();
        e.stopPropagation();
      }.bind(this), false);
    }.bind(this));

    this.$refs.fileform.addEventListener('drop', function (e) {
      /*
        Capture the files from the drop event and add them to our local files
        array.
      */
      this.file = e.dataTransfer.files[0];
    }.bind(this));
  },
  methods: {
    selectImage: function selectImage() {
      this.fileSelector.click();
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalButton_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ModalButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_json__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "modal",
  props: ["slug", "password"],
  components: {
    ModalButton: __WEBPACK_IMPORTED_MODULE_2__ModalButton_vue___default.a
  },
  data: function data() {
    return {
      previewUrl: __WEBPACK_IMPORTED_MODULE_3__config_json___default.a.previewUrl,
      deviceToggle: "desktop"
    };
  },
  mounted: function mounted() {
    document.getElementById("previewText").value = 'https://mamamia-pwa-staging.firebaseapp.com/article-preview/' + this.slug + '/' + this.password + '/';
  },
  methods: {
    copyText: function copyText() {
      document.getElementById('previewText').select();
      document.execCommand('copy');
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var firestore;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  props: {
    passedObject: {
      type: Object
    }
  },
  firestore: function firestore() {
    return {};
  },

  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {};
  },
  methods: {
    deleteBrand: function deleteBrand() {
      firestore.collection("brandedArticles").doc(this.$props.passedObject.id).delete();
      alert("Branded article removed");
      this.$emit('update:modal');
    },
    closeTheModal: function closeTheModal() {
      this.$emit('update:modal');
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var firestore;
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: ['passedValue'],
  name: 'modal',
  firestore: function firestore() {
    return {};
  },

  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {
      states: [{ text: "New South Wales" }, { text: "Queensland" }, { text: "South Australia" }, { text: "Victoria" }, { text: "Western Australia" }],
      newBrand: {
        active: true,
        endDate: '',
        currentPageviews: 0,
        pageviews: 0,
        probability: 0,
        url: "",
        location: ""
      }
    };
  },
  methods: {
    addNewBrand: function addNewBrand() {
      var _this = this;

      //Calculating probability
      var actualValue = true;
      var currentDate = Math.floor(Date.now() / 1000);
      var newDate = new Date(this.newBrand.endDate).getTime() / 1000;
      var noOfDays = Math.floor((newDate - currentDate) / 86400);
      var pvPerDay = (this.newBrand.pageviews - this.newBrand.currentPageviews) / noOfDays;
      //The number 900 has been taken based on an estimate of 9,000 available page views for adding branded articles under.
      //This number is roughly 10% of daily pageviews.Can be tweaked if the daily page views change a lot
      var probValue = (pvPerDay / 90).toFixed(2);
      var probNumber = parseFloat(probValue);
      var totalProb = this.$props.passedValue + probNumber;
      console.log(totalProb);
      // if(20 >= totalProb ){
      //console.log('Total less than 10 : '+totalProb);
      this.newBrand.probability = parseFloat(probNumber);
      // } else {
      //   console.log('Total more than 10 :'+totalProb);
      //   actualValue = false;
      //   this.newBrand.probability = parseFloat((20 - this.$props.passedValue));
      // }
      console.log('This is the probability that will be added : ' + this.newBrand.probability);
      this.newBrand.pageviews = parseInt(this.newBrand.pageviews);
      this.newBrand.currentPageviews = parseInt(this.newBrand.currentPageviews);

      firestore.collection('brandedArticles').add(this.newBrand).then(function (ref) {
        console.log('Added document with ID: ', ref.id);
        if (actualValue) {
          alert("New branded article created");
        } else {
          alert("New branded article created. The probabilty value was adjusted as the there are too many competing branded articles. This may not meet its target.");
        }

        _this.newBrand = {
          active: true,
          currentPageviews: 0,
          endDate: '',
          pageviews: 0,
          probability: 0,
          url: "",
          location: ""
        };
        _this.$emit('update:modal');
      });
    },
    closeTheModal: function closeTheModal() {
      this.$emit('update:modal');
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var firestore;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  props: {
    passedObject: {
      type: Object
    }
  },
  firestore: function firestore() {
    return {};
  },

  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {
      pvChanged: false,
      dateChanged: false,
      probChanged: false,
      states: [{ text: "All States" }, { text: "New South Wales" }, { text: "Queensland" }, { text: "South Australia" }, { text: "Victoria" }, { text: "Western Australia" }]
    };
  },
  methods: {
    editBrand: function editBrand() {
      var _this = this;

      console.log(this.passedObject);
      //Check if we need to re-calculate PROBABILITY
      if (this.pvChanged || this.dateChanged || this.probChanged) {
        var currentTotal = 0;
        //Fetch the total of probability for reference
        firestore.collection("brandedArticles").where('active', '==', true).get().then(function (snapshot) {
          if (snapshot.empty) {
            console.log('No active branded articles found');
          }

          snapshot.forEach(function (doc) {
            var snapData = doc.data();
            if (snapData.url != _this.passedObject.data.url) {
              currentTotal = parseFloat(snapData.probability + currentTotal);
            }
          });
          currentTotal = currentTotal.toFixed(2);
          var maxAllowed = 20 - currentTotal;
          var actualValue = true;
          if (_this.pvChanged || _this.dateChanged) {
            var currentDate = Math.floor(Date.now() / 1000);
            var newDate = new Date(_this.passedObject.data.endDate).getTime() / 1000;
            var noOfDays = Math.floor((newDate - currentDate) / 86400);
            var pvPerDay = _this.passedObject.data.pageviews / noOfDays;
            //The number 900 has been taken based on an estimate of 9,000 available page views for adding branded articles under.
            //This number is roughly 10% of daily pageviews.Can be tweaked if the daily page views change a lot
            var probValue = (pvPerDay / 90).toFixed(2);
            var probNumber = parseFloat(probValue);
            // var totalProb = this.$props.passedValue + probNumber;

            if (probNumber < maxAllowed) {
              _this.passedObject.data.probability = parseFloat(probNumber);
            } else {
              actualValue = false;
              _this.passedObject.data.probability = parseFloat(maxAllowed);
            }
          } else if (_this.probChanged) {
            if (_this.passedObject.data.probability > maxAllowed) {
              _this.passedObject.data.probability = parseFloat(maxAllowed);
              actualValue = false;
            }
          }
          console.log({
            active: _this.passedObject.data.active,
            endDate: _this.passedObject.data.endDate,
            pageviews: parseInt(_this.passedObject.data.pageviews),
            currentPageviews: parseInt(_this.passedObject.data.currentPageviews),
            probability: parseFloat(_this.passedObject.data.probability),
            url: _this.passedObject.data.url,
            location: _this.passedObject.data.location || "All States"
          });
          //Update database after recalculating
          firestore.collection("brandedArticles").doc(_this.$props.passedObject.id).update({
            active: _this.passedObject.data.active,
            endDate: _this.passedObject.data.endDate,
            pageviews: parseInt(_this.passedObject.data.pageviews),
            currentPageviews: parseInt(_this.passedObject.data.currentPageviews),
            probability: parseFloat(_this.passedObject.data.probability),
            url: _this.passedObject.data.url,
            location: _this.passedObject.data.location || "All States"
          });
          if (actualValue) {
            alert("Branded article updated");
          } else {
            alert("Branded article updated.The probabilty value was adjusted as the there are too many competing branded articles. This may not meet its target.");
          }
          _this.$emit('update:modal');
        }).catch(function (err) {
          console.log('Error getting branded articles', err);
        });
      } else {
        console.log("2", {
          active: this.passedObject.data.active,
          endDate: this.passedObject.data.endDate,
          pageviews: parseInt(this.passedObject.data.pageviews),
          currentPageviews: parseInt(this.passedObject.data.currentPageviews),
          probability: parseFloat(this.passedObject.data.probability),
          url: this.passedObject.data.url,
          location: this.passedObject.data.location || "All States"
        });
        //Actual update - no recalculation required
        firestore.collection("brandedArticles").doc(this.$props.passedObject.id).update({
          active: this.passedObject.data.active,
          endDate: this.passedObject.data.endDate,
          pageviews: parseInt(this.passedObject.data.pageviews),
          currentPageviews: parseInt(this.passedObject.data.currentPageviews),
          probability: parseFloat(this.passedObject.data.probability),
          url: this.passedObject.data.url,
          location: this.passedObject.data.location || "All States"
        });
        alert("Branded article updated");
        this.$emit('update:modal');
      }
    },
    closeTheModal: function closeTheModal() {
      this.$emit('update:modal');
    },
    dateChangeDetected: function dateChangeDetected() {
      this.dateChanged = true;
      console.log('Date change detected');
    },
    pvChangeDetected: function pvChangeDetected() {
      this.pvChanged = true;
      console.log('PV change detected');
    },
    probChangeDetected: function probChangeDetected() {
      this.probChanged = true;
      console.log('Prob change detected');
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalBranddelete_vue__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalBranddelete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ModalBranddelete_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modalDelbrand',
  props: {
    passedItem: {
      type: Object
    }
  },
  components: { ModalBranddelete: __WEBPACK_IMPORTED_MODULE_1__ModalBranddelete_vue___default.a },
  data: function data() {
    return {
      showBrandDeleteModal: false,
      objectToPass: null
    };
  },
  methods: {
    showModalDeleteBrand: function showModalDeleteBrand() {
      this.showBrandDeleteModal = true;
      this.objectToPass = this.$props.passedItem;
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalBrandedit_vue__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalBrandedit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ModalBrandedit_vue__);

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modalEditbrand',
  props: {
    passedItem: {
      type: Object
    }
  },
  components: { ModalBrandedit: __WEBPACK_IMPORTED_MODULE_2__ModalBrandedit_vue___default.a },
  data: function data() {
    return {
      showBrandEditModal: false,
      objectToPass: null
    };
  },
  methods: {
    showModalEditBrand: function showModalEditBrand() {
      this.showBrandEditModal = true;
      this.objectToPass = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$props.passedItem);
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalButton_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ModalButton_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "modal",
  props: ["id"],
  components: {
    ModalButton: __WEBPACK_IMPORTED_MODULE_2__ModalButton_vue___default.a
  },
  data: function data() {
    return {
      articleHistory: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore().collection("postContent").doc(this.id).collection("history").orderBy("editedBy.timestamp", "desc").get().then(function (snap) {
      _this.articleHistory = snap.docs.map(function (documentSnapshot) {
        return documentSnapshot.data();
      });
      console.log(_this.articleHistory);
    });
  },
  methods: {
    restore: function restore(article) {
      this.$emit("restore", article);
      this.$emit("close");
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalButton_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_image_imageCrop__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_image_imageCrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_image_imageCrop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_image_imageEdit__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_image_imageEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_image_imageEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_image_imageSelect__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_image_imageSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_image_imageSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_json__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_json__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__webpack_require__(4);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "modal",
  props: ["id", "widget"],
  components: {
    ModalButton: __WEBPACK_IMPORTED_MODULE_3__ModalButton_vue___default.a, ImageCrop: __WEBPACK_IMPORTED_MODULE_4__common_image_imageCrop___default.a, ImageEdit: __WEBPACK_IMPORTED_MODULE_5__common_image_imageEdit___default.a, ImageSelect: __WEBPACK_IMPORTED_MODULE_6__common_image_imageSelect___default.a
  },
  watch: {
    modalOpen: function modalOpen(val) {
      if (!val) {
        this.active = 'first';
        this.first = this.second = this.third = false;
      }
    }
  },
  data: function data() {
    return {
      showSpinner: false,
      modalOpen: false,
      callback: null,
      active: 'first',
      first: false,
      second: false,
      third: false,
      aspectRatio: {},
      aspectRatios: {
        'image-full-width': {
          desktop: 16 / 9,
          mobile: 3 / 4
        },
        'image-standard': {
          desktop: 1,
          mobile: 3 / 4
        },
        'image-featured': {
          desktop: 16 / 9,
          mobile: 3 / 4
        },
        'image-circle': {
          desktop: false,
          mobile: 1,
          circle: true
        },
        'image-double': {
          desktop: false,
          mobile: 4 / 3
        },
        'preview-article-layout-default': {
          desktop: false,
          mobile: 3 / 2
        },
        'preview-article-layout-evergreen': {
          desktop: 3 / 2,
          mobile: 3 / 4
        },
        'preview-article-layout-featured': {
          desktop: 3 / 2,
          mobile: 3 / 4
        },
        'social': {
          desktop: false,
          mobile: 16 / 9
        },
        'article': {
          desktop: false,
          mobile: 'any'
        }
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    gotCropData: function gotCropData(data) {
      var _this = this;

      var promises = [];
      var images = {
        mobile: false,
        desktop: false
      };
      if (data.mobile.done) {
        promises.push(__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.storage().ref().child("croppedImages/mobile_" + Date.now() + "_" + Math.floor(Math.random() * 9999999) + ".jpg").put(data.mobile.data).then(function (snapshot) {
          return snapshot.ref.getDownloadURL().then(function (downloadURL) {
            images.mobile = downloadURL;
          });
        }));
      }
      if (data.desktop.done) {
        promises.push(__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.storage().ref().child("croppedImages/desktop_" + Date.now() + "_" + Math.floor(Math.random() * 9999999) + ".jpg").put(data.desktop.data).then(function (snapshot) {
          return snapshot.ref.getDownloadURL().then(function (downloadURL) {
            images.desktop = downloadURL;
          });
        }));
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        console.log(images.mobile);

        _this.callback(images);
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].nextTick(function () {
          _this.showSpinner = false;
          _this.modalOpen = false;
        });
      });
    },
    saveImageToCatalogue: function saveImageToCatalogue(image) {
      var _this2 = this;

      if (image.data) {
        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.storage().ref().child("croppedImages/" + Date.now() + "_" + Math.floor(Math.random() * 9999999) + "_edited.jpg").put(image.data).then(function (snapshot) {
          return snapshot.ref.getDownloadURL().then(function (downloadURL) {
            image.url = downloadURL;
            _this2.completeSaveImageToCatalogue(image);
          });
        });
      } else if (image.url) {
        this.completeSaveImageToCatalogue(image);
      } else {
        alert("Could not save image to database, no url or data supplied.");
      }
    },
    completeSaveImageToCatalogue: function completeSaveImageToCatalogue(image) {
      return axios.post(__WEBPACK_IMPORTED_MODULE_7__config_json___default.a.apiAdmin + "/saveImage", {
        url: image.url,
        searchString: image.searchString,
        verificationString: "4oq367yvb6o9q346vbgp93q46b"
      });
    },
    processFileArray: function processFileArray(data) {
      // TODO - Upload original image for use in the library here
      // axios.post(config.apiAdmin + "/saveImage", {
      //   url: downloadURL, 
      //   searchString: this.searchString, 
      //   verificationString: "4oq367yvb6o9q346vbgp93q46b"
      // });
      this.setDone('first', data.nextStep);

      var searchString = prompt("Please enter some text to find this image later", "");
      if (name != null) {
        this.saveImageToCatalogue({
          data: data.bytes,
          searchString: searchString
        });
      }

      if (data.nextStep == "second") this.$refs['imageEdit'].openImageData(data.bytes);
      if (data.nextStep == "third") this.$refs['imageCrop'].openImageFromData(data.bytes);
    },
    processFileUrl: function processFileUrl(data) {
      // TODO - Upload original image for use in the library here
      this.setDone('first', data.nextStep);
      console.log(data);
      if (!data.catalogueImage) {
        var searchString = prompt("Please enter some text to find this image later", "");
        if (name != null) {
          this.saveImageToCatalogue({
            url: data.url,
            searchString: searchString
          });
        }
      }

      if (data.nextStep == "second") this.$refs['imageEdit'].openImageUrl(data.url);
      if (data.nextStep == "third") this.$refs['imageCrop'].openImageFromUrl(data.url);
    },
    setDone: function setDone(id, index) {
      this[id] = true;

      if (index) {
        this.active = index;
      }
      console.log(this.active);
    },

    process: function process(callback, item) {
      console.log("process", item);
      if (item.type) this.aspectRatio = this.aspectRatios[item.type];
      this.callback = callback;
      this.modalOpen = true;
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_pageList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_pageList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__widgets_pageList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_gridX__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__widgets_gridX__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ic_firebase_uploader__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ic_firebase_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ic_firebase_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ic_firebase_uploader_dist_ic_firebase_uploader_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_json__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_articleEditor__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_articleEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_articleEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_atoms_TagInput__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_atoms_TagInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_atoms_TagInput__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(687));
var _firestore;






/* harmony default export */ __webpack_exports__["default"] = ({
    name: "articles",
    components: {
        pageList: __WEBPACK_IMPORTED_MODULE_3__widgets_pageList___default.a,
        TagInput: __WEBPACK_IMPORTED_MODULE_9__common_atoms_TagInput___default.a,
        articleEditor: __WEBPACK_IMPORTED_MODULE_8__common_articleEditor___default.a,
        gridX: __WEBPACK_IMPORTED_MODULE_4__widgets_gridX___default.a,
        "ic-firebase-upload": __WEBPACK_IMPORTED_MODULE_5_ic_firebase_uploader___default.a
    },
    data: function data() {
        _firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
        return {
            storage: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage(),
            searchTerm: "",
            searchResults: [],
            articleToEditKey: false,
            tempImage: null,
            filterCategory: null,
            filterSubcategory: null,
            filterTag: null,
            filterStatus: null,
            filterByTimestamp: Date.now(),
            startAfter: null,
            categories: [],
            resetTag: false,
            subCategories: false,
            showCategory: false,
            tags: [],
            showTags: false
        };
    },

    watch: {
        filterCategory: function filterCategory(val) {
            if (val) {
                this.startAfter = false;
                this.updateFilter();
            }
        },
        filterSubcategory: function filterSubcategory(val) {

            if (val) {
                this.startAfter = false;
                this.updateFilter();
            }
        },
        filterTag: function filterTag(val) {
            console.log("filterTag", val);
            if (val) {
                this.startAfter = false;
                this.updateFilter();
            }
        },
        filterStatus: function filterStatus(val) {
            console.log("filterStatus", val);
            if (val) {
                this.startAfter = false;
                this.updateFilter();
            }
        },
        filterByTimestamp: function filterByTimestamp(val) {
            if (val == Date.now()) return;
            this.startAfter = parseInt(this.$moment(val).endOf("day").format("X"));
        },
        startAfter: function startAfter(val, oldval) {
            if (val) {
                this.updateFilter();
            }
        }
    },
    firestore: function firestore() {
        return {
            // Collection
            posts: _firestore.collection("posts").limit(20).orderBy("timestamp", "desc")
        };
    },

    mounted: function mounted() {
        var _this = this;

        this.showCategory = false;
        this.showTags = false;
        _firestore.collection("categories").get().then(function (querySnap) {
            querySnap.forEach(function (catSnap) {
                _this.categories.push(catSnap.id);
            });
            _this.showCategory = true;
        });
        _firestore.collection("tags").get().then(function (querySnap) {
            querySnap.forEach(function (tagSnap) {
                _this.tags.push(tagSnap.id);
            });
            _this.showTags = true;
        });
        var client = algoliasearch("U5GL740LVM", "ee79df2ed46df0e29f0a0e05d9d2466f");
        this.algolia = client.initIndex("posts");
    },
    methods: {
        updateTag: function updateTag(tag) {
            this.filterTag = tag;
        },
        morePosts: function morePosts() {
            this.startAfter = this.posts[this.posts.length - 1].timestamp;
            window.scrollTo(0, 0);
        },
        clearFilters: function clearFilters() {
            var _this2 = this;

            this.filterSubcategory = false;
            this.filterCategory = false;
            this.filterTag = false;
            this.filterStatus = false;
            this.startAfter = false;
            this.searchTerm = "";
            this.searchResults = [];
            this.showTags = false;
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
                _this2.showTags = true;
            });
            this.updateFilter();
        },
        updateFilter: function updateFilter() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
                var ref = _firestore.collection("posts");
                if (_this3.filterCategory) ref = ref.where("parentCategory", "==", _this3.filterCategory);
                if (_this3.filterSubcategory) ref = ref.where("subCategory", "==", _this3.filterSubcategory);
                if (_this3.filterTag) ref = ref.where("tags", "array-contains", _this3.filterTag);
                if (_this3.filterStatus) ref = ref.where("status", "==", _this3.filterStatus);

                console.log(_this3.filterStatus);
                console.log(_this3.filterCategory);
                console.log(_this3.filterSubcategory);
                console.log(_this3.filterTag);
                ref = ref.limit(20).orderBy("timestamp", "desc");
                if (_this3.startAfter) ref = ref.startAfter(_this3.startAfter);
                console.log("getting posts!");
                _this3.$binding("posts", ref);
            });
        },
        updateSubcategories: function updateSubcategories() {
            var _this4 = this;

            this.subCategories = null;
            console.log(this.filterCategory);
            _firestore.collection("categories").doc(this.filterCategory).get().then(function (docSnap) {
                var data = docSnap.data();
                console.log(data);
                var temp = [];
                data.subcategories.forEach(function (subcat) {
                    temp.push(subcat.name);
                });

                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this4, "subCategories", temp);
            });
        },
        editArticle: function editArticle(article) {
            var _this5 = this;

            _firestore.collection("postContent").where("slug", "==", article.slug).get().then(function (snap) {
                var articleData;
                if (snap.docs && snap.docs[0]) articleData = snap.docs[0].data();else {
                    alert("Couldn't find article in database");
                    return;
                }
                _this5.searchTerm = "";
                _this5.searchResults = [];
                _this5.articleToEditKey = article['.key'];
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
                    _this5.$refs['editor'].loadArticle(_this5.articleToEditKey);
                });
            });
        },
        searchForTerm: function searchForTerm() {
            var _this6 = this;

            var query = this.searchTerm;
            if (!query) {
                this.searchResults = [];
                return;
            }
            this.algolia.search({
                query: query
            }).then(function (responses) {
                _this6.searchResults = [];
                var searchResults = [];
                console.log(responses);
                responses.hits.forEach(function (hit) {
                    if (searchResults.length < 20) {
                        searchResults.push({
                            postid: hit.objectID,
                            slug: hit.slug,
                            image: hit.image,
                            title: hit.title,
                            author: hit.author,
                            tags: hit.tags,
                            timestamp: hit.timestamp,
                            categories: hit.categories

                        });
                    }
                });

                // To avoid DOM redraws repeatedly
                // Is this needed? Is Vue smart enough to not redraw when lots of pushes happen?
                _this6.searchResults = searchResults;
            });
        }
    }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalAuthor_vue__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalAuthor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalAuthor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalDelauthor_vue__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalDelauthor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalDelauthor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalEditauthor_vue__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalEditauthor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ModalEditauthor_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var _firestore;



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ModalAuthor: __WEBPACK_IMPORTED_MODULE_3__ModalAuthor_vue___default.a, ModalDelauthor: __WEBPACK_IMPORTED_MODULE_4__ModalDelauthor_vue___default.a, ModalEditauthor: __WEBPACK_IMPORTED_MODULE_5__ModalEditauthor_vue___default.a },
  data: function data() {
    _firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {
      showAuthorModal: false,
      startAfter: null,
      searchTerm: "",
      searchResults: [],
      isTyping: false
    };
  },
  watch: {
    startAfter: function startAfter(val, oldval) {
      if (val) {
        this.updateFilter();
      }
    },
    searchTerm: _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping: function isTyping(value) {
      if (!value) {
        this.searchForTerm(this.searchTerm);
      }
    }
  },
  firestore: function firestore() {
    return {
      authorData: _firestore.collection("authors").limit(20).orderBy("slug")
    };
  },

  methods: {
    showModalAddAuthor: function showModalAddAuthor() {
      this.showAuthorModal = true;
    },
    moreAuthors: function moreAuthors() {
      this.startAfter = this.authorData[this.authorData.length - 1].slug;
      window.scrollTo(0, 0);
    },
    updateFilter: function updateFilter() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
        var ref = _firestore.collection("authors");
        ref = ref.limit(20).orderBy("slug");
        if (_this.startAfter) ref = ref.startAfter(_this.startAfter);
        _this.$binding("authorData", ref);
      });
    },
    searchForTerm: function searchForTerm() {
      var _this2 = this;

      this.searchResults = [];
      this.searchTerm = this.searchTerm.toLowerCase().replace(/\s/g, '-').replace(/[^a-z0-9\-]+/gi, '');
      var strlength = this.searchTerm.length;
      var strFrontCode = this.searchTerm.slice(0, strlength - 1);
      var strEndCode = this.searchTerm.slice(strlength - 1, this.searchTerm.length);
      var endcode = strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);
      var startcode = this.searchTerm;
      _firestore.collection("authors").where('slug', '>=', startcode).where('slug', '<', endcode).limit(20).get().then(function (snapshot) {
        if (snapshot.empty) {
          console.log('No matching documents.');
          return;
        }
        snapshot.forEach(function (doc) {
          _this2.searchResults.push({
            aboutAuthor: doc.data().aboutAuthor,
            authorTagline: doc.data().authorTagline,
            displayName: doc.data().displayName,
            slug: doc.data().slug,
            authorSeoDesc: doc.data().authorSeoDesc,
            authorSeoTitle: doc.data().authorSeoTitle,
            customAvatar: doc.data().customAvatar
          });
        });
      }).catch(function (err) {
        console.log('Error getting search results for author', err);
      });
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modals_branded_ModalBranded_vue__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modals_branded_ModalBranded_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__modals_branded_ModalBranded_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modals_branded_ModalEditbrand_vue__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modals_branded_ModalEditbrand_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__modals_branded_ModalEditbrand_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modals_branded_ModalDelbrand_vue__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modals_branded_ModalDelbrand_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__modals_branded_ModalDelbrand_vue__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_firestore___default.a);
var firestore;




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ModalBranded: __WEBPACK_IMPORTED_MODULE_6__modals_branded_ModalBranded_vue___default.a, ModalEditbrand: __WEBPACK_IMPORTED_MODULE_7__modals_branded_ModalEditbrand_vue___default.a, ModalDelbrand: __WEBPACK_IMPORTED_MODULE_8__modals_branded_ModalDelbrand_vue___default.a },
  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore();
    return {
      newBrand: {
        endDate: new Date()
      },
      brandedData: [],
      showBrandedModal: false,
      probTotal: 0,
      order: {
        endDate: null,
        startDate: null
      },
      user_populations: { "New South Wales": 32, Victoria: 29.21, Queensland: 19.94, "Western Australia": 8.47, "South Australia": 7.33 }
    };
  },

  // firestore() {
  //   return {
  //     brandedData: firestore.collection("brandedArticles")
  //   };
  // },
  computed: {
    brandedDataCalculatedDelivery: function brandedDataCalculatedDelivery() {
      var _this = this;

      return this.brandedData.map(function (vt) {
        return _this.calculateDelivery(vt.data);
      });
    }
  },
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this2 = this;

      var currentDate, newDate, noOfDays;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              //console.log(this.brandedData);
              currentDate = Math.floor(Date.now() / 1000);
              newDate = new Date(this.newBrand.endDate).getTime() / 1000;
              noOfDays = Math.floor((newDate - currentDate) / 86400);

              this.brandedSubscribe = firestore.collection("brandedArticles").onSnapshot(function (snap) {
                _this2.brandedData = snap.docs.map(function (doc) {
                  return { id: doc.id, data: doc.data() };
                });
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    sort: function sort(column) {
      var _this3 = this;

      var order = this.order[column] ? 'desc' : 'asc';
      // Using firebase's 'desc' or'asc' might cause some rows to disappear if it is missing a data key newer data should have all the proper keys but if this becomes a big issue use sort method instead
      this.brandedSubscribe();

      this.brandedSubscribe = firestore.collection("brandedArticles").orderBy(column, order).onSnapshot(function (snap) {
        _this3.brandedData = snap.docs.map(function (doc) {
          return { id: doc.id, data: doc.data() };
        });
      });

      this.order[column] = !this.order[column];
      // Reset all other columns
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.order).forEach(function (item) {
        console.log("loop");
        if (item !== column) {
          _this3.order[item] = null;
        };
      });
    },
    showModalAddBranded: function showModalAddBranded() {
      //calculate the current probability total
      var useArray = this.brandedData;
      var proCount = 0;
      useArray.forEach(function (arrayItem) {
        if (arrayItem.active == true) {
          proCount = arrayItem.probability + proCount;
        }
      });
      this.probTotal = proCount;
      this.showBrandedModal = true;
    },
    getEma: function getEma(pageViewHistory) {
      if (!pageViewHistory) {
        return null;
      }
      var newArray = [];
      pageViewHistory.forEach(function (hist) {
        newArray.push(hist);
      });
      newArray.sort(function (a, b) {
        return a.timestamp > b.timestamp;
      });

      var previous = "unset";
      var values = [];

      newArray.forEach(function (data) {
        if (previous != "unset") {
          values.push({ "pageviews": data.pageviews - previous, "probability": data.probability });
        }
        previous = data.pageviews;
      });

      var count = 0;
      var dayCount = 0;
      var probability = 0;
      var totalValues = [];
      values.forEach(function (value) {
        if (count < 12) {
          dayCount += value.pageviews;
          probability += value.probability;
          count++;
        } else {
          totalValues.push(dayCount / (probability / 12));
          dayCount = value.pageviews;
          probability = value.probability;
          count = 0;
        }
      });
      var getEMA = function getEMA(a, r) {
        return a.reduce(function (p, n, i) {
          return i ? p.concat(2 * n / (r + 1) + p[p.length - 1] * (r - 1) / (r + 1)) : p;
        }, [a[0]]);
      };

      var range = Math.round(totalValues.length / 4);
      if (range < 2) range = 2;
      var ema = getEMA(totalValues, 2);

      return ema[ema.length - 1];
    },
    calculateDelivery: function calculateDelivery(item) {
      var probability = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      console.log(item);
      if (!item.active || !item.pageViewHistory || item.pageViewHistory.length < 24) {
        return false;
      }

      var emaRate = this.getEma(item.pageViewHistory);

      var currentDate = Math.floor(Date.now() / 1000);
      var newDate = new Date(item.endDate).getTime() / 1000;
      var startDate = item.pageViewHistory[0].timestamp.getTime() / 1000;

      var daysLeft = Math.floor((newDate - currentDate) / 86400);
      var daysPast = Math.floor((currentDate - startDate) / 86400);
      var expectedPageViewsPerDay = emaRate * (probability ? probability : item.probability) * 0.9; // Pessimism
      var likelyTotal = item.pageviews ? daysLeft * expectedPageViewsPerDay + item.pageviews : daysLeft * expectedPageViewsPerDay;
      var likelyPercent = Math.round(likelyTotal / item.pageviews * 100);
      return likelyPercent;
      // expectedPageViewsPerDay and pvPerDay are almost the same thing but have to deal with the fact that there may not be a startDay or ema. Will need to think of better names.
      // const expectedPageViewsPerDay = daysPast > 0 ? item.currentPageviews/daysPast : item.currentPageviews;
      // const pvPerDay = ema ? ema : expectedPageViewsPerDay;
      // const likelyTotal = item.otherPageviews ?  (daysLeft * pvPerDay) + item.otherPageviews : daysLeft * pvPerDay;
      // const likelyPercent = Math.round(likelyTotal / item.pageviews * 100);
      // return likelyPercent;
    },
    recommendedProbability: function recommendedProbability(item, index) {
      if (!item.active) {
        return false;
      }
      var recommendedProbability = 0;
      var calculateDelivery = this.brandedDataCalculatedDelivery[index];
      if (calculateDelivery) {
        recommendedProbability = 100 / calculateDelivery;
      } else {
        return false;
      }

      var target = Math.round(recommendedProbability * item.probability * 100) / 100;
      if (this.calculateDelivery(item, target) < 100) target = Math.round((target + 0.01) * 100) / 100;
      console.log("loop", index);

      return target;
    },
    updateProbability: function updateProbability(item, index) {
      var newProbability = this.recommendedProbability(item, index);
      firestore.collection("brandedArticles").where("url", "==", "" + item.url).get().then(function (snap) {
        var data = snap.docs[0];
        firestore.collection("brandedArticles").doc(data.id).update({
          probability: newProbability
        }).then(function () {});
      });
    },
    adjustProbForState: function adjustProbForState(item) {
      var location_amount = this.user_populations[item.location] * 100 * (item.probability / 100);
      var difference = item.probability / 100 * 10000 / location_amount;
      return "(State Adjustment: " + (item.probability * difference).toFixed(2) + ")";
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_gridX__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__widgets_gridX__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_firestore___default.a);
var _firestore;



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { gridX: __WEBPACK_IMPORTED_MODULE_4__widgets_gridX___default.a },
  props: ["podcasts"],
  firestore: function firestore() {
    return {
      // Collection
      categories: _firestore.collection("categories")
    };
  },

  data: function data() {
    _firestore = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();
    return {
      currentCat: {
        podcasts: []
      },
      currentCatObj: {}
    };
  },
  methods: {
    addPodcast: function addPodcast() {
      if (!this.currentCat.podcasts) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.currentCat, "podcasts", [{ playlist: {} }]);
        return;
      }

      this.currentCat.podcasts.push({ playlist: {} });
    },
    saveCurrentCat: function saveCurrentCat() {
      var clone = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.currentCatObj);
      delete clone[".key"];
      this.$firestore.categories.doc(this.currentCatObj[".key"]).update(clone);
    },
    activeClass: function activeClass(a, b) {
      if (a == b) return "active";
      return "";
    },
    updateCacheCategories: function updateCacheCategories() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("posts").orderBy("timestamp", "desc").limit(1500).get().then(function (postSnap) {
        var postArray = postSnap.docs.map(function (doc) {
          return doc.data();
        });
        postArray.forEach(function (post) {
          var foundCat = false;
          if (!post.parentCategory || post.type != "post") return;
          for (var i in _this.categories) {
            if (_this.categories[i].name == post.parentCategory) {
              foundCat = true;
              if (!post.subCategory || post.subCategory == "") break;
              var foundSub = false;
              if (_this.categories[i].subcategories) {
                _this.categories[i].subcategories.some(function (subcat) {
                  if (subcat.name == post.subCategory) {
                    foundSub = true;
                    return true;
                  }
                });
                if (!foundSub) {
                  _this.categories[i].subcategories.push({
                    name: post.subCategory
                  });
                }
              } else {
                _this.categories[i].subcategories = [{
                  name: post.subCategory
                }];
              }

              break;
            }
          }
          if (!foundCat) {
            var catObj = {
              name: post.parentCategory
            };
            if (post.subCategory && post.subCategory != "") {
              catObj.subcategories = [{
                name: post.subCategory
              }];
            }

            __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("categories").doc(post.parentCategory).set(catObj);
          }
        });
      }).then(function () {
        console.log(_this.categories);
        for (var i in _this.categories) {
          if (_this.categories[i].subcategories) {
            __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("categories").doc(_this.categories[i][".key"]).update({
              subcategories: _this.categories[i].subcategories
            });
          }
        }
      });
    },
    selected: function selected() {
      this.$refs.addPodCastSelector.style.setProperty("--inputColor", "aliceblue");
    },
    changeColor: function changeColor() {
      this.$refs.addPodcastSelector.style.setProperty("--inputColor", "black");
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_pageList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_pageList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__widgets_pageList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__widgets_gridX__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__widgets_gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__widgets_gridX__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_articleWidgets_Froala__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_articleWidgets_Froala___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_articleWidgets_Froala__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ic_firebase_uploader__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ic_firebase_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_ic_firebase_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ic_firebase_uploader_dist_ic_firebase_uploader_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_atoms_TagInput__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_atoms_TagInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_atoms_TagInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_json__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__config_json__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  TODO:
    Create post button pieces together html and creates a post object
      Implement Form render outputting HTML for the above
      Prevent slug collisions
    Save to competitions database
      Save format for form builder / froala content
    Data validation
    View Results
      Preview of data in table (first 20 rows?)
        Ability to delete a row (test data)
      Export all data to CSV
*/




__webpack_require__(4);


__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_firestore___default.a);
var _firestore;






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    pageList: __WEBPACK_IMPORTED_MODULE_6__widgets_pageList___default.a,
    FroalaEditor: __WEBPACK_IMPORTED_MODULE_8__common_articleWidgets_Froala___default.a,
    gridX: __WEBPACK_IMPORTED_MODULE_7__widgets_gridX___default.a,
    "ic-firebase-upload": __WEBPACK_IMPORTED_MODULE_9_ic_firebase_uploader___default.a,
    TagInput: __WEBPACK_IMPORTED_MODULE_11__common_atoms_TagInput___default.a
  },
  firestore: function firestore() {
    return {
      // Collection
      competitions: _firestore.collection("competitions"),
      categories: _firestore.collection("categories")
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.tags = [];
    __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore().collection("tags").get().then(function (querySnap) {
      querySnap.forEach(function (tagSnap) {
        _this.tags.push(tagSnap.id);
      });
      _this.showTags = true;
    });
  },

  data: function data() {
    _firestore = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore();
    return {
      storage: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage(),
      results: [],
      newCompetition: {
        meta: {
          title: "",
          description: ""
        }
      },
      tags: [],
      selectedCompetitionKey: "",
      selectedCompetition: {
        status: "",
        meta: {
          title: "",
          description: ""
        }
      },
      formBuilder: null,
      //selectedCompetition: false,
      currentTab: "post",
      showNewCompetition: false,
      categoryChanged: false,
      debounceSlug: false,
      checkSlugRandom: null,
      slugValid: "",
      changeCat: false,
      subCategories: null
    };
  },
  watch: {
    selectedCompetitionKey: function selectedCompetitionKey(val) {
      var _this2 = this;

      // Binding Docs
      this.$binding("selectedCompetition", _firestore.collection("competitions").doc(val)).then(function (ford) {
        _this2.selected();
      }).catch(function (err) {
        console.error(err);
      });
    }
  },
  methods: {
    addTag: function addTag(event) {
      this.selectedCompetition.tags.push(event);
    },
    updateTags: function updateTags(event) {
      this.selectedCompetition.tags = event;
    },
    selectCategory: function selectCategory() {
      var _this3 = this;

      var catRef = _firestore.collection("categories").doc(this.selectedCompetition.parentCategory);
      var getSubCat = catRef.get().then(function (doc) {
        if (!doc.exists) {
          console.log("No such document!");
        } else {
          _this3.subCategories = doc.data().subcategories;
        }
      }).catch(function (err) {
        console.log("Error getting document", err);
      });
      this.categoryChanged = false;
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].nextTick(function () {
        _this3.categoryChanged = true;
      });
    },
    checkSlug: function checkSlug() {
      var _this4 = this;

      if (this.debounceSlug) clearTimeout(this.debounceSlug);
      this.slugValid = "searching";
      this.debounceSlug = setTimeout(function () {
        var localCheckSlugRandom = Math.random();
        _this4.checkSlugRandom = localCheckSlugRandom;
        _firestore.collection("posts").where("slug", "==", _this4.selectedCompetition.slug).get().then(function (querySnapshot) {
          if (localCheckSlugRandom != _this4.checkSlugRandom) return;
          if (!querySnapshot.empty) {
            _this4.slugValid = "invalid";
          } else {
            _this4.slugValid = "valid";
          }
        });
      }, 500);
    },
    setupFroala: function setupFroala(currentData) {
      var _this5 = this;

      setTimeout(function () {
        console.log(currentData);
        var fbEditor = document.getElementById("fb-editor");
        //Removing the existing formbuilder
        var testForm = $("#fb-editor").find(".form-builder");
        if (testForm.length !== 0) {
          $(testForm).remove();
        }
        //Create new formbuilder based on whether there is existing data or not.
        if (currentData.formData) {
          var options = {
            formData: currentData.formData,
            dataType: "json"
          };
          _this5.formBuilder = $(fbEditor).formBuilder(options);
        } else {
          var defaultData = '[    {      "type": "textarea",      "required": true,      "label": "Tell us in 25 words or less........",      "className": "form-control",      "name": "textarea-1549837574814",      "subtype": "textarea",      "rows": "4"    },    {      "type": "text",      "required": true,      "label": "First Name",      "className": "form-control",      "name": "text-1549837609949",      "subtype": "text"    },    {      "type": "text",      "label": "Last Name",      "className": "form-control",      "name": "text-1549837627270",      "subtype": "text"    },    {      "type": "number",      "required": true,      "label": "Contact Number",      "className": "form-control",      "name": "number-1549837647059"    },    {      "type": "text",      "required": true,      "label": "Email",      "className": "form-control",      "name": "text-1549837662055",      "subtype": "text"    },    {      "type": "text",      "label": "Postcode",      "className": "form-control",      "name": "text-1549837729241",      "subtype": "text"    },    {      "type": "checkbox-group",      "label": "Please tick to confirm",      "name": "checkbox-group-1549837744924",      "values": [        {          "label": "I have read and agree to the Terms and Conditions",          "value": "option-terms"        },        {          "label": "I am over the age of 18",          "value": "option-age"        }      ]    },    {      "type": "button",      "subtype": "submit",      "label": "SUBMIT",      "className": "btn-default btn",      "name": "button-1554096713544",      "style": "default"    }  ]';
          var options = {
            formData: defaultData,
            dataType: "json"
          };
          _this5.formBuilder = $(fbEditor).formBuilder(options);
        }
      }, 100);
    },
    activeClass: function activeClass(a, b) {
      if (a == b) return "active";
      return "";
    },
    createCompetition: function createCompetition() {
      var errorMessage = "";
      if (!this.newCompetition.name) {
        errorMessage = "Missing Competition Name";
      }
      if (errorMessage) {
        alert(errorMessage);
        return;
      }
      this.newCompetition.status = "draft";
      this.$firestore.competitions
      // .doc(this.newCompetition.key)
      .add(this.newCompetition);
      alert("Competition created");
      this.newCompetition = {
        meta: {
          title: "",
          description: ""
        }
      };
    },
    saveCompData: function saveCompData() {
      var errorMessage = "";
      if (!this.selectedCompetition["name"]) {
        errorMessage = "Missing Competition Name";
      }
      if (!this.selectedCompetition["slug"]) {
        errorMessage = "Missing Competition Slug";
      }
      if (!this.selectedCompetition.title) {
        errorMessage = "Post Title is missing";
      }
      if (errorMessage) {
        alert(errorMessage);
        return false;
      }
      var formData = this.formBuilder.actions.getData("json");
      var textEntered = this.selectedCompetition.writtenContent;

      // Grab markup and escape it
      var $markup = $("<div/>");
      $markup.formRender({ formData: formData });

      var scripts = "\n        var s = document.createElement(\"script\");\n        s.setAttribute(\"src\", \"https://code.jquery.com/jquery-3.4.1.min.js\");\n        s.setAttribute(\"async\", true);\n\n        s.onload = () => {\n          $('.fb-button button').click(function(event) {\n              $('#form-error').html(\"\");\n              var data = {};\n          ";
      formData = JSON.parse(formData);
      formData.forEach(function (input) {
        switch (input.type) {
          case "text":
          case "number":
          case "select":
          case "textarea":
            scripts += "data['" + $($.parseHTML(input.label)).text() + "'] = $('#" + $($.parseHTML(input.name)).text() + "').val();";
            if (input.required) scripts += "if(!data['" + $($.parseHTML(input.label)).text() + "']) { $('#form-error').html(\"<i>" + $($.parseHTML(input.label)).text() + "</i> is a required field.\"); return; }";

            break;
          case "checkbox-group":
            scripts += "var stopLoop = false;";
            input.values.forEach(function (checkbox, index) {
              scripts += "var checkValue = $('#" + $($.parseHTML(checkbox.name)).text() + "-" + index + "').val();";
              if (input.required) scripts += "if(!checkValue) { $('#form-error').html(\"<i>" + $($.parseHTML(checkbox.label)).text() + "</i> is a required field.\"); stopLoop = true; }";
              scripts += "data[checkValue] = true;";
            });
            scripts += "if(stopLoop) return;";
            break;
        }
      });
      scripts += "\n      $('#submit-success').hide();\n      $('#submit-processing').show();\n      data.compId = '" + this.selectedCompetition[".key"] + "';\n      $.ajax({\n          method: 'POST',\n          url: 'https://us-central1-" + __WEBPACK_IMPORTED_MODULE_12__config_json___default.a.firebase.projectId + ".cloudfunctions.net/submitCompetition',\n          data: JSON.stringify(data),\n          contentType: 'application/json',\n          dataType: 'json',\n          processData: false,\n          success:function() {\n              console.log('form success');\n              $('.rendered-form').hide();\n              $('#submit-processing').hide();\n              $('#submit-success').show();\n          },\n      failure: function(err) {\n              $('#submit-processing').hide();\n              $('#form-error').html('There was an issue submitting the form. Please try again later.');\n        console.log(err);\n      }\n        });\n      });\n      };\n      document.getElementsByTagName(\"head\")[0].appendChild(s);";
      var formHtml = $markup.formRender("html");
      var contentHtml = textEntered + formHtml + "<div id=\"form-error\"></div>\n        <div id=\"submit-processing\" style=\"display:none;\">Submitting...</div>\n        <div id=\"submit-success\" style=\"display:none;\">Success! Your entry has been submitted.</div>";

      var ampHtml = textEntered + (" <form method=\"post\"\n          action-xhr=\"https://us-central1-" + __WEBPACK_IMPORTED_MODULE_12__config_json___default.a.firebase.projectId + ".cloudfunctions.net/submitForm\"\n          target=\"_top\">") + formHtml + ("  <input type=\"hidden\" id=\"compId\" name=\"compId\" value=\"" + this.selectedCompetition[".key"] + "\">\n        <div submit-success>\n          <template type=\"amp-mustache\">\n            Submission successful!\n          </template>\n        </div>\n        <div submitting>\n          <template type=\"amp-mustache\">\n            Submitting...\n          </template>\n        </div>\n        <div submit-error>\n          <template type=\"amp-mustache\">\n            Submission failed, please try again later.\n          </template>\n        </div>\n      </form>");

      var tempObj = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.selectedCompetition);
      delete tempObj[".key"];
      tempObj.type = "competitions";
      tempObj.categories = [this.selectedCompetition.parentCategory, this.selectedCompetition.subCategory];
      tempObj.scripts = scripts;
      tempObj.formData = formData;
      tempObj.content = contentHtml;
      tempObj.ampContent = ampHtml;
      tempObj.writtenContent = textEntered;
      console.log("this is submit comp");
      //console.log(submitcomp);
      this.$firestore.competitions.doc(this.selectedCompetition[".key"]).update(tempObj);
      $("ul.ic-fb_uploader-files > li").hide();
      return true;
    },
    getResults: function getResults() {
      var _this6 = this;

      _firestore.collection("competitions").doc(this.selectedCompetition[".key"]).collection("results").get().then(function (snap) {
        _this6.results = snap.docs.map(function (doc) {
          return doc.data();
        });
      });
    },
    onUploadedCompImage: function onUploadedCompImage(e, attrib) {
      var _this7 = this;

      e.getDownloadURL().then(function (url) {
        _this7.selectedCompetition[attrib] = url;
      });
    },
    onUpload: function onUpload(e) {
      e.doUpload();
    },
    onDelete: function onDelete(e) {
      e.doDelete();
    },
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    selected: function selected() {
      this.slugValid = "";
      this.$refs.competitionSelector.style.setProperty("--inputColor", "aliceblue");
      this.setupFroala(this.selectedCompetition);
      if (this.selectedCompetition.parentCategory) {
        this.selectCategory();
      }
      if (!this.selectedCompetition.meta) this.selectedCompetition.meta = { title: "", description: "" };
    },
    changeColor: function changeColor() {
      this.$refs.competitionSelector.style.setProperty("--inputColor", "black");
    },
    publishCompetition: function publishCompetition() {
      var result = this.saveCompData();
      if (!result) return;
      this.$firestore.competitions.doc(this.selectedCompetition[".key"]).update({
        status: "publish"
      });
      // set published true
    },
    previewCompetition: function previewCompetition() {
      var result = this.saveCompData();
      if (!result) return;
      this.$firestore.competitions.doc(this.selectedCompetition[".key"]).update({
        status: "preview"
      });
      // set published true
    },
    unpublishCompetition: function unpublishCompetition() {
      var confirm = window.confirm("Are you sure you would like to UNPUBLISH this competition? The page URL will no longer function.");
      if (confirm) {
        this.$firestore.competitions.doc(this.selectedCompetition[".key"]).update({
          status: "draft"
        });
      }

      // set published false
    },
    exportCsv: function exportCsv() {
      var items = this.results;
      var replacer = function replacer(key, value) {
        return value === null ? "" : value;
      }; // specify how you want to handle null values here
      var header = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(items[0]);
      var csv = items.map(function (row) {
        return header.map(function (fieldName) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(row[fieldName], replacer);
        }).join(",");
      });
      csv.unshift(header.join(","));
      csv = csv.join("\r\n");

      //Download the file as CSV
      var downloadLink = document.createElement("a");
      var blob = new Blob(["\uFEFF", csv]);
      var url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = "DataDump.csv"; //Name the file here
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    getSeletedTags: function getSeletedTags(query) {
      if (query) {
        this.searchTags(query);
      }
    }
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_articleEditor__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_articleEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_articleEditor__);
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    articleEditor: __WEBPACK_IMPORTED_MODULE_1__common_articleEditor___default.a
  },
  data: function data() {
    return {
      blankArticle: {
        layout: "article-layout-default",
        title: "",
        content: "",
        name: "",
        tags: [],
        widgets: [],
        type: "post",
        seoPhrase: "",
        status: "draft",
        timestamp: Math.floor(Date.now() / 1000),
        slug: "",
        meta: {
          title: "",
          description: ""
        }
      }
    };
  },
  mounted: function mounted() {
    this.$refs['editor'].initialiseArticle();
  },
  methods: {}
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_gridX__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__widgets_gridX__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { gridX: __WEBPACK_IMPORTED_MODULE_1__widgets_gridX___default.a },
  data: function data() {
    return {
      previewImage: "",
      showUploader: "",
      heroImage: "",
      heroText: "",
      columns: "1fr 1fr",
      showPreview: false
    };
  },

  methods: {
    processPreviewImage: function processPreviewImage(event) {
      var _this = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "hero";

      var previewThis = source === "hero" ? "heroImage" : "previewImage";
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          console.log(e);
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this, previewThis, e.target.result);
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this, previewThis, "");
      }
    },
    clearUploader: function clearUploader() {
      this.$refs.fileUpload.value = "";
    },
    switchHero: function switchHero(arg) {
      if (arg === "desktop") {
        return this.$refs.hero.classList.add("desktop");
      }

      return this.$refs.hero.classList.remove("desktop");
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_asyncIterator__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_asyncIterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_asyncIterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalButton_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ModalButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widgets_gridX__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widgets_gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__widgets_gridX__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ic_firebase_uploader__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ic_firebase_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_ic_firebase_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ic_firebase_uploader_dist_ic_firebase_uploader_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_firestore___default.a);
var _firestore;




var Parser = __webpack_require__(550);
var parser = new Parser();




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { "ic-firebase-upload": __WEBPACK_IMPORTED_MODULE_9_ic_firebase_uploader___default.a, gridX: __WEBPACK_IMPORTED_MODULE_8__widgets_gridX___default.a, ModalButton: __WEBPACK_IMPORTED_MODULE_6__ModalButton_vue___default.a },
  data: function data() {
    _firestore = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.firestore();
    return {
      storage: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage(),
      podcastEpisodes: [],
      editPodcast: {
        key: "",
        obj: {}
      },
      editPodcastMode: false,
      newPodcast: {
        key: "",
        obj: {
          rss: "",
          title: "",
          image: ""
        }
      },
      selectedPodcast: "",
      showNewPodcast: false
    };
  },
  firestore: function firestore() {
    return {
      // Collection
      podcasts: _firestore.collection("podcasts")
    };
  },

  methods: {
    onUploadedPodcastImage: function onUploadedPodcastImage(e) {
      var _this = this;

      console.log(e);
      e.getDownloadURL().then(function (url) {
        _this.editPodcast.obj.overrideImage = url;
        _this.$firestore.podcasts.doc(_this.editPodcast.key).update({
          overrideImage: url
        });
      });
    },
    onUploadedPodcastSocialImage: function onUploadedPodcastSocialImage(e) {
      var _this2 = this;

      console.log(e);
      e.getDownloadURL().then(function (url) {
        _this2.editPodcast.obj.socialImage = url;
        _this2.$firestore.podcasts.doc(_this2.editPodcast.key).update({
          socialImage: url
        });
      });
    },
    onUploadedEpisodeImage: function onUploadedEpisodeImage(e, item) {
      console.log(e);
      e.getDownloadURL().then(function (url) {
        _firestore.collection("podcastEpisodes").doc(item[".key"]).update({
          overrideImage: url
        });
      });
    },
    onUploadedEpisodeSocialImage: function onUploadedEpisodeSocialImage(e, item) {
      console.log(e);
      e.getDownloadURL().then(function (url) {
        _firestore.collection("podcastEpisodes").doc(item[".key"]).update({
          socialImage: url
        });
      });
    },
    promptFiles: function promptFiles(key) {
      this.$refs[key].promptFiles();
    },
    onUpload: function onUpload(e) {
      e.doUpload();
    },
    onDelete: function onDelete(e) {
      e.doDelete();
    },
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    editPodcastItem: function editPodcastItem(item) {
      this.editPodcastMode = true;
      this.editPodcast = { key: item[".key"], obj: item };
      console.log(this.editPodcast);
      this.$binding("podcastEpisodes", _firestore.collection("podcastEpisodes").where("podcast", "==", item[".key"]).orderBy("timestamp", "desc"));
    },
    rssDurationToSeconds: function rssDurationToSeconds(duration) {
      // var splitDuration = duration.split(":");
      // return (parseInt(splitDuration[0]) * 3600) + (parseInt(splitDuration[1]) * 60) + parseInt(splitDuration[2]);
      return parseInt(duration);
    },
    updateCacheEpisode: function updateCacheEpisode(item) {
      var _this3 = this;

      var podcast = this.podcasts.find(function (x) {
        return x['.key'] === item.podcast;
      });
      parser.parseURL(podcast.rss).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(response) {
          var playlistItem, deleteItem;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  console.log("response", response);

                  playlistItem = response.items.find(function (x) {
                    return (/[^/]*$/.exec(x.link)[0] === item.slug
                    );
                  });

                  if (playlistItem) {
                    _context.next = 10;
                    break;
                  }

                  deleteItem = confirm("Episode not found, delete?");

                  if (!deleteItem) {
                    _context.next = 8;
                    break;
                  }

                  console.log("deleting");
                  _context.next = 8;
                  return _firestore.collection("podcastEpisodes").doc(item[".key"]).delete();

                case 8:
                  _context.next = 12;
                  break;

                case 10:
                  _context.next = 12;
                  return _firestore.collection("podcastEpisodes").doc(podcast[".key"] + "-" + /[^/]*$/.exec(playlistItem.link)[0]).get().then(function (data) {
                    var dataObj = {
                      podcast: podcast[".key"],
                      title: playlistItem.title,
                      content: playlistItem.content,
                      timestamp: __WEBPACK_IMPORTED_MODULE_7_moment___default()(playlistItem.isoDate).format("X"),
                      url: playlistItem.enclosure.url,
                      image: playlistItem.itunes.image,
                      duration: _this3.rssDurationToSeconds(playlistItem.itunes.duration),
                      slug: /[^/]*$/.exec(playlistItem.link)[0]
                    };
                    if (data.exists) {
                      _firestore.collection("podcastEpisodes").doc(podcast[".key"] + "-" + /[^/]*$/.exec(playlistItem.link)[0]).update(dataObj);
                    } else {
                      _firestore.collection("podcastEpisodes").doc(podcast[".key"] + "-" + /[^/]*$/.exec(playlistItem.link)[0]).set(dataObj);
                    }
                  });

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    updateCachePodcast: function updateCachePodcast() {
      var _this4 = this;

      this.podcasts.forEach(function (podcast) {
        parser.parseURL(podcast.rss).then(function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _value, dataObj, result, _ret;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    console.log(response);
                    _firestore.collection("podcasts").doc(podcast[".key"]).update({
                      latest: {
                        podcast: podcast[".key"],
                        title: response.items[0].title,
                        content: response.items[0].content,
                        timestamp: __WEBPACK_IMPORTED_MODULE_7_moment___default()(response.items[0].isoDate).format("X"),
                        url: response.items[0].enclosure.url,
                        image: response.items[0].itunes.image,
                        duration: _this4.rssDurationToSeconds(response.items[0].itunes.duration),
                        slug: /[^/]*$/.exec(response.items[0].link)[0]
                      },
                      count: response.items.length
                    });

                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context3.prev = 5;
                    _loop = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _loop() {
                      var playlistItem;
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _loop$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              playlistItem = _value;
                              dataObj = {
                                podcast: podcast[".key"],
                                title: playlistItem.title,
                                content: playlistItem.content,
                                timestamp: __WEBPACK_IMPORTED_MODULE_7_moment___default()(playlistItem.isoDate).format("X"),
                                url: playlistItem.enclosure.url,
                                image: playlistItem.itunes.image,
                                duration: _this4.rssDurationToSeconds(playlistItem.itunes.duration),
                                slug: /[^/]*$/.exec(playlistItem.link)[0]
                              };

                              console.log("requesting next one");
                              _context2.next = 5;
                              return _firestore.collection("podcastEpisodes").doc(podcast[".key"] + "-" + /[^/]*$/.exec(playlistItem.link)[0]).get().then(function (data) {
                                if (data.exists) {
                                  console.log("old");
                                  // firestore
                                  //   .collection("podcastEpisodes")
                                  //   .doc(
                                  //     podcast[".key"] +
                                  //       "-" +
                                  //       /[^/]*$/.exec(playlistItem.link)[0]
                                  //   )
                                  //   .update(dataObj);
                                  return false;
                                } else {
                                  console.log("new");
                                  _firestore.collection("podcastEpisodes").doc(podcast[".key"] + "-" + /[^/]*$/.exec(playlistItem.link)[0]).set(dataObj);
                                  return true;
                                }
                              });

                            case 5:
                              result = _context2.sent;

                              console.log(result);

                              if (result) {
                                _context2.next = 9;
                                break;
                              }

                              return _context2.abrupt("return", "break");

                            case 9:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _loop, _this4);
                    });
                    _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_asyncIterator___default()(response.items);

                  case 8:
                    _context3.next = 10;
                    return _iterator.next();

                  case 10:
                    _step = _context3.sent;
                    _iteratorNormalCompletion = _step.done;
                    _context3.next = 14;
                    return _step.value;

                  case 14:
                    _value = _context3.sent;

                    if (_iteratorNormalCompletion) {
                      _context3.next = 23;
                      break;
                    }

                    return _context3.delegateYield(_loop(), "t0", 17);

                  case 17:
                    _ret = _context3.t0;

                    if (!(_ret === "break")) {
                      _context3.next = 20;
                      break;
                    }

                    return _context3.abrupt("break", 23);

                  case 20:
                    _iteratorNormalCompletion = true;
                    _context3.next = 8;
                    break;

                  case 23:
                    _context3.next = 29;
                    break;

                  case 25:
                    _context3.prev = 25;
                    _context3.t1 = _context3["catch"](5);
                    _didIteratorError = true;
                    _iteratorError = _context3.t1;

                  case 29:
                    _context3.prev = 29;
                    _context3.prev = 30;

                    if (!(!_iteratorNormalCompletion && _iterator.return)) {
                      _context3.next = 34;
                      break;
                    }

                    _context3.next = 34;
                    return _iterator.return();

                  case 34:
                    _context3.prev = 34;

                    if (!_didIteratorError) {
                      _context3.next = 37;
                      break;
                    }

                    throw _iteratorError;

                  case 37:
                    return _context3.finish(34);

                  case 38:
                    return _context3.finish(29);

                  case 39:
                    ;
                    console.log("done this one");

                  case 41:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee2, _this4, [[5, 25, 29, 39], [30,, 34, 38]]);
          }));

          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
      console.log("done all");
    },
    timestampToDate: function timestampToDate(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default.a.unix(timestamp).format("YYYY-MM-DD");
    },
    removePodcastItem: function removePodcastItem(item) {
      var message = "Are you sure you would like to remove " + item.title + "?";
      if (window.confirm(message)) {
        this.$firestore.podcasts.doc(item[".key"]).delete();
      };
    },
    createPodcast: function createPodcast() {
      var errorMessage = "";
      if (!this.newPodcast.key) {
        errorMessage = "Missing key";
      }
      if (!this.newPodcast.obj.rss) {
        errorMessage = "Missing RSS";
      }
      if (!this.newPodcast.obj.title) {
        errorMessage = "Missing Title";
      }
      if (errorMessage) {
        alert(errorMessage);
        return;
      }
      this.$firestore.podcasts.doc(this.newPodcast.key).set(this.newPodcast.obj);
      this.newPodcast = {
        key: "",
        obj: {
          rss: "",
          title: ""
        }
      };
    },

    executeEditPodcast: function executeEditPodcast() {
      var errorMessage = "";
      if (!this.editPodcast.key) {
        errorMessage = "Missing key";
      }
      if (!this.editPodcast.obj.rss) {
        errorMessage = "Missing RSS";
      }
      if (!this.editPodcast.obj.title) {
        errorMessage = "Missing Title";
      }
      if (errorMessage) {
        alert(errorMessage);
        return;
      }
      this.$firestore.podcasts.doc(this.editPodcast.key).set(this.editPodcast.obj);
      this.editPodcast = {
        key: "",
        obj: {
          rss: "",
          title: ""
        }
      };
      this.editPodcastMode = false;
    },
    selected: function selected() {
      this.$refs.podcastSelector.style.setProperty("--inputColor", "aliceblue");
    },
    changeColor: function changeColor() {
      this.$refs.podcastSelector.style.setProperty("--inputColor", "black");
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_gridX__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_gridX__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "redirects",
  components: {
    gridX: __WEBPACK_IMPORTED_MODULE_2__widgets_gridX___default.a
  },
  props: ["storage"],
  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {
      newRedirectRegex: {
        from: "",
        to: ""
      },
      newRedirectString: {
        from: "",
        to: ""
      }
    };
  },
  firestore: function (_firestore) {
    function firestore() {
      return _firestore.apply(this, arguments);
    }

    firestore.toString = function () {
      return _firestore.toString();
    };

    return firestore;
  }(function () {
    return {
      redirectStrings: firestore.collection("redirects").doc("strings").collection("list"),
      redirectRegex: firestore.collection("redirects").doc("regex").collection("list")
    };
  }),

  methods: {
    createRedirectRegex: function createRedirectRegex() {
      this.$firestore.redirectRegex.add(this.newRedirectRegex);
    },
    createRedirectString: function createRedirectString() {
      this.$firestore.redirectStrings.add(this.newRedirectString);
    },
    removeRedirectRegex: function removeRedirectRegex(item) {
      this.$firestore.redirectRegex.doc(item[".key"]).delete();
    },
    removeRedirectString: function removeRedirectString(item) {
      this.$firestore.redirectStrings.doc(item[".key"]).delete();
    }
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_pageList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_pageList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_pageList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_gridX__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__widgets_gridX__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_seoTagInput__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_seoTagInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__widgets_seoTagInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_atoms_SearchDropdown__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_atoms_SearchDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_atoms_SearchDropdown__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


__webpack_require__(4);
var _firestore;





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["pages"],
  components: {
    pageList: __WEBPACK_IMPORTED_MODULE_2__widgets_pageList___default.a,
    gridX: __WEBPACK_IMPORTED_MODULE_3__widgets_gridX___default.a,
    seoTagInput: __WEBPACK_IMPORTED_MODULE_4__widgets_seoTagInput___default.a,
    SearchDropdown: __WEBPACK_IMPORTED_MODULE_5__common_atoms_SearchDropdown___default.a
  },
  data: function data() {
    _firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {
      storage: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage(),
      pageSEO: {
        title: "",
        description: "",
        socialImage: ""
      },
      selected: {
        page: "",
        tag: ""
      },
      newTag: "",
      currentPageSEO: {
        disable: true
      },
      searchTagSEO: {},
      db: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore(),
      search: "",
      editTagSEO: false,
      tags: []
    };
  },
  firestore: function firestore() {
    return {
      pages: _firestore.collection("pages")
    };
  },
  mounted: function mounted() {
    this.getSEOTags();
  },

  methods: {
    getDropdownQuery: function getDropdownQuery(query) {
      if (query) {
        this.searchTags(query);
      }
    },

    activeClass: function activeClass(a, b) {
      if (a == b) return "active";
      return "";
    },
    getSEOTags: function getSEOTags() {
      var _this = this;

      var seoTagsRef = this.db.collection("seo").doc("tags").collection("meta");
      seoTagsRef.get().then(function (item) {
        var allTags = item.docs.map(function (tag) {

          return tag.id;
        });
        _this.tags = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(allTags));
      });
    },
    selectPageSEO: function selectPageSEO(item) {
      this.editTagSEO = false;
      var key = item[".key"];
      this.$binding("currentPageSEO", __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore().collection("pages").doc(key));
      this.currentPageKey = key;
      this.selected.page = item.name;
      this.selected.tag = "";
      this.search = "";
      this.currentPageSEO.disable = false;
    },
    savePageSEO: function savePageSEO() {
      var _this2 = this;

      var updateObj = {
        seoTitle: "",
        seoDescription: "",
        socialImage: ""
      };
      if (this.currentPageSEO.seoTitle) updateObj.seoTitle = this.currentPageSEO.seoTitle;
      if (this.currentPageSEO.seoDescription) updateObj.seoDescription = this.currentPageSEO.seoDescription;
      if (this.currentPageSEO.socialImage) updateObj.socialImage = this.currentPageSEO.socialImage;

      this.$firestore.currentPageSEO.update(updateObj).then(function () {
        console.log("Document successfully updated!");
        _this2.currentPageSEO = {};
        _this2.selected.page = "";
        _this2.currentPageSEO.disable = true;
      });
    },
    updateSearchedTag: function updateSearchedTag() {
      var _this3 = this;

      this.db.collection("seo").doc("tags").collection("meta").doc("" + (this.search || this.selected.tag)).set({
        seoTitle: this.currentPageSEO.seoTitle,
        seoDescription: this.currentPageSEO.seoDescription,
        seoImage: this.currentPageSEO.seoImage
      }).then(function () {
        console.log("Document successfully written!");
        _this3.search = "";
        _this3.currentPageSEO = {};
        _this3.selected.tag = "";
        _this3.currentPageSEO.disable = true;
        _this3.getSEOTags();
      }).catch(function (error) {
        console.error("Error writing document: ", error);
      });
    },
    createTagSeo: function createTagSeo() {
      this.selected.tag = this.newTag;
      this.newTag = "";
      this.currentPageSEO = {
        seoTitle: "",
        seoDescription: "",
        seoImage: ""
      };
      this.editTagSEO = true;
      this.currentPageSEO.disable = false;
    },
    searchTags: function searchTags(query) {
      var _this4 = this;

      console.log(query);
      this.$refs.pageList.page = "";
      this.editTagSEO = true;
      this.selected.page = "";
      var lowerCasedQuery = query.toLowerCase();
      var seoTagsRef = this.db.collection("seo").doc("tags").collection("meta");
      seoTagsRef.doc("" + lowerCasedQuery).get().then(function (item) {
        _this4.selected.tag = lowerCasedQuery;
        _this4.currentPageSEO = item.data();
        _this4.currentPageSEO.disable = false;
      }).catch(function (error) {
        console.error("Error writing document: ", error);
      });
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var _firestore;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    _firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {
      newTag: ""
    };
  },
  firestore: function firestore() {
    return {
      // Collection
      tags: _firestore.collection("tags")
    };
  },

  methods: {
    createTag: function createTag(tag) {
      // Replace spaces with dashes, everything must be a lower case letter
      tag = tag.toLowerCase().replace(/\s/g, '-').replace(/[^a-z0-9\-]+/gi, '');
      var fail = false;
      this.tags.forEach(function (eachTag) {
        if (tag == eachTag.name) {
          alert("This tag already exists.");
          fail = true;
        }
      });
      if (fail) return;
      _firestore.collection("tags").doc(tag).set({
        name: tag,
        count: 0
      });
    },
    removeTag: function removeTag(tag) {
      var result = confirm("This will delete this tag and remove its usage from all articles where it is used. ARE YOU SURE??");
      if (result) {
        _firestore.collection("tags").doc(tag).delete();
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalUser_vue__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalUser_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalDeluser_vue__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalDeluser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalDeluser_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalEdituser_vue__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalEdituser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ModalEdituser_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import request from "axios";



__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var _firestore;



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ModalUser: __WEBPACK_IMPORTED_MODULE_3__ModalUser_vue___default.a, ModalDeluser: __WEBPACK_IMPORTED_MODULE_4__ModalDeluser_vue___default.a, ModalEdituser: __WEBPACK_IMPORTED_MODULE_5__ModalEdituser_vue___default.a },
  data: function data() {
    _firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {
      showUserModal: false
    };
  },
  firestore: function firestore() {
    return {
      userData: _firestore.collection("users")
    };
  },

  methods: {
    showModalAddUser: function showModalAddUser() {
      this.showUserModal = true;
    }
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ic_firebase_uploader__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ic_firebase_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ic_firebase_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ic_firebase_uploader_dist_ic_firebase_uploader_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__widgets_gridX__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__widgets_gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__widgets_gridX__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(4);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_firestore___default.a);
var _firestore;










/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  components: { "ic-firebase-upload": __WEBPACK_IMPORTED_MODULE_5_ic_firebase_uploader___default.a, gridX: __WEBPACK_IMPORTED_MODULE_7__widgets_gridX___default.a },
  data: function data() {
    _firestore = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();
    return {
      storage: __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage(),
      editVideo: {},
      editVideoMode: false,
      videoEpisodes: [],
      newVideo: {
        key: "",
        obj: {
          id: "",
          title: ""
        }
      },
      selectedVideo: "",
      showNewVideo: false
    };
  },
  firestore: function firestore() {
    return {
      // Collection
      videos: _firestore.collection("videos")
    };
  },

  methods: {
    executeRemoveVideo: function executeRemoveVideo(item) {
      _firestore.collection("videoEpisodes").doc(item[".key"]).delete();
    },
    editVideoItem: function editVideoItem(item) {
      this.editVideoMode = true;
      this.editVideo = { key: item[".key"], obj: item };
      console.log(this.editVideo);
      this.$binding("videoEpisodes", _firestore.collection("videoEpisodes").where("playlist", "==", item[".key"]).orderBy("timestamp", "desc"));
    },
    onUploadedVideoSocialImage: function onUploadedVideoSocialImage(e) {
      var _this = this;

      console.log(e);
      e.getDownloadURL().then(function (url) {
        _this.editVideo.obj.socialImage = url;
        _this.$firestore.videos.doc(_this.editVideo.key).update({
          socialImage: url
        });
      });
    },
    onUpload: function onUpload(e) {
      e.doUpload();
    },
    onDelete: function onDelete(e) {
      e.doDelete();
    },
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    updateCacheVideo: function updateCacheVideo() {
      this.videos.forEach(function (video) {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("https://cdn.jwplayer.com/v2/playlists/" + video.id).then(function (response) {
          var playlist = [];

          setTimeout(function () {
            _firestore.collection("videoEpisodes").where("playlist", "==", video[".key"]).get().then(function (snap) {
              _firestore.collection("videos").doc(video[".key"]).update({
                latest: response.data.playlist[0],
                count: snap.size
              });
            });
          }, 5000);

          response.data.playlist.forEach(function (playlistItem) {
            var dataObj = {
              playlist: video[".key"],
              timestamp: playlistItem.pubdate,
              duration: playlistItem.duration,
              pubdate: playlistItem.pubdate,
              mediaid: playlistItem.mediaid,
              title: playlistItem.title,
              image: playlistItem.image,
              description: playlistItem.description
            };

            _firestore.collection("videoEpisodes").doc(video[".key"] + "-" + playlistItem.mediaid).get().then(function (data) {
              if (data.exists) {
                _firestore.collection("videoEpisodes").doc(video[".key"] + "-" + playlistItem.mediaid).update(dataObj);
              } else {
                _firestore.collection("videoEpisodes").doc(video[".key"] + "-" + playlistItem.mediaid).set(dataObj);
              }
            });
          });
        });
      });
    },
    timestampToDate: function timestampToDate(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(timestamp).format("YYYY-MM-DD");
    },
    removeVideoItem: function removeVideoItem(item) {
      this.$firestore.videos.doc(item[".key"]).delete();
    },
    createVideo: function createVideo() {
      var errorMessage = "";
      if (!this.newVideo.key) {
        errorMessage = "Missing key";
      }
      if (!this.newVideo.obj.id) {
        errorMessage = "Missing RSS";
      }
      if (!this.newVideo.obj.title) {
        errorMessage = "Missing Title";
      }
      if (errorMessage) {
        alert(errorMessage);
        return;
      }
      this.$firestore.videos.doc(this.newVideo.key).set(this.newVideo.obj);
      this.newVideo = {
        key: "",
        obj: {
          id: "",
          title: ""
        }
      };
    },
    executeEditVideo: function executeEditVideo() {
      var errorMessage = "";
      if (!this.editVideo.key) {
        errorMessage = "Missing key";
      }
      if (!this.editVideo.obj.id) {
        errorMessage = "Missing RSS";
      }
      if (!this.editVideo.obj.title) {
        errorMessage = "Missing Title";
      }
      if (errorMessage) {
        alert(errorMessage);
        return;
      }
      this.$firestore.videos.doc(this.editVideo.key).set(this.editVideo.obj);
      this.editVideo = {
        key: "",
        obj: {
          id: "",
          title: ""
        }
      };
      this.editVideoMode = false;
    },
    selected: function selected() {
      this.$refs.videoSelector.style.setProperty("--inputColor", "aliceblue");
    },
    changeColor: function changeColor() {
      this.$refs.videoSelector.style.setProperty("--inputColor", "black");
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_gridX__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__widgets_gridX__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalCreate_vue__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ModalCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_pageList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_pageList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__widgets_pageList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_json__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_articleWidgets_CodeEditor__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_articleWidgets_CodeEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_articleWidgets_CodeEditor__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var firestore;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "widgets",
  components: {
    CodeEditor: __WEBPACK_IMPORTED_MODULE_8__common_articleWidgets_CodeEditor___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a,
    gridX: __WEBPACK_IMPORTED_MODULE_4__widgets_gridX___default.a,
    ModalCreate: __WEBPACK_IMPORTED_MODULE_5__ModalCreate_vue___default.a,
    pageList: __WEBPACK_IMPORTED_MODULE_6__widgets_pageList___default.a
  },
  data: function data() {
    firestore = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();
    return {
      storage: __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.storage(),
      currentPageWidgets: false,
      currentPage: false,
      pages: [],
      updateWidgetMessage: "",
      newWidgetButton: "",
      currentWidgetItems: false,
      currentWidget: "",
      newWidgetStyle: "",
      newWidgetName: "",
      newWidgetLink: "",
      newWidgetType: "",
      newPageName: "",
      showModalCreate: {
        edit: false,
        add: false
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    firestore.collection("pages").get().then(function (snap) {
      var array = snap.docs.map(function (doc) {
        return { id: doc.id, data: doc.data() };
      });
      console.log(array);
      _this.pages = array;
    });
  },

  methods: {
    closeModals: function closeModals() {
      this.showModalCreate.edit = false;
      this.showModalCreate.add = false;
    },
    checkMode: function checkMode(mode, type) {
      // Checks what mode each widget type can take so the wrong mode won't brake front-end
      //  Only modes that break nuxt are checked so more modes or types may need to be added later
      var validModesForType = {
        'hero': ['curated', 'category'],
        'listen': ['curated', 'podcast'],
        'top-stories': ['curated', 'category'],
        'vertical-article-block': ['curated', 'category'],
        'three-row-column': ['curated', 'category'],
        'author-carousel': ['curated'],
        'grid-three': ['curated', 'category', 'tags'],
        'grid-four': ['curated', 'category', 'tags'],
        'infinite-grid-four': ['curated', 'category', 'tags'],
        'horizontal-scroller': ['curated', 'category'],
        'horizontal-scroller-video': ['curated', 'videos'],
        'all-videos': ['curated', 'category', 'videos'],
        'all-episodes': ['podcast'],
        'all-episodes-video': ['curated', 'category', 'tags', 'videos'],
        'podcast-carousel': ['curated', 'category', 'tags', 'videos', 'podcast']
      };

      if (validModesForType[type] == null) {
        return false;
      }

      return validModesForType[type].includes(mode);
    },
    checkType: function checkType(type, check) {
      var typesForChecks = {
        'article': ["curatedArticles", "hero", "top-stories", "vertical-article-block", "three-row-column", "grid-three", "grid-four", "horizontal-scroller"],
        'author': ['author-carousel'],
        'podcast': ["menu-podcasts", "listen", "all-podcasts", "podcast-carousel"],
        'video': ["menu-video-playlists", "all-video-topics"]
      };
      console.log(type, check);

      // || [] here ensures that if typesForChecks[check] is null we still have an empty array for
      // .includes(type) to execute on
      return (typesForChecks[check] || []).includes(type);
    },
    activeClass: function activeClass(a, b) {
      if (a == b) return "active";
      return "";
    },
    reorderItems: function reorderItems(e) {
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(this.currentPage.id).collection("widgets").doc(this.currentWidget.id).update({
        items: this.currentWidget.data.items
      });
    },
    reorderWidgetItems: function reorderWidgetItems() {
      var count = 0;
      for (var index in this.currentPageWidgets) {
        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(this.currentPage.id).collection("widgets").doc(this.currentPageWidgets[index].id).update({
          order: count
        });
        count++;
      }
      // this.$firestore.currentPageWidgets.update({
      //   items: this.currentPageWidgets.items
      // });
    },

    saveHtml: function saveHtml() {
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(this.currentPage.id).collection("widgets").doc(this.currentWidget.id).update({
        html: this.editor.getSession().getValue()
      }).then(function () {
        var overlay = document.getElementById("editor-overlay");
        overlay.classList.toggle('is-visible');
        setTimeout(function () {
          return overlay.classList.toggle('is-visible');
        }, 3000);
      }).catch(function (error) {
        console.log("Data could not be saved: " + error);
      });
    },
    saveCustomData: function saveCustomData() {
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(this.currentPage.id).collection("widgets").doc(this.currentWidget.id).update({
        custom: JSON.parse(this.customEditor.getSession().getValue())
      }).then(function () {
        var overlay = document.getElementById("custom-editor-overlay");
        overlay.classList.toggle('is-visible');
        setTimeout(function () {
          return overlay.classList.toggle('is-visible');
        }, 3000);
      }).catch(function (error) {
        console.log("Data could not be saved: " + error);
      });
    },
    saveAd: function saveAd() {
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(this.currentPage.id).collection("widgets").doc(this.currentWidget.id).update({
        placementName: this.currentWidget.data.placementName
      });
    },
    selectPage: function selectPage(item) {
      var _this2 = this;

      this.currentPage = item;

      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(this.currentPage.id).collection("widgets").orderBy("order").get().then(function (snap) {
        var array = snap.docs.map(function (doc) {
          return { id: doc.id, data: doc.data() };
        });
        console.log(array);
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this2, "currentPageWidgets", array);
        //console.log(e);
        if (_this2.currentPageWidgets && _this2.currentPageWidgets.length > 0) {
          __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(_this2.currentPage.id).collection("widgets").doc(_this2.currentPageWidgets[0].id).get().then(function (doc) {
            _this2.currentWidget = {
              id: _this2.currentPageWidgets[0].id,
              data: doc.data()
            };
          });
        }
      });
    },
    removeWidget: function removeWidget(item) {
      var confirm = window.confirm("Are you sure you would like to delete this widget?");
      if (confirm) {
        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(this.currentPage.id).collection("widgets").doc(item.id).delete();
      }
    },

    selectWidget: function selectWidget(item) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].nextTick(function () {

        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(_this3.currentPage.id).collection("widgets").doc(item.id).get().then(function (doc) {
          _this3.currentWidget = {
            id: item.id,
            data: doc.data()
          };
          setTimeout(function () {
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.currentWidget.data));
            if (document.getElementById("editor")) {
              _this3.editor = ace.edit("editor");
              _this3.editor.setTheme("ace/theme/monokai");
              _this3.editor.session.setMode("ace/mode/html");
              _this3.editor.setValue(_this3.currentWidget.data.html);
            }
            if (document.getElementById("custom-editor")) {
              _this3.customEditor = ace.edit("custom-editor");
              _this3.customEditor.setTheme("ace/theme/monokai");
              _this3.customEditor.session.setMode("brace/mode/json");
              _this3.customEditor.setValue(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.currentWidget.data.custom, null, '\t'));
            }
          }, 1000);
        });
      });
    },
    addPage: function addPage() {
      var key = this.newPageName.toLowerCase().replace(/\s/g, "-").replace(/[^a-zA-Z\- ]/g, "");
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(key).set({
        name: this.newPageName
      });
      this.newPageName = "";
    },
    createItem: function createItem(itemData) {
      if (!this.currentWidget.data.items) {
        this.currentWidget.data.items = [itemData];
      } else if (this.currentWidget.data.items) {
        this.currentWidget.data.items.push(itemData);
      }
      if (itemData.reorder) {
        this.currentWidget.data.items = itemData.reorder;
      }
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(this.currentPage.id).collection("widgets").doc(this.currentWidget.id).update({
        items: this.currentWidget.data.items
      });
      this.closeModals();
    },

    confirmEditButtonVisible: function confirmEditButtonVisible(array) {
      if (array) return true;
    },
    lengthValidator: function lengthValidator(maxLength) {
      // this returns a function which checks length against the
      // maxLength param which was passed in when we created the
      // function
      return function (length) {
        return length <= maxLength;
      };
    },
    confirmAddButtonVisible: function confirmAddButtonVisible(array) {
      if (!array) {
        return true;
      }

      var lengthValidators = {
        "hero": this.lengthValidator(0),
        "listen": this.lengthValidator(2),
        "three-row-column": this.lengthValidator(2),
        "grid-three": this.lengthValidator(2),
        "vertical-article-block": this.lengthValidator(3),
        "grid-four": this.lengthValidator(3),
        "top-stories": this.lengthValidator(0),
        "horizontal-scroller": this.lengthValidator(9)
      };

      if (lengthValidators[this.currentWidget.data.type] == null) {
        return true;
      }

      return lengthValidators[this.currentWidget.data.type](array.length);
    },
    setWidgetMode: function setWidgetMode(mode) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.currentWidget.data, "mode", mode);
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(this.currentWidget.data, "modeOrder", "recent");
      this.updateCurrentWidget();
    },
    updateCurrentWidget: function updateCurrentWidget() {
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(this.currentPage.id).collection("widgets").doc(this.currentWidget.id).update(this.currentWidget.data);
    },
    saveCategoryMode: function saveCategoryMode() {
      this.updateCurrentWidget();
    },
    removeItem: function removeItem(item, key) {
      var _this4 = this;

      this.currentWidget.data.items.splice(key, 1);
      this.updateCurrentWidget();
      setTimeout(function () {
        _this4.selectPage(_this4.currentPage);
      }, 1000);
    },
    editItem: function editItem(item, key) {
      this.currentWidget.data.items = [item];
      this.updateCurrentWidget();
      this.closeModals();
    },
    openEditItem: function openEditItem(item, key) {
      this.editData = item;
      this.showModalEdit = true;
    },
    addWidget: function addWidget() {
      var _this5 = this;

      var key = this.newWidgetName.toLowerCase().replace(/\s/g, "-").replace(/[^a-zA-Z\- ]/g, "");
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore().collection("pages").doc(this.currentPage.id).collection("widgets").doc(key).set({
        style: this.newWidgetStyle,
        name: this.newWidgetName,
        type: this.newWidgetType,
        order: this.currentPageWidgets.length,
        showTitle: this.showTitle || false,
        infiniteScroll: this.infiniteScroll || false
      }).then(function () {
        _this5.selectPage(_this5.currentPage);
      });
      this.newWidgetButton = "";
    },
    updateWidget: function updateWidget() {
      this.updateCurrentWidget();
      this.newWidgetButton = "";
    },
    testPage: function testPage(key) {
      request.get(__WEBPACK_IMPORTED_MODULE_7__config_json___default.a.apiFrontend + "/getWidgetCollectionData?pageid=" + key + "&cachebuster=" + Date.now()).then(function (response) {
        console.log(response.data);
        var alertMsg = "";
        for (var index in response.data.widgetData) {
          if (response.data.widgetData[index].items) alertMsg += index + ": " + response.data.widgetData[index].items.length + "\n";else alertMsg += index + ": N/A\n";
        }
        alert(alertMsg);
      });
    },
    refreshWidget: function refreshWidget(key) {
      var _this6 = this;

      this.updateWidgetMessage = "Sending, please wait...";
      request.get(__WEBPACK_IMPORTED_MODULE_7__config_json___default.a.apiFrontend + "/refreshPage?slug=" + key + "&type=widget&cachebuster=" + Date.now()).then(function (response) {
        _this6.updateWidgetMessage = response.data;
      }).catch(function (err) {
        console.log(err);
        _this6.updateWidgetMessage = "There was an error";
      });
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["selectedItem", "currentWidget", "mode", "storage"],
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
  },
  data: function data() {
    return {
      initialOrder: [],
      finalOrder: "",
      currentIndex: null,
      showEditText: false,
      isLoading: false,
      form: {
        newSlug: "",
        newName: "",
        newDescription: ""
      }
    };
  },
  mounted: function mounted() {
    // Might change this to vue.set to make copy of array of objects
    this.initialOrder = this.currentWidget.items ? JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.currentWidget.items)) : [];
  },

  directives: {
    focus: {
      update: function update(el) {
        el.focus();
      }
    }
  },
  methods: {
    deleteImage: function deleteImage(image, index) {
      var _this = this;

      var storageRef = this.storage.refFromURL("" + image);
      storageRef.delete().then(function () {
        // File deleted successfully
        console.log("file was deleted!");
        delete _this.initialOrder[index].image;
        _this.finalOrder = _this.initialOrder;
        _this.updateList();
      }).catch(function (error) {
        console.log(error);
      });
    },
    clickInput: function clickInput(index) {
      console.log("blur", index);
      this.initialOrder[index].slug = this.form.newSlug;
      this.initialOrder[index].name = this.form.newName;
      this.initialOrder[index].description = this.form.newDescription;
      this.updateList();
      this.finalOrder = this.initialOrder;
      this.reorderItems();
      this.showEditText = false;
    },
    focusInput: function focusInput(index) {
      console.log("focus", index);
    },
    newItem: function newItem() {
      this.initialOrder.unshift({
        title: "",
        image: "",
        authorSlug: ""
      });
      this.reorderItems();
    },
    reorderItems: function reorderItems(e) {
      this.finalOrder = this.initialOrder;
      this.$emit("orderChange", this.finalOrder);
    },
    removeItem: function removeItem(index) {
      this.initialOrder.splice(index, 1);
      this.reorderItems();
    },
    selectImg: function selectImg(index) {
      this.$refs.fileInput.value = "";
      this.$refs.fileInput.click();
      this.currentIndex = index;
    },
    selectTextInput: function selectTextInput(index, item) {
      console.log("index", index);
      this.form.newSlug = item.slug;
      this.form.newName = item.name;
      this.form.newDescription = item.description;
      this.showEditText = true;
      this.currentIndex = index;
    },
    cancelTextInput: function cancelTextInput() {
      this.form.newSlug = "";
      this.form.newName = "";
      this.form.newDescription = "";
      this.showEditText = false;
    },
    getText: function getText(index) {
      this.initialOrder[index].slug = this.form.newSlug;
      this.initialOrder[index].name = this.form.newName;
      this.initialOrder[index].description = this.form.newDescription;
      this.updateList();
      this.finalOrder = this.initialOrder;
      this.reorderItems();
      this.showEditText = false;
    },
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    updateList: function updateList() {
      // Spread updates items in v-for loop above (https://vuejs.org/v2/guide/list.html#Caveats)
      this.initialOrder = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.initialOrder));
    },
    processImg: function processImg(event) {
      var _this2 = this;

      console.log(event);
      if (event.target.files && event.target.files[0]) {
        var file = event.target.files[0];
        var storageRef = this.storage.ref("images/" + this.getFileName(file));
        var fileUpload = storageRef.put(file);
        var url = null;
        fileUpload.on("state_changed", function (snapshot) {
          var percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
          if (percentage < 100) {
            _this2.isLoading = true;
          } else {
            _this2.isLoading = false;
          }
        }, function (err) {
          console.log(err);
        }, function () {
          fileUpload.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            _this2.initialOrder[_this2.currentIndex].image = downloadURL;
            _this2.updateList();
            _this2.finalOrder = _this2.initialOrder;
            _this2.isLoading = false;
            _this2.$emit("orderChange", _this2.finalOrder);
          });
        });
      }
    }
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["col", "row", "gap"],
  methods: {
    setColumns: function setColumns(col) {
      this.$refs.grid.style.setProperty("--columns", col);
    },
    setRows: function setRows(row) {
      this.$refs.grid.style.setProperty("--rows", row);
    },
    setGap: function setGap(gap) {
      this.$refs.grid.style.setProperty("--gap", gap);
    }
  },
  mounted: function mounted() {
    this.setColumns(this.col);
    this.setRows(this.row);
    this.setGap(this.gap);
  },

  watch: {
    col: function col(val) {
      this.setColumns(val);
    }
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gridX__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gridX__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { gridX: __WEBPACK_IMPORTED_MODULE_1__gridX___default.a },
  props: ["item", "previewImage"],
  data: function data() {
    return {
      showUploader: "hero",
      showUploadBtn: false,
      columns: "1fr",
      showPreview: true
    };
  },

  methods: {
    processPreviewImage: function processPreviewImage(event) {
      var _this = this;

      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this.item, "image", e.target.result);
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.item, "image", "");
      }
    },
    clearUploader: function clearUploader() {
      this.$refs.fileUpload.value = "";
    },
    switchHero: function switchHero(arg) {
      if (arg === "desktop") {
        return this.$refs.hero.classList.add("desktop");
      }
      return this.$refs.hero.classList.remove("desktop");
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["selectedItem", "currentWidget", "mode", "storage"],
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
  },
  data: function data() {
    return {
      initialOrder: [],
      finalOrder: "",
      currentIndex: null,
      showEditText: false,
      isLoading: false,
      form: {
        newTitle: ""
      }
    };
  },
  mounted: function mounted() {
    // Might change this to vue.set to make copy of array of objects
    this.initialOrder = this.currentWidget.items ? JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.currentWidget.items)) : [];
  },

  directives: {
    focus: {
      update: function update(el) {
        el.focus();
      }
    }
  },
  methods: {
    deleteImage: function deleteImage(image, index) {
      var _this = this;

      var storageRef = this.storage.refFromURL("" + image);
      storageRef.delete().then(function () {
        // File deleted successfully
        console.log("file was deleted!");
        delete _this.initialOrder[index].image;
        _this.finalOrder = _this.initialOrder;
        _this.updateList();
      }).catch(function (error) {
        console.log(error);
      });
    },
    newItem: function newItem() {
      this.initialOrder.unshift({
        title: this.selectedItem.title,
        tempImage: this.selectedItem.image,
        postid: this.selectedItem.postid
      });
      this.reorderItems();
    },
    reorderItems: function reorderItems(e) {
      this.finalOrder = this.initialOrder;
      this.$emit("orderChange", this.finalOrder);
    },
    removeItem: function removeItem(index) {
      this.initialOrder.splice(index, 1);
      this.reorderItems();
    },
    selectImg: function selectImg(index) {
      this.$refs.fileInput.click();
      this.currentIndex = index;
    },
    selectTextInput: function selectTextInput(index) {
      this.form.newTitle = "";
      this.showEditText = true;
      this.currentIndex = index;
    },
    getText: function getText(index) {
      this.initialOrder[index].title = this.form.newTitle;
      this.updateList();
      this.finalOrder = this.initialOrder;
      this.reorderItems();
      this.showEditText = false;
    },
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    updateList: function updateList() {
      // Spread updates items in v-for loop above (https://vuejs.org/v2/guide/list.html#Caveats)
      this.initialOrder = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.initialOrder));
    },
    processImg: function processImg(event) {
      var _this2 = this;

      if (event.target.files && event.target.files[0]) {
        var file = event.target.files[0];
        var storageRef = this.storage.ref("images/" + this.getFileName(file));
        var fileUpload = storageRef.put(file);
        var url = null;
        fileUpload.on("state_changed", function (snapshot) {
          var percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
          if (percentage < 100) {
            _this2.isLoading = true;
          } else {
            _this2.isLoading = false;
          }
        }, function (err) {
          console.log(err);
        }, function () {
          fileUpload.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            _this2.initialOrder[_this2.currentIndex].image = downloadURL;
            _this2.updateList();
            _this2.finalOrder = _this2.initialOrder;
            _this2.isLoading = false;
            _this2.$emit("orderChange", _this2.finalOrder);
          });
        });
      }
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gridX__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gridX___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gridX__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["selectedItem", "currentWidget", "mode", "maxItems", "storage"],
  components: { gridX: __WEBPACK_IMPORTED_MODULE_3__gridX___default.a, draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a },
  data: function data() {
    return {
      previewImage: "",
      columns: "1fr",
      initialOrder: [],
      finalOrder: "",
      limit: this.maxItems,
      isLoading: false,
      showEditText: false,
      form: {
        newTitle: ""
      }
    };
  },
  created: function created() {
    // Might change this to vue.set to make copy of array of objects
    this.initialOrder = this.currentWidget.items ? JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.currentWidget.items)) : [];
    this.limit = this.limit - this.initialOrder.length;
  },

  directives: {
    focus: {
      update: function update(el) {
        el.focus();
      }
    }
  },
  methods: {
    updateList: function updateList() {
      // Spread updates items in v-for loop above (https://vuejs.org/v2/guide/list.html#Caveats)
      this.initialOrder = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.initialOrder));
    },
    selectTextInput: function selectTextInput(index) {
      this.form.newTitle = "";
      this.showEditText = true;
      this.currentIndex = index;
    },
    getText: function getText(index) {
      this.initialOrder[index].title = this.form.newTitle;
      this.updateList();
      this.finalOrder = this.initialOrder;
      this.reorderItems();
      this.currentIndex = null;
      this.showEditText = false;
    },
    newItem: function newItem() {
      this.initialOrder.unshift({
        title: this.selectedItem.title,
        tempImage: this.selectedItem.image,
        postid: this.selectedItem.postid
      });
      this.reorderItems();
      this.limit = this.limit - 1;
    },
    reorderItems: function reorderItems() {
      this.finalOrder = this.initialOrder;
      this.$emit("orderChange", this.finalOrder);
    },
    removeItem: function removeItem(index) {
      this.initialOrder.splice(index, 1);
      this.reorderItems();
      this.limit = this.limit + 1;
    },
    getFileName: function getFileName(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    deleteImage: function deleteImage(image, index) {
      var _this = this;

      var storageRef = this.storage.refFromURL("" + image);
      storageRef.delete().then(function () {
        // File deleted successfully
        console.log("file was deleted!");
        delete _this.initialOrder[index].image;
        _this.finalOrder = _this.initialOrder;
        _this.updateList();
      }).catch(function (error) {
        console.log(error);
      });
    },
    selectImg: function selectImg(index) {
      this.$refs.fileInput.click();
      this.currentIndex = index;
    },
    processImg: function processImg(event) {
      var _this2 = this;

      if (event.target.files && event.target.files[0]) {
        var file = event.target.files[0];
        var storageRef = this.storage.ref("images/" + this.getFileName(file));
        var fileUpload = storageRef.put(file);
        var url = null;
        fileUpload.on("state_changed", function (snapshot) {
          var percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
          if (percentage < 100) {
            _this2.isLoading = true;
          } else {
            _this2.isLoading = false;
          }
        }, function (err) {
          console.log(err);
        }, function () {
          fileUpload.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            _this2.initialOrder[_this2.currentIndex].image = downloadURL;
            _this2.updateList();
            _this2.finalOrder = _this2.initialOrder;
            _this2.isLoading = false;
            _this2.$emit("orderChange", _this2.finalOrder);
          });
        });
      }
    }
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["dataPages"],
  data: function data() {
    return {
      page: ""
    };
  },

  methods: {
    selected: function selected() {
      return this.$emit("page-data", this.page);
    },
    changeColor: function changeColor() {
      this.$refs.pageSelector.style.setProperty("--inputColor", "black");
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        value: {}
    },
    watch: {
        value: function value() {
            this.$emit('input', this.value);
        }
    }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_json__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_dist_vue_material_min_css__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_theme_default_dark_css__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_theme_default_dark_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_material_dist_theme_default_dark_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material___default.a);

var linkActiveClass = 'my-link-active-class';

// pass custom class to Vue Material
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].material.router.linkActiveClass = linkActiveClass;

var app = void 0;
//test
var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_4__config_json___default.a.firebase);
__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
      el: '#app',
      template: '<App/>',
      components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a },
      router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]
    });
  }
});
/* harmony default export */ __webpack_exports__["default"] = (firebaseApp.firestore());

/***/ }),
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */
/***/ (function(module, exports) {

module.exports = {
	"0": 65533,
	"128": 8364,
	"130": 8218,
	"131": 402,
	"132": 8222,
	"133": 8230,
	"134": 8224,
	"135": 8225,
	"136": 710,
	"137": 8240,
	"138": 352,
	"139": 8249,
	"140": 338,
	"142": 381,
	"145": 8216,
	"146": 8217,
	"147": 8220,
	"148": 8221,
	"149": 8226,
	"150": 8211,
	"151": 8212,
	"152": 732,
	"153": 8482,
	"154": 353,
	"155": 8250,
	"156": 339,
	"158": 382,
	"159": 376
};

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"AElig": "Æ",
	"aelig": "æ",
	"Agrave": "À",
	"agrave": "à",
	"amp": "&",
	"AMP": "&",
	"Aring": "Å",
	"aring": "å",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"brvbar": "¦",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"cedil": "¸",
	"cent": "¢",
	"copy": "©",
	"COPY": "©",
	"curren": "¤",
	"deg": "°",
	"divide": "÷",
	"Eacute": "É",
	"eacute": "é",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"Egrave": "È",
	"egrave": "è",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"frac12": "½",
	"frac14": "¼",
	"frac34": "¾",
	"gt": ">",
	"GT": ">",
	"Iacute": "Í",
	"iacute": "í",
	"Icirc": "Î",
	"icirc": "î",
	"iexcl": "¡",
	"Igrave": "Ì",
	"igrave": "ì",
	"iquest": "¿",
	"Iuml": "Ï",
	"iuml": "ï",
	"laquo": "«",
	"lt": "<",
	"LT": "<",
	"macr": "¯",
	"micro": "µ",
	"middot": "·",
	"nbsp": " ",
	"not": "¬",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"Oacute": "Ó",
	"oacute": "ó",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"Ograve": "Ò",
	"ograve": "ò",
	"ordf": "ª",
	"ordm": "º",
	"Oslash": "Ø",
	"oslash": "ø",
	"Otilde": "Õ",
	"otilde": "õ",
	"Ouml": "Ö",
	"ouml": "ö",
	"para": "¶",
	"plusmn": "±",
	"pound": "£",
	"quot": "\"",
	"QUOT": "\"",
	"raquo": "»",
	"reg": "®",
	"REG": "®",
	"sect": "§",
	"shy": "­",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"szlig": "ß",
	"THORN": "Þ",
	"thorn": "þ",
	"times": "×",
	"Uacute": "Ú",
	"uacute": "ú",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uml": "¨",
	"Uuml": "Ü",
	"uuml": "ü",
	"Yacute": "Ý",
	"yacute": "ý",
	"yen": "¥",
	"yuml": "ÿ"
};

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 125,
	"./af.js": 125,
	"./ar": 132,
	"./ar-dz": 126,
	"./ar-dz.js": 126,
	"./ar-kw": 127,
	"./ar-kw.js": 127,
	"./ar-ly": 128,
	"./ar-ly.js": 128,
	"./ar-ma": 129,
	"./ar-ma.js": 129,
	"./ar-sa": 130,
	"./ar-sa.js": 130,
	"./ar-tn": 131,
	"./ar-tn.js": 131,
	"./ar.js": 132,
	"./az": 133,
	"./az.js": 133,
	"./be": 134,
	"./be.js": 134,
	"./bg": 135,
	"./bg.js": 135,
	"./bm": 136,
	"./bm.js": 136,
	"./bn": 137,
	"./bn.js": 137,
	"./bo": 138,
	"./bo.js": 138,
	"./br": 139,
	"./br.js": 139,
	"./bs": 140,
	"./bs.js": 140,
	"./ca": 141,
	"./ca.js": 141,
	"./cs": 142,
	"./cs.js": 142,
	"./cv": 143,
	"./cv.js": 143,
	"./cy": 144,
	"./cy.js": 144,
	"./da": 145,
	"./da.js": 145,
	"./de": 148,
	"./de-at": 146,
	"./de-at.js": 146,
	"./de-ch": 147,
	"./de-ch.js": 147,
	"./de.js": 148,
	"./dv": 149,
	"./dv.js": 149,
	"./el": 150,
	"./el.js": 150,
	"./en-au": 151,
	"./en-au.js": 151,
	"./en-ca": 152,
	"./en-ca.js": 152,
	"./en-gb": 153,
	"./en-gb.js": 153,
	"./en-ie": 154,
	"./en-ie.js": 154,
	"./en-il": 155,
	"./en-il.js": 155,
	"./en-nz": 156,
	"./en-nz.js": 156,
	"./eo": 157,
	"./eo.js": 157,
	"./es": 160,
	"./es-do": 158,
	"./es-do.js": 158,
	"./es-us": 159,
	"./es-us.js": 159,
	"./es.js": 160,
	"./et": 161,
	"./et.js": 161,
	"./eu": 162,
	"./eu.js": 162,
	"./fa": 163,
	"./fa.js": 163,
	"./fi": 164,
	"./fi.js": 164,
	"./fo": 165,
	"./fo.js": 165,
	"./fr": 168,
	"./fr-ca": 166,
	"./fr-ca.js": 166,
	"./fr-ch": 167,
	"./fr-ch.js": 167,
	"./fr.js": 168,
	"./fy": 169,
	"./fy.js": 169,
	"./gd": 170,
	"./gd.js": 170,
	"./gl": 171,
	"./gl.js": 171,
	"./gom-latn": 172,
	"./gom-latn.js": 172,
	"./gu": 173,
	"./gu.js": 173,
	"./he": 174,
	"./he.js": 174,
	"./hi": 175,
	"./hi.js": 175,
	"./hr": 176,
	"./hr.js": 176,
	"./hu": 177,
	"./hu.js": 177,
	"./hy-am": 178,
	"./hy-am.js": 178,
	"./id": 179,
	"./id.js": 179,
	"./is": 180,
	"./is.js": 180,
	"./it": 181,
	"./it.js": 181,
	"./ja": 182,
	"./ja.js": 182,
	"./jv": 183,
	"./jv.js": 183,
	"./ka": 184,
	"./ka.js": 184,
	"./kk": 185,
	"./kk.js": 185,
	"./km": 186,
	"./km.js": 186,
	"./kn": 187,
	"./kn.js": 187,
	"./ko": 188,
	"./ko.js": 188,
	"./ky": 189,
	"./ky.js": 189,
	"./lb": 190,
	"./lb.js": 190,
	"./lo": 191,
	"./lo.js": 191,
	"./lt": 192,
	"./lt.js": 192,
	"./lv": 193,
	"./lv.js": 193,
	"./me": 194,
	"./me.js": 194,
	"./mi": 195,
	"./mi.js": 195,
	"./mk": 196,
	"./mk.js": 196,
	"./ml": 197,
	"./ml.js": 197,
	"./mn": 198,
	"./mn.js": 198,
	"./mr": 199,
	"./mr.js": 199,
	"./ms": 201,
	"./ms-my": 200,
	"./ms-my.js": 200,
	"./ms.js": 201,
	"./mt": 202,
	"./mt.js": 202,
	"./my": 203,
	"./my.js": 203,
	"./nb": 204,
	"./nb.js": 204,
	"./ne": 205,
	"./ne.js": 205,
	"./nl": 207,
	"./nl-be": 206,
	"./nl-be.js": 206,
	"./nl.js": 207,
	"./nn": 208,
	"./nn.js": 208,
	"./pa-in": 209,
	"./pa-in.js": 209,
	"./pl": 210,
	"./pl.js": 210,
	"./pt": 212,
	"./pt-br": 211,
	"./pt-br.js": 211,
	"./pt.js": 212,
	"./ro": 213,
	"./ro.js": 213,
	"./ru": 214,
	"./ru.js": 214,
	"./sd": 215,
	"./sd.js": 215,
	"./se": 216,
	"./se.js": 216,
	"./si": 217,
	"./si.js": 217,
	"./sk": 218,
	"./sk.js": 218,
	"./sl": 219,
	"./sl.js": 219,
	"./sq": 220,
	"./sq.js": 220,
	"./sr": 222,
	"./sr-cyrl": 221,
	"./sr-cyrl.js": 221,
	"./sr.js": 222,
	"./ss": 223,
	"./ss.js": 223,
	"./sv": 224,
	"./sv.js": 224,
	"./sw": 225,
	"./sw.js": 225,
	"./ta": 226,
	"./ta.js": 226,
	"./te": 227,
	"./te.js": 227,
	"./tet": 228,
	"./tet.js": 228,
	"./tg": 229,
	"./tg.js": 229,
	"./th": 230,
	"./th.js": 230,
	"./tl-ph": 231,
	"./tl-ph.js": 231,
	"./tlh": 232,
	"./tlh.js": 232,
	"./tr": 233,
	"./tr.js": 233,
	"./tzl": 234,
	"./tzl.js": 234,
	"./tzm": 236,
	"./tzm-latn": 235,
	"./tzm-latn.js": 235,
	"./tzm.js": 236,
	"./ug-cn": 237,
	"./ug-cn.js": 237,
	"./uk": 238,
	"./uk.js": 238,
	"./ur": 239,
	"./ur.js": 239,
	"./uz": 241,
	"./uz-latn": 240,
	"./uz-latn.js": 240,
	"./uz.js": 241,
	"./vi": 242,
	"./vi.js": 242,
	"./x-pseudo": 243,
	"./x-pseudo.js": 243,
	"./yo": 244,
	"./yo.js": 244,
	"./zh-cn": 245,
	"./zh-cn.js": 245,
	"./zh-hk": 246,
	"./zh-hk.js": 246,
	"./zh-tw": 247,
	"./zh-tw.js": 247
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 537;

/***/ }),
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(490)
  __webpack_require__(489)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(655),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40dd62b5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(529)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(683),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d9e1d468",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(531)
  __webpack_require__(532)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(685),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f634358a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(511)
  __webpack_require__(512)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(672),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7cd5d726",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(519)
  __webpack_require__(520)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(677),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a3699676",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(467)
  __webpack_require__(468)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(640),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2fff442c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(515)
  __webpack_require__(516)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(675),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9c6e5954",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(444)
  __webpack_require__(445)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(627),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-117de354",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(500)
  __webpack_require__(501)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(663),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59d9c2c5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(527)
  __webpack_require__(528)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(682),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d755e4f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(659),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-443bd3a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(533)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(686),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fa8435b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(457)
  __webpack_require__(458)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(635),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-26a1cff8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(649),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(452)
  __webpack_require__(453)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(632),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-25d3557b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(461)
  __webpack_require__(462)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(637),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2903d134",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
  __webpack_require__(486)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(653),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e868505",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(648),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36db0636",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(524)
  __webpack_require__(525)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(680),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c9687d02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(644),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-333f2d60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
  __webpack_require__(472)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(643),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-32d5687c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(522)
  __webpack_require__(523)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(679),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b9128206",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(463)
  __webpack_require__(464)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(638),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2cba884c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(507)
  __webpack_require__(508)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(669),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6bdf91fb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(480)
  __webpack_require__(481)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(650),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a6516e9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(465)
  __webpack_require__(466)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(639),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f6d8a4a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(513)
  __webpack_require__(514)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(673),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7da7bdf4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(441)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(624),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(660),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44bbad7b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(488)
  __webpack_require__(487)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(654),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f1ae280",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(510)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(671),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7cce158c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(459)
  __webpack_require__(460)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(636),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27d3ed2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(509)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(670),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c0abbb1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(448)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(629),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17ca5984",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(517)
  __webpack_require__(518)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(676),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a1b3fc0c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(482)
  __webpack_require__(483)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(651),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3cdd226e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(491)
  __webpack_require__(492)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(657),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42dff6ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(498)
  __webpack_require__(499)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(662),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59204884",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(455)
  __webpack_require__(456)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(634),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-261ac445",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(442)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(625),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c9713f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(446)
  __webpack_require__(447)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(628),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14f5fd9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
  __webpack_require__(497)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(661),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55214aec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(667),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67e6ba80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(641),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-313afd9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(668),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(475)
  __webpack_require__(476)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(646),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3553d78c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(440)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(623),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(443)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(626),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1006e970",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(454)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(633),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-25f3cd32",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(521)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(678),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ac467262",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(530)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(684),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-efbbb7d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(439)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(622),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-066f7a91",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(656),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(437)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(620),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05977250",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(438)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(621),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06600d67",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(474)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(645),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-335d6fd1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(631),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('grid-x', {
    attrs: {
      "col": "1fr 1fr",
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Update Videos")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.updateCacheVideo()
      }
    }
  }, [_vm._v("Update Video Cache")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedVideo),
      expression: "selectedVideo"
    }],
    ref: "videoSelector",
    staticClass: "video-list-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedVideo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selected()
      }],
      "focus": function($event) {
        _vm.changeColor()
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a video")]), _vm._v(" "), _vm._l((_vm.videos), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": item.title
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2)]), _vm._v(" "), _vm._l((_vm.videos), function(item, key) {
    return _c('div', {
      key: key
    }, [(_vm.selectedVideo === item.title) ? _c('div', {
      staticClass: "draggable-items flex center-flex-y"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "podcast-buttons"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.removeVideoItem(item)
        }
      }
    }, [_vm._v("Remove")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.editVideoItem(item)
        }
      }
    }, [_vm._v("Edit")])])]) : _vm._e()])
  }), _vm._v(" "), _c('grid-x', {
    staticClass: "edit-video",
    attrs: {
      "col": "1fr 1fr",
      "row": "1fr",
      "gap": ".5em"
    }
  }, [(_vm.editVideoMode) ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Video Slug")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVideo.key),
      expression: "editVideo.key"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Video Slug"
    },
    domProps: {
      "value": (_vm.editVideo.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVideo, "key", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Video Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVideo.obj.title),
      expression: "editVideo.obj.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Video Title"
    },
    domProps: {
      "value": (_vm.editVideo.obj.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVideo.obj, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Video ID")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVideo.obj.id),
      expression: "editVideo.obj.id"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Video ID"
    },
    domProps: {
      "value": (_vm.editVideo.obj.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVideo.obj, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVideo.obj.seoTitle),
      expression: "editVideo.obj.seoTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Title"
    },
    domProps: {
      "value": (_vm.editVideo.obj.seoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVideo.obj, "seoTitle", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Description")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVideo.obj.seoDescription),
      expression: "editVideo.obj.seoDescription"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Description"
    },
    domProps: {
      "value": (_vm.editVideo.obj.seoDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVideo.obj, "seoDescription", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "20px",
      "float": "left"
    },
    on: {
      "click": _vm.executeEditVideo
    }
  }, [_vm._v("Save Changes")])]) : _vm._e(), _vm._v(" "), (_vm.editVideoMode) ? _c('div', [_c('h3', {
    staticClass: "social-image-title"
  }, [_vm._v("Social Image")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "display": "block"
    },
    attrs: {
      "src": _vm.editVideo.obj.socialImage
    }
  }), _vm._v(" "), _c('ic-firebase-upload', {
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": _vm.onUploadedVideoSocialImage,
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    }
  })], 1) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("New Video")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.showNewVideo = !_vm.showNewVideo
      }
    }
  }, [_vm._v("New Video")])]), _vm._v(" "), (_vm.showNewVideo) ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Video Slug")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVideo.key),
      expression: "newVideo.key"
    }],
    staticStyle: {
      "display": "block",
      "width": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": "New Video Slug"
    },
    domProps: {
      "value": (_vm.newVideo.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newVideo, "key", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Video Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVideo.obj.title),
      expression: "newVideo.obj.title"
    }],
    staticStyle: {
      "display": "block",
      "width": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": "New Video Title"
    },
    domProps: {
      "value": (_vm.newVideo.obj.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newVideo.obj, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Video ID")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVideo.obj.id),
      expression: "newVideo.obj.id"
    }],
    staticStyle: {
      "display": "block",
      "width": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": "New Video ID"
    },
    domProps: {
      "value": (_vm.newVideo.obj.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newVideo.obj, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVideo.obj.seoTitle),
      expression: "newVideo.obj.seoTitle"
    }],
    staticStyle: {
      "display": "block",
      "width": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": "SEO Title"
    },
    domProps: {
      "value": (_vm.newVideo.obj.seoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newVideo.obj, "seoTitle", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Description")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVideo.obj.seoDescription),
      expression: "newVideo.obj.seoDescription"
    }],
    staticStyle: {
      "display": "block",
      "width": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": "SEO Description"
    },
    domProps: {
      "value": (_vm.newVideo.obj.seoDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newVideo.obj, "seoDescription", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Social Image")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVideo.obj.socialImage),
      expression: "newVideo.obj.socialImage"
    }],
    staticStyle: {
      "display": "block",
      "width": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Social Image"
    },
    domProps: {
      "value": (_vm.newVideo.obj.socialImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newVideo.obj, "socialImage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "20px",
      "float": "left"
    },
    on: {
      "click": _vm.createVideo
    }
  }, [_vm._v("Create Video Series Entry")])]) : _vm._e()])]), _vm._v(" "), (_vm.editVideoMode) ? _c('div', [_c('h3', [_vm._v("All Videos")]), _vm._v(" "), _vm._l((_vm.videoEpisodes), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items all-videos flex center-flex-y"
    }, [_c('div', {
      staticClass: "all-video-buttons center-flex-y"
    }, [_c('span', [_vm._v(_vm._s(_vm.timestampToDate(item.timestamp)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.executeRemoveVideo(item)
        }
      }
    }, [_vm._v("Remove")])])
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid-x', {
    attrs: {
      "col": "1fr 1fr 1fr",
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Pages")]), _vm._v(" "), _c('page-list', {
    attrs: {
      "data-pages": _vm.pages
    },
    on: {
      "page-data": function($event) {
        _vm.selectPage($event)
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("New Page")]), _vm._v(" "), _c('div', {
    staticClass: "new-page"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPageName),
      expression: "newPageName"
    }],
    ref: "newPage",
    attrs: {
      "type": "text",
      "placeholder": "New Page Name"
    },
    domProps: {
      "value": (_vm.newPageName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPageName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.addPage()
      }
    }
  }, [_vm._v("Create Page")])]), _vm._v(" "), (_vm.currentPage.id) ? _c('div', [_c('h4', [_vm._v("Current Page Key")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentPage.id))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("Widgets")]), _vm._v(" "), (_vm.currentPageWidgets) ? _c('div', [_c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.refreshWidget(_vm.currentPage.id)
      }
    }
  }, [_vm._v("UPDATE")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.testPage(_vm.currentPage.id)
      }
    }
  }, [_vm._v("TEST")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.updateWidgetMessage))])]), _vm._v(" "), _c('draggable', {
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      },
      "change": _vm.reorderWidgetItems
    },
    model: {
      value: (_vm.currentPageWidgets),
      callback: function($$v) {
        _vm.currentPageWidgets = $$v
      },
      expression: "currentPageWidgets"
    }
  }, _vm._l((_vm.currentPageWidgets), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items flex center-flex-y flex-space-between",
      class: _vm.activeClass(item.id, _vm.currentWidget.id),
      on: {
        "click": function($event) {
          _vm.selectWidget(item)
        }
      }
    }, [_c('div', {
      staticClass: "flex center-flex-y"
    }, [_c('svg', {
      staticClass: "draggable-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.data.name))])]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.removeWidget(item)
        }
      }
    }, [_vm._v("Remove")])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h3', [_vm._v("Current Widget Type")]), _vm._v(" "), _c('p', {
    staticClass: "widget-type"
  }, [_vm._v("Type: " + _vm._s(_vm.currentWidget.data.type))]), _vm._v(" "), _c('p', {
    staticClass: "widget-type"
  }, [_vm._v("ID: " + _vm._s(_vm.currentWidget.id))]), _vm._v(" "), _c('h3', [_vm._v("New / Update Widget")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    class: _vm.newWidgetButton === 'new' ? 'active-button' : '',
    on: {
      "click": function($event) {
        _vm.newWidgetButton = 'new'
      }
    }
  }, [_vm._v("Create Widget")]), _vm._v(" "), (_vm.currentWidget) ? _c('button', {
    class: _vm.newWidgetButton === 'update' ? 'active-button' : '',
    on: {
      "click": function($event) {
        _vm.newWidgetButton = 'update'
      }
    }
  }, [_vm._v("Update Current Widget")]) : _vm._e()])]), _vm._v(" "), (_vm.newWidgetButton === 'new') ? _c('div', {
    staticClass: "new-widget-container"
  }, [_c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWidgetType),
      expression: "newWidgetType"
    }],
    attrs: {
      "placeholder": "Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newWidgetType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Widget Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mm-html"
    }
  }, [_vm._v("HTML")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hero"
    }
  }, [_vm._v("Hero")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "top-stories"
    }
  }, [_vm._v("Top Stories")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "listen"
    }
  }, [_vm._v("Listen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vertical-article-block"
    }
  }, [_vm._v("Left-Right Block")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "three-row-column"
    }
  }, [_vm._v("Three Articles Bordered")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "grid-three"
    }
  }, [_vm._v("Three Column Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "grid-four"
    }
  }, [_vm._v("Four Column Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "capsule-block"
    }
  }, [_vm._v("Capsule Block")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "infinite-grid-four"
    }
  }, [_vm._v("Infinite Scroll Four Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "horizontal-scroller"
    }
  }, [_vm._v("Horizontal Scroller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-podcasts"
    }
  }, [_vm._v("Podcast Playlist Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-episodes"
    }
  }, [_vm._v("Podcast Episodes Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "podcast-carousel"
    }
  }, [_vm._v("Podcast Carousel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "author-carousel"
    }
  }, [_vm._v("Author Carousel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "watch-header"
    }
  }, [_vm._v("Video Hero")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "horizontal-scroller-video"
    }
  }, [_vm._v("Video Horizontal Scroller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-video-topics"
    }
  }, [_vm._v("Video Playlist Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-episodes-video"
    }
  }, [_vm._v("Video Episodes Grid 3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-videos"
    }
  }, [_vm._v("Video Episodes Grid 4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "title-with-lines"
    }
  }, [_vm._v("Title With Lines")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dynamic-ad-slot"
    }
  }, [_vm._v("Dynamic Ad Slot")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "menu-podcasts"
    }
  }, [_vm._v("MENU Playlists Podcast")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "menu-video-playlists"
    }
  }, [_vm._v("MENU Playlists Videos")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWidgetStyle),
      expression: "newWidgetStyle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Widget Style"
    },
    domProps: {
      "value": (_vm.newWidgetStyle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newWidgetStyle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWidgetName),
      expression: "newWidgetName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Widget Name"
    },
    domProps: {
      "value": (_vm.newWidgetName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newWidgetName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWidgetLink),
      expression: "newWidgetLink"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Widget Link"
    },
    domProps: {
      "value": (_vm.newWidgetLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newWidgetLink = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showTitle),
      expression: "showTitle"
    }],
    attrs: {
      "type": "checkbox",
      "id": "newShowTitleCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showTitle) ? _vm._i(_vm.showTitle, null) > -1 : (_vm.showTitle)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showTitle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showTitle = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showTitle = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showTitle = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "newShowTitleCheckbox"
    }
  }, [_vm._v("Show Title " + _vm._s(_vm.showTitle))])]), _vm._v(" "), (_vm.newWidgetType === 'grid-four') ? _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.infiniteScroll),
      expression: "infiniteScroll"
    }],
    attrs: {
      "type": "checkbox",
      "id": "newInfinteScrollCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.infiniteScroll) ? _vm._i(_vm.infiniteScroll, null) > -1 : (_vm.infiniteScroll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.infiniteScroll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.infiniteScroll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.infiniteScroll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.infiniteScroll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "newInfinteScrollCheckbox"
    }
  }, [_vm._v("Infinite Scroll " + _vm._s(_vm.infiniteScroll))])]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.addWidget()
      }
    }
  }, [_vm._v("Save Widget")])]) : _vm._e(), _vm._v(" "), (_vm.newWidgetButton === 'update') ? _c('div', {
    staticClass: "update-widget-container"
  }, [_c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.type),
      expression: "currentWidget.data.type"
    }],
    attrs: {
      "placeholder": "Current Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentWidget.data, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Widget Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mm-html"
    }
  }, [_vm._v("HTML")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hero"
    }
  }, [_vm._v("Hero")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "top-stories"
    }
  }, [_vm._v("Top Stories")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "listen"
    }
  }, [_vm._v("Listen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vertical-article-block"
    }
  }, [_vm._v("Left-Right Block")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "three-row-column"
    }
  }, [_vm._v("Three Articles Bordered")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "grid-three"
    }
  }, [_vm._v("Three Column Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "grid-four"
    }
  }, [_vm._v("Four Column Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "capsule-block"
    }
  }, [_vm._v("Capsule Block")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "infinite-grid-four"
    }
  }, [_vm._v("Infinite Scroll Four Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "horizontal-scroller"
    }
  }, [_vm._v("Horizontal Scroller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-podcasts"
    }
  }, [_vm._v("Podcast Playlist Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-episodes"
    }
  }, [_vm._v("Podcast Episodes Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "podcast-carousel"
    }
  }, [_vm._v("Podcast Carousel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "author-carousel"
    }
  }, [_vm._v("Author Carousel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "watch-header"
    }
  }, [_vm._v("Video Hero")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "horizontal-scroller-video"
    }
  }, [_vm._v("Video Horizontal Scroller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-video-topics"
    }
  }, [_vm._v("Video Playlist Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-episodes-video"
    }
  }, [_vm._v("Video Episodes Grid 3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-videos"
    }
  }, [_vm._v("Video Episodes Grid 4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "title-with-lines"
    }
  }, [_vm._v("Title With Lines")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dynamic-ad-slot"
    }
  }, [_vm._v("Dynamic Ad Slot")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "menu-podcasts"
    }
  }, [_vm._v("MENU Playlists Podcast")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "menu-video-playlists"
    }
  }, [_vm._v("MENU Playlists Videos")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.style),
      expression: "currentWidget.data.style"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Current Widget Styles"
    },
    domProps: {
      "value": (_vm.currentWidget.data.style)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "style", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.name),
      expression: "currentWidget.data.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Current Widget Name"
    },
    domProps: {
      "value": (_vm.currentWidget.data.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.link),
      expression: "currentWidget.data.link"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Current Widget Link"
    },
    domProps: {
      "value": (_vm.currentWidget.data.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "link", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box input-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.showTitle),
      expression: "currentWidget.data.showTitle"
    }],
    attrs: {
      "type": "checkbox",
      "id": "updateShowTitleCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentWidget.data.showTitle) ? _vm._i(_vm.currentWidget.data.showTitle, null) > -1 : (_vm.currentWidget.data.showTitle)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentWidget.data.showTitle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentWidget.data.showTitle = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentWidget.data.showTitle = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentWidget.data, "showTitle", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "updateShowTitleCheckbox"
    }
  }, [_vm._v("Show Title " + _vm._s(_vm.currentWidget.data.showTitle))])]), _vm._v(" "), (_vm.currentWidget.data.type === 'grid-four') ? _c('div', {
    staticClass: "input-box input-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.infiniteScroll),
      expression: "currentWidget.data.infiniteScroll"
    }],
    attrs: {
      "type": "checkbox",
      "id": "updateInfinteScrollCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentWidget.data.infiniteScroll) ? _vm._i(_vm.currentWidget.data.infiniteScroll, null) > -1 : (_vm.currentWidget.data.infiniteScroll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentWidget.data.infiniteScroll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentWidget.data.infiniteScroll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentWidget.data.infiniteScroll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentWidget.data, "infiniteScroll", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "updateInfinteScrollCheckbox"
    }
  }, [_vm._v("Infinite Scroll " + _vm._s(_vm.currentWidget.data.infiniteScroll))])]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.updateWidget()
      }
    }
  }, [_vm._v("Update Widget")])]) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex5"
  }, [_c('h3', [_vm._v("Manage Widget")]), _vm._v(" "), (_vm.currentWidget) ? _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [(_vm.currentWidget.data.type == 'mm-html') ? _c('div', [_c('div', {
    staticClass: "editor-container",
    attrs: {
      "id": "editor-container"
    }
  }, [_c('div', {
    staticClass: "editor-overlay",
    attrs: {
      "id": "editor-overlay"
    }
  }, [_vm._v("Changes Saved")]), _vm._v(" "), _c('div', {
    staticClass: "editor",
    attrs: {
      "id": "editor"
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveHtml
    }
  }, [_vm._v("save")])]) : (_vm.currentWidget.data.type == 'dynamic-ad-slot') ? _c('div', [_c('span', [_vm._v("Placement Name")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.placementName),
      expression: "currentWidget.data.placementName"
    }],
    attrs: {
      "placeholder": "*required"
    },
    domProps: {
      "value": (_vm.currentWidget.data.placementName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "placementName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveAd
    }
  }, [_vm._v("save")])]) : (_vm.currentWidget.data.type == 'capsule-block') ? _c('div', [_c('h2', [_vm._v("Custom Data")]), _vm._v(" "), _c('div', {
    staticClass: "editor-container",
    attrs: {
      "id": "custom-data-container"
    }
  }, [_c('div', {
    staticClass: "editor-overlay",
    attrs: {
      "id": "custom-editor-overlay"
    }
  }, [_vm._v("Changes Saved")]), _vm._v(" "), _c('div', {
    staticClass: "editor",
    attrs: {
      "id": "custom-editor"
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveCustomData
    }
  }, [_vm._v("save")])]) : _c('div', [(_vm.showModalCreate.add || _vm.showModalCreate.edit) ? _c('modal-create', {
    attrs: {
      "podcasts": _vm.podcastPlaylists,
      "videos": _vm.videos,
      "storage": _vm.storage,
      "currentWidget": _vm.currentWidget.data,
      "mode": _vm.showModalCreate
    },
    on: {
      "cancel": _vm.closeModals,
      "create": function($event) {
        _vm.createItem($event)
      },
      "update": function($event) {
        _vm.currentWidget.data.items = $event;
        _vm.updateCurrentWidget();
        _vm.closeModals();
      },
      "edit": _vm.editItem,
      "setWidgetData": function($event) {
        _vm.currentWidget.data[$event.key] = $event.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkMode('category', _vm.currentWidget.data.type)) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.setWidgetMode('category');
      }
    }
  }, [_vm._v("Category")]) : _vm._e(), _vm._v(" "), (_vm.checkMode('curated', _vm.currentWidget.data.type)) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.setWidgetMode('curated');
      }
    }
  }, [_vm._v("Curated")]) : _vm._e(), _vm._v(" "), (_vm.checkMode('tags', _vm.currentWidget.data.type)) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.setWidgetMode('tags');
      }
    }
  }, [_vm._v("Tags")]) : _vm._e(), _vm._v(" "), (_vm.checkMode('podcast', _vm.currentWidget.data.type)) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.setWidgetMode('podcasts');
      }
    }
  }, [_vm._v("Podcasts")]) : _vm._e(), _vm._v(" "), (_vm.checkMode('videos', _vm.currentWidget.data.type)) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.setWidgetMode('videos');
      }
    }
  }, [_vm._v("Videos")]) : _vm._e(), _vm._v(" "), (_vm.currentWidget.data.mode == 'curated') ? _c('div', [_c('h2', [_vm._v("Curated")]), _vm._v(" "), _c('draggable', {
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      },
      "change": _vm.reorderItems
    },
    model: {
      value: (_vm.currentWidget.data.items),
      callback: function($$v) {
        _vm.$set(_vm.currentWidget.data, "items", $$v)
      },
      expression: "currentWidget.data.items"
    }
  }, _vm._l((_vm.currentWidget.data.items), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items flex center-flex-y flex-space-between"
    }, [_c('div', {
      staticClass: "flex flex center-flex-y",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('svg', {
      staticClass: "draggable-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      }
    })]), _vm._v(" "), _c('span', {
      staticStyle: {
        "flex": "1"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (_vm.checkType(_vm.currentWidget.data.type, 'podcast') || _vm.checkType(_vm.currentWidget.data.type, 'video')) ? _c('button', {
      on: {
        "click": function($event) {
          _vm.removeItem(item, key)
        }
      }
    }, [_vm._v("Remove")]) : _vm._e()])])
  })), _vm._v(" "), (_vm.confirmAddButtonVisible(_vm.currentWidget.data.items)) ? _c('button', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        _vm.showModalCreate.add = true;
      }
    }
  }, [_vm._v("Add Items")]) : _vm._e(), _vm._v(" "), (_vm.confirmEditButtonVisible(_vm.currentWidget.data.items) && !_vm.checkType(_vm.currentWidget.data.type, 'podcast') && !_vm.checkType(_vm.currentWidget.data.type, 'video')) ? _c('button', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        _vm.showModalCreate.edit = true;
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.currentWidget.data.mode == 'category') ? _c('div', [_c('h2', [_vm._v("Categories")]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Category")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.category),
      expression: "currentWidget.data.category"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Category (Blank for all)"
    },
    domProps: {
      "value": (_vm.currentWidget.data.category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "category", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Number of articles")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.limit),
      expression: "currentWidget.data.limit"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Number of articles"
    },
    domProps: {
      "value": (_vm.currentWidget.data.limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.modeOrder),
      expression: "currentWidget.data.modeOrder"
    }],
    attrs: {
      "placeholder": "Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentWidget.data, "modeOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "recent"
    }
  }, [_vm._v("Most Recent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "popular"
    }
  }, [_vm._v("Most Popular")])])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.saveCategoryMode
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (_vm.currentWidget.data.mode == 'podcasts') ? _c('div', [_c('h2', [_vm._v("Podcasts")]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Number of Podcasts")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.limit),
      expression: "currentWidget.data.limit"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Number of Podcasts"
    },
    domProps: {
      "value": (_vm.currentWidget.data.limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.modeOrder),
      expression: "currentWidget.data.modeOrder"
    }],
    attrs: {
      "placeholder": "Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentWidget.data, "modeOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "recent"
    }
  }, [_vm._v("Most Recent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "popular"
    }
  }, [_vm._v("Most Popular")])])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.saveCategoryMode
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (_vm.currentWidget.data.mode == 'videos') ? _c('div', [_c('h2', [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.playlists),
      expression: "currentWidget.data.playlists"
    }],
    attrs: {
      "placeholder": "Playlists"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentWidget.data, "playlists", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": {
        slug: 'allplaylists',
        title: 'allplaylists'
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.videos), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": {
          slug: item.id,
          title: item.data.title
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Number of videos")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.limit),
      expression: "currentWidget.data.limit"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Number of Videos"
    },
    domProps: {
      "value": (_vm.currentWidget.data.limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.modeOrder),
      expression: "currentWidget.data.modeOrder"
    }],
    attrs: {
      "placeholder": "Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentWidget.data, "modeOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "recent"
    }
  }, [_vm._v("Most Recent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "popular"
    }
  }, [_vm._v("Most Popular")])])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.saveCategoryMode
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (_vm.currentWidget.data.mode == 'tags') ? _c('div', [_c('h2', [_vm._v("Tags")]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Tag")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.tags),
      expression: "currentWidget.data.tags"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Tag (ONLY ONE)"
    },
    domProps: {
      "value": (_vm.currentWidget.data.tags)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "tags", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Number of articles")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.limit),
      expression: "currentWidget.data.limit"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Number of articles"
    },
    domProps: {
      "value": (_vm.currentWidget.data.limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.modeOrder),
      expression: "currentWidget.data.modeOrder"
    }],
    attrs: {
      "placeholder": "Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentWidget.data, "modeOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "recent"
    }
  }, [_vm._v("Most Recent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "popular"
    }
  }, [_vm._v("Most Popular")])])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.saveTagMode
    }
  }, [_vm._v("Save")])]) : _vm._e()], 1)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Tags")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons flex"
  }, [_c('div', {
    staticClass: "input-box",
    staticStyle: {
      "height": "33px",
      "margin-right": "10px",
      "width": "220px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter Tag..."
    },
    domProps: {
      "value": (_vm.newTag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTag = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "height": "33px",
      "width": "120px"
    },
    on: {
      "click": function($event) {
        _vm.createTag(_vm.newTag)
      }
    }
  }, [_vm._v("Create Tag")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.tags), function(tag, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(tag.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tag.count))]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.removeTag(tag.name)
        }
      }
    }, [_vm._v("Remove")])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Tag")]), _vm._v(" "), _c('th', [_vm._v("Count")]), _vm._v(" "), _c('th')])
}]}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('article-editor', {
    ref: "editor",
    attrs: {
      "article": _vm.blankArticle
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('multiselect', {
    attrs: {
      "placeholder": _vm.placeholder,
      "options": _vm.options,
      "reset-after": true
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "x-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "min-height": "calc(95vh - 141px)"
    }
  }, [_vm._t("body", [_c('div', [_c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("EDITED BY")]), _vm._v(" "), _c('md-table-head', [_vm._v("DATE")])], 1), _vm._v(" "), (_vm.articleHistory.length > 0) ? _vm._l((_vm.articleHistory), function(item, key) {
    return _c('md-table-row', {
      key: key
    }, [_c('md-table-cell', [_vm._v(_vm._s(item.editedBy.user))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(_vm.$moment(item.editedBy.timestamp * 1000), "hh:mm DD/MM/YYYY")))]), _vm._v(" "), _c('md-table-cell', [_c('button', {
      on: {
        "click": function($event) {
          _vm.restore(item)
        }
      }
    }, [_vm._v("RESTORE")])])], 1)
  }) : _vm._e()], 2)], 1)])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Done")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid-x', {
    attrs: {
      "col": _vm.columns,
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Image Upload")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.showUploader = 'hero', _vm.columns = '1fr'
      }
    }
  }, [_vm._v("Hero")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showUploader = 'bacteria', _vm.columns = '1fr 1fr'
      }
    }
  }, [_vm._v("Lifestyle Widget")])]), _vm._v(" "), (_vm.showUploader === 'hero') ? _c('div', [_c('div', {
    staticClass: "input-box flex center-flex-y bacteria-image-upload"
  }, [_c('input', {
    ref: "fileUpload",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.processPreviewImage($event, 'hero'), _vm.showPreview = true
      }
    }
  }), _vm._v(" "), (_vm.heroImage) ? _c('div', {
    staticClass: "upload-preview",
    on: {
      "click": function($event) {
        [_vm.heroImage = '', _vm.clearUploader(), _vm.showPreview = false]
      }
    }
  }, [_c('img', {
    staticClass: "lazyload-images",
    attrs: {
      "src": _vm.heroImage
    }
  })]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "message"
  }, [_vm._v("Uploader does not actually upload")]), _vm._v(" "), _c('h4', [_vm._v("Hero Text")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heroText),
      expression: "heroText"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Hero Text"
    },
    domProps: {
      "value": (_vm.heroText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heroText = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showUploader === 'bacteria') ? _c('div', {
    staticClass: "bacteria-image"
  }, [_c('div', {
    staticClass: "input-box flex center-flex-y bacteria-image-upload"
  }, [_c('input', {
    ref: "fileUpload",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.processPreviewImage($event, 'bacteria')
      }
    }
  }), _vm._v(" "), (_vm.previewImage) ? _c('div', {
    staticClass: "upload-preview",
    on: {
      "click": function($event) {
        [_vm.previewImage = '', _vm.clearUploader()]
      }
    }
  }, [_c('img', {
    staticClass: "lazyload-images",
    attrs: {
      "src": _vm.previewImage
    }
  })]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "message"
  }, [_vm._v("Uploader does not actually upload")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("Image Preview")]), _vm._v(" "), (_vm.showUploader === 'hero') ? _c('div', {
    staticClass: "hero-preview"
  }, [_c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.switchHero('mobile')
      }
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.switchHero('desktop')
      }
    }
  }, [_vm._v("Desktop")])]), _vm._v(" "), (_vm.showPreview) ? _c('div', {
    staticClass: "desktop-preview"
  }, [_c('div', {
    ref: "hero",
    staticClass: "hero-image desktop"
  }, [_c('img', {
    staticClass: "object-fit",
    attrs: {
      "src": _vm.heroImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-text"
  }, [_c('h2', {
    staticClass: "hero-text-title"
  }, [_vm._v(_vm._s(_vm.heroText))]), _vm._v(" "), _c('span', {
    staticClass: "hero-author"
  }, [_c('i', [_vm._v("by")]), _vm._v("\n              Boaty McBoatface\n            ")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showUploader === 'bacteria' && _vm.previewImage) ? _c('div', {
    staticClass: "image-bg flex center-flex"
  }, [(_vm.previewImage) ? _c('img', {
    staticClass: "lazyload-images",
    attrs: {
      "src": _vm.previewImage
    }
  }) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "flex center-flex-y",
    on: {
      "click": _vm.showModalDeleteUser
    }
  }, [_vm._v("REMOVE USER")]), _vm._v(" "), (_vm.showUserDeleteModal) ? _c('modal-userdelete', {
    attrs: {
      "modal": _vm.showUserDeleteModal,
      "passedObject": _vm.objectToPass
    },
    on: {
      "update:modal": function($event) {
        _vm.showUserDeleteModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.modalOpen) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('div', [_c('md-steppers', {
    attrs: {
      "md-active-step": _vm.active,
      "md-linear": ""
    },
    on: {
      "update:mdActiveStep": function($event) {
        _vm.active = $event
      }
    }
  }, [_c('md-step', {
    attrs: {
      "id": "first",
      "md-label": "Select Image",
      "md-done": _vm.first
    },
    on: {
      "update:mdDone": function($event) {
        _vm.first = $event
      }
    }
  }, [_c('md-content', {
    staticClass: "content-area md-scrollbar"
  }, [_c('image-select', {
    on: {
      "save-image-to-catalogue": _vm.saveImageToCatalogue,
      "process-file-array": _vm.processFileArray,
      "process-file-url": _vm.processFileUrl
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex bottom-buttons"
  }, [_c('div'), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.modalOpen = false
      }
    }
  }, [_vm._v("CANCEL")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("NEXT")])])], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "id": "second",
      "md-label": "Edit Image",
      "md-done": _vm.second
    },
    on: {
      "update:mdDone": function($event) {
        _vm.second = $event
      }
    }
  }, [_c('md-content', {
    staticClass: "content-area md-scrollbar"
  }, [_c('image-edit', {
    ref: "imageEdit",
    on: {
      "save-data": _vm.processFileArray,
      "save-image-to-catalogue": _vm.saveImageToCatalogue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex bottom-buttons"
  }, [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.setDone('second', 'first')
      }
    }
  }, [_vm._v("PREVIOUS")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.modalOpen = false
      }
    }
  }, [_vm._v("CANCEL")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$refs.imageEdit.saveImageData()
      }
    }
  }, [_vm._v("NEXT")])])], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "id": "third",
      "md-label": "Crop Image",
      "md-done": _vm.third
    },
    on: {
      "update:mdDone": function($event) {
        _vm.third = $event
      }
    }
  }, [_c('md-content', {
    staticClass: "content-area md-scrollbar"
  }, [_c('image-crop', {
    ref: "imageCrop",
    attrs: {
      "aspectRatio": _vm.aspectRatio
    },
    on: {
      "crop-data": _vm.gotCropData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex bottom-buttons"
  }, [(_vm.showSpinner) ? _c('md-progress-spinner', {
    attrs: {
      "md-mode": "indeterminate"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showSpinner) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.setDone('third', 'second')
      }
    }
  }, [_vm._v("PREVIOUS")]) : _vm._e(), _vm._v(" "), (!_vm.showSpinner) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.modalOpen = false
      }
    }
  }, [_vm._v("CANCEL")]) : _vm._e(), _vm._v(" "), (!_vm.showSpinner) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.showSpinner = true;
        _vm.$refs.imageCrop.getCropData();
      }
    }
  }, [_vm._v("DONE")]) : _vm._e(), _vm._v(" "), _c('div')], 1)], 1)], 1)], 1)])], 2)])])])]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "x-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "4px",
      "width": "100%",
      "display": "flex",
      "left": "0px",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deviceToggle = 'desktop'
      }
    }
  }, [_vm._v("Desktop")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deviceToggle = 'mobile'
      }
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.deviceToggle = 'amp'
      }
    }
  }, [_vm._v("AMP")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "min-height": "calc(98vh - 115px)"
    }
  }, [_vm._t("body", [(_vm.deviceToggle == 'desktop') ? _c('iframe', {
    staticStyle: {
      "width": "1280px",
      "height": "calc(98vh - 115px)",
      "margin": "20px auto",
      "display": "block"
    },
    attrs: {
      "src": _vm.previewUrl + _vm.slug + '/' + _vm.password + '/'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deviceToggle == 'mobile') ? _c('iframe', {
    staticStyle: {
      "width": "400px",
      "height": "800px",
      "margin": "20px auto",
      "display": "block"
    },
    attrs: {
      "src": _vm.previewUrl + _vm.slug + '/' + _vm.password + '/'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deviceToggle == 'amp') ? _c('iframe', {
    staticStyle: {
      "width": "400px",
      "height": "800px",
      "margin": "20px auto",
      "display": "block"
    },
    attrs: {
      "src": _vm.previewUrl + _vm.slug + '/' + _vm.password + '/amp/'
    }
  }) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('span', {
    staticStyle: {
      "width": "700px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.copyText();
      }
    }
  }, [_vm._v("COPY")]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "previewText"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Done")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "flex center-flex-y",
    on: {
      "click": function($event) {
        _vm.showModalPodcast(_vm.item)
      }
    }
  }, [_vm._v("Update SEO")]), _vm._v(" "), (_vm.showPodModal) ? _c('modal-podcast', {
    attrs: {
      "modal": _vm.showPodModal,
      "passedObject": _vm.objectToPass
    },
    on: {
      "update:modal": function($event) {
        _vm.showPodModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.seoTitle),
      expression: "value.seoTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Title",
      "disabled": _vm.value.disable
    },
    domProps: {
      "value": (_vm.value.seoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "seoTitle", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Description")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.seoDescription),
      expression: "value.seoDescription"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Description",
      "disabled": _vm.value.disable
    },
    domProps: {
      "value": (_vm.value.seoDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "seoDescription", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              USER DETAILS\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n              User Email\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "email", $event.target.value)
      }
    }
  })]), _vm._v("\n              Tick the permission required\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.permission),
      expression: "newUser.permission"
    }],
    attrs: {
      "type": "checkbox",
      "id": "admin",
      "value": "admin"
    },
    domProps: {
      "checked": Array.isArray(_vm.newUser.permission) ? _vm._i(_vm.newUser.permission, "admin") > -1 : (_vm.newUser.permission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newUser.permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "admin",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newUser.permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newUser.permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newUser, "permission", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "admin"
    }
  }, [_vm._v("admin")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.permission),
      expression: "newUser.permission"
    }],
    attrs: {
      "type": "checkbox",
      "id": "role-editor",
      "value": "editor"
    },
    domProps: {
      "checked": Array.isArray(_vm.newUser.permission) ? _vm._i(_vm.newUser.permission, "editor") > -1 : (_vm.newUser.permission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newUser.permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "editor",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newUser.permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newUser.permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newUser, "permission", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "role-editor"
    }
  }, [_vm._v("editor")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.permission),
      expression: "newUser.permission"
    }],
    attrs: {
      "type": "checkbox",
      "id": "podcast",
      "value": "podcast"
    },
    domProps: {
      "checked": Array.isArray(_vm.newUser.permission) ? _vm._i(_vm.newUser.permission, "podcast") > -1 : (_vm.newUser.permission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newUser.permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "podcast",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newUser.permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newUser.permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newUser, "permission", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "podcast"
    }
  }, [_vm._v("podcast")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.permission),
      expression: "newUser.permission"
    }],
    attrs: {
      "type": "checkbox",
      "id": "video",
      "value": "video"
    },
    domProps: {
      "checked": Array.isArray(_vm.newUser.permission) ? _vm._i(_vm.newUser.permission, "video") > -1 : (_vm.newUser.permission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newUser.permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "video",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newUser.permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newUser.permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newUser, "permission", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "video"
    }
  }, [_vm._v("video")])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.addNewUser
    }
  }, [_vm._v("\n                ADD USER\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('grid-x', {
    attrs: {
      "col": "1fr 1fr",
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Update PodCasts")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.updateCachePodcast()
      }
    }
  }, [_vm._v("Update Podcast Cache")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPodcast),
      expression: "selectedPodcast"
    }],
    ref: "podcastSelector",
    staticClass: "podcast-list-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPodcast = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selected()
      }],
      "focus": function($event) {
        _vm.changeColor()
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a podcast")]), _vm._v(" "), _vm._l((_vm.podcasts), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": item.title
      }
    }, [_vm._v(_vm._s(item.title) + " -- " + _vm._s(item.count))])
  })], 2)]), _vm._v(" "), _vm._l((_vm.podcasts), function(item, key) {
    return _c('div', {
      key: key
    }, [(_vm.selectedPodcast === item.title) ? _c('div', {
      staticClass: "draggable-items flex center-flex-y"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v("- " + _vm._s(item.count) + " Episodes")]), _vm._v(" "), _c('div', {
      staticClass: "podcast-buttons"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.removePodcastItem(item)
        }
      }
    }, [_vm._v("Remove")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.editPodcastItem(item)
        }
      }
    }, [_vm._v("Edit")])])]) : _vm._e()])
  }), _vm._v(" "), _c('grid-x', {
    attrs: {
      "col": "1fr 1fr",
      "row": "1fr",
      "gap": ".5em"
    }
  }, [(_vm.editPodcastMode) ? _c('div', {
    staticClass: "podcast-edit"
  }, [_vm._v("Podcast Slug\n          "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPodcast.key),
      expression: "editPodcast.key"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Podcast Slug"
    },
    domProps: {
      "value": (_vm.editPodcast.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editPodcast, "key", $event.target.value)
      }
    }
  })]), _vm._v("Podcast Title\n          "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPodcast.obj.title),
      expression: "editPodcast.obj.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Podcast Title"
    },
    domProps: {
      "value": (_vm.editPodcast.obj.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editPodcast.obj, "title", $event.target.value)
      }
    }
  })]), _vm._v("Podcast RSS\n          "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPodcast.obj.rss),
      expression: "editPodcast.obj.rss"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Podcast RSS"
    },
    domProps: {
      "value": (_vm.editPodcast.obj.rss)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editPodcast.obj, "rss", $event.target.value)
      }
    }
  })]), _vm._v("SEO Title\n          "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPodcast.obj.seoTitle),
      expression: "editPodcast.obj.seoTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Title"
    },
    domProps: {
      "value": (_vm.editPodcast.obj.seoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editPodcast.obj, "seoTitle", $event.target.value)
      }
    }
  })]), _vm._v("SEO Description\n          "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPodcast.obj.seoDescription),
      expression: "editPodcast.obj.seoDescription"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Description"
    },
    domProps: {
      "value": (_vm.editPodcast.obj.seoDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editPodcast.obj, "seoDescription", $event.target.value)
      }
    }
  })]), _vm._v("Subscribe URL\n          "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPodcast.obj.subscribeUrl),
      expression: "editPodcast.obj.subscribeUrl"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Subscribe URL"
    },
    domProps: {
      "value": (_vm.editPodcast.obj.subscribeUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editPodcast.obj, "subscribeUrl", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "20px",
      "float": "left"
    },
    on: {
      "click": _vm.executeEditPodcast
    }
  }, [_vm._v("Save Edit")])]) : _vm._e(), _vm._v(" "), (_vm.editPodcastMode) ? _c('div', [_c('h3', [_vm._v("Square Image")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "display": "block"
    },
    attrs: {
      "src": _vm.editPodcast.obj.overrideImage ? _vm.editPodcast.obj.overrideImage : _vm.editPodcast.obj.image
    }
  }), _vm._v(" "), _c('ic-firebase-upload', {
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": _vm.onUploadedPodcastImage,
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Social")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "display": "block"
    },
    attrs: {
      "src": _vm.editPodcast.obj.socialImage
    }
  }), _vm._v(" "), _c('ic-firebase-upload', {
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": _vm.onUploadedPodcastSocialImage,
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    }
  })], 1) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("New Podcast")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.showNewPodcast = !_vm.showNewPodcast
      }
    }
  }, [_vm._v("New Podcast")])]), _vm._v(" "), (_vm.showNewPodcast) ? _c('div', [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPodcast.key),
      expression: "newPodcast.key"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Podcast Slug"
    },
    domProps: {
      "value": (_vm.newPodcast.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPodcast, "key", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPodcast.obj.title),
      expression: "newPodcast.obj.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Podcast Title"
    },
    domProps: {
      "value": (_vm.newPodcast.obj.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPodcast.obj, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPodcast.obj.rss),
      expression: "newPodcast.obj.rss"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Podcast RSS"
    },
    domProps: {
      "value": (_vm.newPodcast.obj.rss)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPodcast.obj, "rss", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPodcast.obj.seoTitle),
      expression: "newPodcast.obj.seoTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Title"
    },
    domProps: {
      "value": (_vm.newPodcast.obj.seoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPodcast.obj, "seoTitle", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPodcast.obj.seoDescription),
      expression: "newPodcast.obj.seoDescription"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Description"
    },
    domProps: {
      "value": (_vm.newPodcast.obj.seoDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPodcast.obj, "seoDescription", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPodcast.obj.subscribeUrl),
      expression: "newPodcast.obj.subscribeUrl"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Subscribe URL"
    },
    domProps: {
      "value": (_vm.newPodcast.obj.subscribeUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPodcast.obj, "subscribeUrl", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.createPodcast
    }
  }, [_vm._v("Create Podcast Entry")])]) : _vm._e()])]), _vm._v(" "), (_vm.editPodcastMode) ? _c('div', {
    staticClass: "all-episodes"
  }, [_c('h3', [_vm._v("All Episodes")]), _vm._v(" "), _vm._l((_vm.podcastEpisodes), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items"
    }, [_c('grid-x', {
      attrs: {
        "col": "1fr 200px 1fr",
        "row": "1fr",
        "gap": "2em"
      }
    }, [_c('div', {
      staticClass: "flex center-flex-y"
    }, [_c('span', {
      staticClass: "flex-1"
    }, [_vm._v(_vm._s(_vm.timestampToDate(item.timestamp)))]), _vm._v(" "), _c('span', {
      staticClass: "flex-3"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "flex center-flex-x",
      staticStyle: {
        "max-height": "75px"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "50px",
        "height": "100%"
      },
      attrs: {
        "src": item.overrideImage ? item.overrideImage : item.image
      }
    }), _vm._v(" "), (item.socialImage) ? _c('img', {
      staticStyle: {
        "width": "50px",
        "height": "auto"
      },
      attrs: {
        "src": item.socialImage
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flex"
    }, [_c('span', {
      staticClass: "flex center-flex-y"
    }, [_vm._v("Square->")]), _vm._v(" "), _c('ic-firebase-upload', {
      attrs: {
        "path": "images",
        "max-files": "1",
        "getFileName": _vm.getFileName,
        "storage": _vm.storage
      },
      on: {
        "uploaded": function($event) {
          _vm.onUploadedEpisodeImage($event, item)
        },
        "upload": _vm.onUpload,
        "delete": _vm.onDelete
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "flex center-flex-y"
    }, [_vm._v("Social->")]), _vm._v(" "), _c('ic-firebase-upload', {
      attrs: {
        "path": "images",
        "max-files": "1",
        "getFileName": _vm.getFileName,
        "storage": _vm.storage
      },
      on: {
        "uploaded": function($event) {
          _vm.onUploadedEpisodeSocialImage($event, item)
        },
        "upload": _vm.onUpload,
        "delete": _vm.onDelete
      }
    }), _vm._v(" "), _c('modal-button', {
      staticClass: "flex center-flex-y",
      attrs: {
        "passedItem": item
      }
    }, [_vm._v("Update SEO")]), _vm._v(" "), _c('button', {
      staticClass: "flex center-flex-y",
      on: {
        "click": function($event) {
          _vm.updateCacheEpisode(item)
        }
      }
    }, [_vm._v("Refresh")])], 1)])], 1)
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "flex center-flex-y",
    on: {
      "click": _vm.showModalEditBrand
    }
  }, [_vm._v("EDIT ARTICLE")]), _vm._v(" "), (_vm.showBrandEditModal) ? _c('modal-brandedit', {
    attrs: {
      "modal": _vm.showBrandEditModal,
      "passedObject": _vm.objectToPass
    },
    on: {
      "update:modal": function($event) {
        _vm.showBrandEditModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "80vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              SEO Details\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n              SEO Title\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.podSeoTitle),
      expression: "passedObject.podSeoTitle"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.podSeoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "podSeoTitle", $event.target.value)
      }
    }
  })]), _vm._v("\n              SEO Description\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.podSeoDesc),
      expression: "passedObject.podSeoDesc"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.podSeoDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "podSeoDesc", $event.target.value)
      }
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.saveEpisodeSeo
    }
  }, [_vm._v("\n                SAVE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex center-flex-x center-flex-y",
    staticStyle: {
      "background-color": "#424242",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "input-box",
    staticStyle: {
      "width": "250px",
      "margin-bottom": "0",
      "margin-right": "12px",
      "height": "33px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchPhrase),
      expression: "searchPhrase"
    }],
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "searchTermInput"
    },
    domProps: {
      "value": (_vm.searchPhrase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchPhrase = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "hidden-button",
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_vm._v("Search Stock Images")])]), _vm._v(" "), (_vm.images && (_vm.images.mmCatalogue || _vm.images.gettyCreative || _vm.images.gettyEditorial || _vm.images.unsplash)) ? _c('div', [_c('md-tabs', {
    on: {
      "md-changed": _vm.changeImagesTab
    },
    scopedSlots: _vm._u([{
      key: "md-tab",
      fn: function(ref) {
        var tab = ref.tab;

        return [_vm._v("\n        " + _vm._s(tab.label) + " "), (tab.data.badge) ? _c('i', {
          staticClass: "badge"
        }, [_vm._v(_vm._s(tab.data.badge))]) : _vm._e()]
      }
    }])
  }, [(_vm.images.mmCatalogue) ? _c('md-tab', {
    attrs: {
      "id": "mmCatalogue",
      "md-label": "MM Catalogue",
      "md-template-data": {
        badge: _vm.images.mmCatalogue.length
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "upload",
      "md-label": "Upload"
    }
  }), _vm._v(" "), (_vm.images.gettyEditorial) ? _c('md-tab', {
    attrs: {
      "id": "gettyEditorial",
      "md-label": "Getty Editorial",
      "md-template-data": {
        badge: _vm.images.gettyEditorial.length
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.images.gettyCreative) ? _c('md-tab', {
    attrs: {
      "id": "gettyCreative",
      "md-label": "Getty Creative",
      "md-template-data": {
        badge: _vm.images.gettyCreative.length
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.images.unsplash) ? _c('md-tab', {
    attrs: {
      "id": "unsplash",
      "md-label": "Unsplash",
      "md-template-data": {
        badge: _vm.images.unsplash.length
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [('upload' == _vm.currentTab) ? _c('md-content', [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "space-around"
    }
  }, [_c('image-upload', {
    on: {
      "file-array": _vm.processFileDataEdit
    }
  }, [_vm._v("UPLOAD AND EDIT")]), _vm._v(" "), _c('image-upload', {
    on: {
      "file-array": _vm.processFileDataCrop
    }
  }, [_vm._v("UPLOAD AND CROP")])], 1), _vm._v(" "), _c('div', {
    staticClass: "input-box",
    staticStyle: {
      "width": "400px",
      "height": "33px",
      "margin": "10px auto",
      "display": "block",
      "max-width": "80%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.associatedText),
      expression: "associatedText"
    }],
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "searchTermInput",
      "placeholder": "Enter text to help find it later..."
    },
    domProps: {
      "value": (_vm.associatedText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.associatedText = $event.target.value
      }
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.images), function(imageList, listKey) {
    return _c('div', {
      key: listKey
    }, [(listKey == _vm.currentTab) ? _c('md-content', [_c('div', {
      staticClass: "grid"
    }, [_c('div', {
      staticClass: "grid-sizer"
    }), _vm._v(" "), _vm._l((imageList), function(item, key) {
      return _c('div', {
        key: key,
        staticClass: "grid-item"
      }, [(item.type == 'getty') ? _c('div', [_c('img', {
        attrs: {
          "src": item.preview
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "hidden-buttons"
      }, [_c('button', {
        staticClass: "hidden-button",
        on: {
          "click": function($event) {
            _vm.buyThenEmit({
              nextStep: 'second'
            })
          }
        }
      }, [_vm._v("BUY AND EDIT")]), _vm._v(" "), _c('button', {
        staticClass: "hidden-button",
        on: {
          "click": function($event) {
            _vm.buyThenEmit({
              nextStep: 'third'
            })
          }
        }
      }, [_vm._v("BUY AND CROP")])])]) : _vm._e(), _vm._v(" "), (item.type == 'catalogue') ? _c('div', [_c('img', {
        attrs: {
          "src": item.url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "hidden-buttons"
      }, [_c('button', {
        staticClass: "hidden-button",
        on: {
          "click": function($event) {
            _vm.$emit('process-file-url', {
              url: item.url,
              nextStep: 'second',
              catalogueImage: true
            })
          }
        }
      }, [_vm._v("EDIT IMAGE")]), _vm._v(" "), _c('button', {
        staticClass: "hidden-button",
        on: {
          "click": function($event) {
            _vm.$emit('process-file-url', {
              url: item.url,
              nextStep: 'third',
              catalogueImage: true
            })
          }
        }
      }, [_vm._v("CROP IMAGE")])])]) : _vm._e(), _vm._v(" "), (item.type == 'unsplash') ? _c('div', [_c('img', {
        attrs: {
          "src": item.url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "hidden-buttons"
      }, [_c('button', {
        staticClass: "hidden-button",
        on: {
          "click": function($event) {
            _vm.$emit('done', {
              url: item.url,
              searchText: item.photo.description || '' + ' ' + item.photo.alt_description || '' + ' ' + item.photo.categories.join(',')
            })
          }
        }
      }, [_vm._v("SELECT")])])]) : _vm._e()])
    })], 2)]) : _vm._e()], 1)
  })], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              ARE YOU SURE YOU WANT TO DELETE USER ?\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.deleteUser
    }
  }, [_vm._v("\n                YES, DELETE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button cancel-delete-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex",
    style: ('width:880px;margin:10px auto;padding:20px;background-color:' + _vm.value.backgroundColor.hex + ';')
  }, [_c('div', {
    staticStyle: {
      "margin-right": "10px",
      "flex": "1"
    }
  }, [_c('div', {
    staticClass: "image-parent"
  }, [_c('img', {
    attrs: {
      "src": _vm.value.image.mobile || 'https://firebasestorage.googleapis.com/v0/b/mamamia-pwa.appspot.com/o/images%2FAMamamiasStory_Image-01.png129?alt=media&token=15b9cc5d-63c5-49e6-b253-d6a88cba0814'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-uploader"
  }, [_c('button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": _vm.changeImage
    }
  }, [_vm._v("CHANGE IMAGE")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.caption),
      expression: "value.caption"
    }],
    attrs: {
      "placeholder": "Enter a caption..."
    },
    domProps: {
      "value": (_vm.value.caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "caption", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.source),
      expression: "value.source"
    }],
    attrs: {
      "placeholder": "Enter a source..."
    },
    domProps: {
      "value": (_vm.value.source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "source", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('slider-picker', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    model: {
      value: (_vm.value.backgroundColor),
      callback: function($$v) {
        _vm.$set(_vm.value, "backgroundColor", $$v)
      },
      expression: "value.backgroundColor"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.backgroundColor.hex),
      expression: "value.backgroundColor.hex"
    }],
    attrs: {
      "placeholder": "Hex colour"
    },
    domProps: {
      "value": (_vm.value.backgroundColor.hex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value.backgroundColor, "hex", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('froala-editor', {
    staticStyle: {
      "width": "100%",
      "margin": "0",
      "min-height": "100%"
    },
    attrs: {
      "config": _vm.froalaConfig
    },
    model: {
      value: (_vm.value.wysiwyg),
      callback: function($$v) {
        _vm.$set(_vm.value, "wysiwyg", $$v)
      },
      expression: "value.wysiwyg"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-width"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.title),
      expression: "value.title"
    }],
    attrs: {
      "placeholder": "Enter a title..."
    },
    domProps: {
      "value": (_vm.value.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.subtitle),
      expression: "value.subtitle"
    }],
    attrs: {
      "placeholder": "Enter a subtitle.."
    },
    domProps: {
      "value": (_vm.value.subtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "subtitle", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-parent"
  }, [_c('img', {
    attrs: {
      "src": _vm.value.image.mobile
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-uploader"
  }, [_c('button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": _vm.changeImage
    }
  }, [_vm._v("CHANGE IMAGE")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.mediaId),
      expression: "value.mediaId"
    }],
    attrs: {
      "placeholder": "Enter a jwplayer media id.."
    },
    domProps: {
      "value": (_vm.value.mediaId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "mediaId", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "x-button",
    on: {
      "click": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "modal-header"
  }, [(_vm.mode.add) ? _vm._t("header", [_vm._v("Add an item")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.checkType(_vm.currentWidget.type, 'article') && (_vm.mode.add || _vm.currentWidget.type == 'hero')) ? _vm._t("body", [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "modal-input",
    attrs: {
      "placeholder": "Search Mamamia..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }, _vm.searchForTerm]
    }
  }), _vm._v(" "), (_vm.searchResults) ? _c('div', {
    staticStyle: {
      "font-size": "10px",
      "color": "black",
      "max-height": "45vh",
      "overflow": "auto",
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "searchResults"
    }
  }, _vm._l((_vm.searchResults), function(result, key) {
    return _c('div', {
      key: key,
      class: 'result flex-row ' + (_vm.selectedItem == result ? 'selectedItem' : ''),
      on: {
        "click": [function($event) {
          _vm.selectedItem = result
        }, _vm.onSelected]
      }
    }, [_c('div', [_c('img', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "src": result.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex1"
    }, [_c('h2', {
      domProps: {
        "innerHTML": _vm._s(result.algoliaTitle)
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(result.algoliaContent)
      }
    })])])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'podcast')) ? _vm._t("body", [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.podcastPlaylist),
      expression: "podcastPlaylist"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.podcastPlaylist = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.podcasts), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": {
          slug: item['.key'],
          title: item.title
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'video')) ? _vm._t("body", [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoPlaylist),
      expression: "videoPlaylist"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.videoPlaylist = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.videos), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": {
          slug: item['.key'],
          title: item.title
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'article') && _vm.currentWidget.type !== 'hero') ? _vm._t("body", [_c('modal-multi-article', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "newWidgetOrder": _vm.newWidgetOrder,
      "mode": _vm.mode,
      "storage": _vm.storage
    },
    on: {
      "setWidgetData": function($event) {
        _vm.$emit('setWidgetData', $event)
      },
      "reorder": _vm.reorder
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'author') && _vm.currentWidget.type !== 'hero') ? _vm._t("body", [_c('modal-multi-author', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "newWidgetOrder": _vm.newWidgetOrder,
      "mode": _vm.mode,
      "storage": _vm.storage
    },
    on: {
      "setWidgetData": function($event) {
        _vm.$emit('setWidgetData', $event)
      },
      "reorder": _vm.reorder
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'article') && _vm.currentWidget.type === 'hero') ? _vm._t("body", [_c('modal-single-article', {
    attrs: {
      "storage": _vm.storage,
      "selectedItem": _vm.selectedItem,
      "previewImage": _vm.previewImage,
      "mode": _vm.mode
    },
    model: {
      value: (_vm.previewImage),
      callback: function($$v) {
        _vm.previewImage = $$v
      },
      expression: "previewImage"
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'article')) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.emitArticle
    }
  }, [_vm._v(_vm._s(_vm.mode.edit ? 'Save' : 'Create'))]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'author')) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.updateAuthors
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'podcast')) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('create', _vm.podcastPlaylist)
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (_vm.checkType(_vm.currentWidget.type, 'video')) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('create', _vm.videoPlaylist)
      }
    }
  }, [_vm._v("Create")]) : _vm._e()])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "add-brand-button",
    on: {
      "click": _vm.showModalAddBranded
    }
  }, [_vm._v("ADD NEW BRANDED ARTICLE")]), _vm._v(" "), (_vm.showBrandedModal) ? _c('modal-branded', {
    attrs: {
      "modal": _vm.showBrandedModal,
      "passedValue": _vm.probTotal
    },
    on: {
      "update:modal": function($event) {
        _vm.showBrandedModal = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("ARTICLE SLUG")]), _vm._v(" "), _c('th', [_vm._v("ACTIVE")]), _vm._v(" "), _c('th', [_vm._v("LOCATION")]), _vm._v(" "), _c('th', [_vm._v("TARGETED PAGEVIEWS")]), _vm._v(" "), _c('th', [_vm._v("CURRENT PAGEVIEWS")]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    class: _vm.order.startDate !== null ? (_vm.order.startDate ? 'asc' : 'desc') : '',
    on: {
      "click": function($event) {
        _vm.sort('startDate')
      }
    }
  }, [_c('div', [_vm._v("\n            CAMPAIGN START DATE\n            "), _c('svg', {
    staticClass: "up-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    }
  }), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    }
  }), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "sortable",
    class: _vm.order.endDate !== null ? (_vm.order.endDate ? 'asc' : 'desc') : '',
    on: {
      "click": function($event) {
        _vm.sort('endDate')
      }
    }
  }, [_c('div', [_vm._v("\n          CAMPAIGN END DATE\n          "), _c('svg', {
    staticClass: "up-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    }
  }), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    }
  }), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])])]), _vm._v(" "), _c('th', [_vm._v("PROBABILITY OF SURFACING")]), _vm._v(" "), _c('th', [_vm._v("% PV TARGET LIKELY TO BE ACHIEVED")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.brandedData), function(item, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s(item.data.url))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data.active))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data.location ? item.data.location : 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data.pageviews))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data.currentPageviews))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data.startDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.data.endDate))]), _vm._v(" "), _c('td', {
      staticClass: "probability"
    }, [_vm._v(_vm._s(item.data.probability)), (item.data.location !== 'All States' && item.data.location !== undefined) ? _c('span', [_vm._v(" " + _vm._s(_vm.adjustProbForState(item.data)))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.brandedDataCalculatedDelivery[key] ? ((_vm.brandedDataCalculatedDelivery[key]) + " %") : "N/A"))]), _vm._v(" "), _c('td', [_c('modal-editbrand', {
      attrs: {
        "passedItem": item
      }
    })], 1), _vm._v(" "), _c('td', [_c('modal-delbrand', {
      attrs: {
        "passedItem": item
      }
    })], 1)])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "latest-stories-container"
  }, [_c('div', [_c('button', {
    on: {
      "click": _vm.newItem
    }
  }, [_vm._v("Add Author")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.title),
      expression: "currentWidget.title"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "placeholder": "title"
    },
    domProps: {
      "value": (_vm.currentWidget.title)
    },
    on: {
      "change": function($event) {
        _vm.$emit('setWidgetData', {
          'key': 'title',
          'value': _vm.currentWidget.title
        })
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.subtitle),
      expression: "currentWidget.subtitle"
    }],
    staticStyle: {
      "width": "100%",
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "subtitle"
    },
    domProps: {
      "value": (_vm.currentWidget.subtitle)
    },
    on: {
      "change": function($event) {
        _vm.$emit('setWidgetData', {
          'key': 'subtitle',
          'value': _vm.currentWidget.subtitle
        })
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget, "subtitle", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.processImg($event)
      }
    }
  }), _vm._v(" "), (_vm.initialOrder.length !== 0) ? _c('draggable', {
    staticClass: "latest-stories-draggable",
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      },
      "change": _vm.reorderItems
    },
    model: {
      value: (_vm.initialOrder),
      callback: function($$v) {
        _vm.initialOrder = $$v
      },
      expression: "initialOrder"
    }
  }, _vm._l((_vm.initialOrder), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "border flex-row"
    }, [_c('svg', {
      staticClass: "draggable-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card flex-row"
    }, [_c('a', {
      staticClass: "post-link flex-column-ats",
      attrs: {
        "href": "#"
      }
    }, [(!item.image) ? _c('img', {
      staticClass: "object-fit lazyload-images loaded",
      attrs: {
        "src": item.tempImage
      }
    }) : _vm._e(), _vm._v(" "), (item.image) ? _c('div', {
      staticClass: "new-image-container"
    }, [_c('img', {
      staticClass: "upload-image",
      attrs: {
        "src": item.image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "new-image-details"
    }, [(item.image) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.deleteImage(item.image, key)
        }
      }
    }, [_vm._v("Remove Item")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [(!_vm.showEditText || _vm.currentIndex !== key) ? _c('h3', {
      on: {
        "click": function($event) {
          _vm.selectTextInput(key, item)
        }
      }
    }, [_vm._v(_vm._s(item.slug || 'Slug'))]) : _vm._e(), _vm._v(" "), (!_vm.showEditText || _vm.currentIndex !== key) ? _c('h3', {
      on: {
        "click": function($event) {
          _vm.selectTextInput(key, item)
        }
      }
    }, [_vm._v(_vm._s(item.name || 'Name'))]) : _vm._e(), _vm._v(" "), (!_vm.showEditText || _vm.currentIndex !== key) ? _c('h3', {
      on: {
        "click": function($event) {
          _vm.selectTextInput(key, item)
        }
      }
    }, [_vm._v(_vm._s(item.description || 'Description'))]) : _vm._e(), _vm._v(" "), _c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.getText(key)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showEditText && _vm.currentIndex === key),
        expression: "showEditText && currentIndex === key"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.form.newSlug),
        expression: "form.newSlug"
      }],
      ref: "slugInput",
      refInFor: true,
      staticClass: "title-input",
      attrs: {
        "type": "text",
        "placeholder": "Enter Slug",
        "required": ""
      },
      domProps: {
        "value": (_vm.form.newSlug)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "newSlug", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showEditText && _vm.currentIndex === key),
        expression: "showEditText && currentIndex === key"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.form.newName),
        expression: "form.newName"
      }],
      ref: "nameInput",
      refInFor: true,
      staticClass: "title-input",
      attrs: {
        "type": "text",
        "placeholder": "Enter Name",
        "required": ""
      },
      domProps: {
        "value": (_vm.form.newName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "newName", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showEditText && _vm.currentIndex === key),
        expression: "showEditText && currentIndex === key"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.form.newDescription),
        expression: "form.newDescription"
      }],
      ref: "descriptionInput",
      refInFor: true,
      staticClass: "title-input",
      attrs: {
        "type": "text",
        "placeholder": "Enter Description",
        "required": ""
      },
      domProps: {
        "value": (_vm.form.newDescription)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "newDescription", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showEditText && _vm.currentIndex === key),
        expression: "showEditText && currentIndex === key"
      }],
      staticClass: "edit-menu",
      attrs: {
        "id": "test"
      }
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.clickInput(key)
        }
      }
    }, [_vm._v("Update")]), _c('button', {
      staticClass: "cancel-edit",
      on: {
        "click": function($event) {
          _vm.cancelTextInput()
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div', {
      staticClass: "post-author flex-row-ats flex-align-end flex-justify-center flex1"
    }, [_c('div', {
      staticClass: "author-meta flex-column flex-justify-space-between flex-align-center top-story-meta"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "card-menu"
    }, [_c('svg', {
      staticClass: "add-photo",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      },
      on: {
        "click": function($event) {
          _vm.selectImg(key)
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "remove-x",
      on: {
        "click": function($event) {
          _vm.removeItem(key)
        }
      }
    }, [_vm._v("×")])])])
  })) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "800px",
      "margin": "10px auto"
    }
  }, [_c('div', {
    staticClass: "image-parent"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.value.image.mobile || 'https://firebasestorage.googleapis.com/v0/b/mamamia-pwa.appspot.com/o/images%2FAMamamiasStory_Image-01.png129?alt=media&token=15b9cc5d-63c5-49e6-b253-d6a88cba0814'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-uploader"
  }, [_c('button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": _vm.changeImage
    }
  }, [_vm._v("CHANGE IMAGE")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.caption),
      expression: "value.caption"
    }],
    attrs: {
      "placeholder": "Enter a caption..."
    },
    domProps: {
      "value": (_vm.value.caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "caption", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.source),
      expression: "value.source"
    }],
    attrs: {
      "placeholder": "Enter a source..."
    },
    domProps: {
      "value": (_vm.value.source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "source", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "selectHolder"
  }, [_c('span', [_vm._v("Decoration Style")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.decorationStyle),
      expression: "value.decorationStyle"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.value, "decorationStyle", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "option-1"
    }
  }, [_vm._v("Standard")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "option-2"
    }
  }, [_vm._v("Stars")])])])])
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "results"
  }, [(_vm.value) ? _c('div', {
    staticClass: "ind"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.title),
      expression: "value.title"
    }],
    staticClass: "link",
    domProps: {
      "value": (_vm.value.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "title", $event.target.value)
      }
    }
  }), _c('br'), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("https://www.mamamia.com.au/" + _vm._s(_vm.slug) + " ▾")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.description),
      expression: "value.description"
    }],
    staticClass: "desc",
    attrs: {
      "type": "text",
      "placeholder": "Enter between 120 and 156 characters"
    },
    domProps: {
      "value": (_vm.value.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "description", $event.target.value)
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid-x', {
    attrs: {
      "col": _vm.columns,
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [(_vm.showUploader === 'hero') ? _c('div', [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.title),
      expression: "item.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Hero Text"
    },
    domProps: {
      "value": (_vm.item.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "title", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("Image Preview")]), _vm._v(" "), (_vm.showUploader === 'hero') ? _c('div', {
    staticClass: "hero-preview"
  }, [_c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.switchHero('mobile')
      }
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.switchHero('desktop')
      }
    }
  }, [_vm._v("Desktop")])]), _vm._v(" "), _c('div', {
    staticClass: "desktop-preview"
  }, [_c('div', {
    ref: "hero",
    staticClass: "hero-image desktop"
  }, [_c('img', {
    staticClass: "object-fit",
    attrs: {
      "src": _vm.previewImage ? _vm.previewImage : _vm.item.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-text"
  }, [_c('h2', {
    staticClass: "hero-text-title",
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hero-author"
  }, [_c('i', [_vm._v("by")]), _vm._v("\n              " + _vm._s(_vm.item.authorName ? _vm.item.authorName : "Boaty McBoatface") + "\n            ")])])])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid-x', {
    attrs: {
      "col": "1fr 7fr",
      "rows": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Competitions")]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetitionKey),
      expression: "selectedCompetitionKey"
    }],
    ref: "competitionSelector",
    staticClass: "podcast-list-select",
    on: {
      "focus": function($event) {
        _vm.changeColor()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCompetitionKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a competition")]), _vm._v(" "), _vm._l((_vm.competitions), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": item['.key']
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.showNewCompetition = !_vm.showNewCompetition
      }
    }
  }, [_vm._v("New Competition")])]), _vm._v(" "), (_vm.showNewCompetition) ? _c('div', [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompetition.name),
      expression: "newCompetition.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Competition Name"
    },
    domProps: {
      "value": (_vm.newCompetition.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompetition, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.createCompetition
    }
  }, [_vm._v("Create Competition")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-2",
    staticStyle: {
      "padding-right": "100px"
    }
  }, [(_vm.selectedCompetitionKey) ? _c('div', {
    staticClass: "section-title"
  }, [_c('h3', [_vm._v(_vm._s(_vm.selectedCompetition.name))]), _vm._v(" "), _c('div', {
    staticClass: "tab-container"
  }, [_c('button', {
    class: {
      'active-tab': _vm.currentTab === 'post', tab: true
    },
    on: {
      "click": function($event) {
        _vm.currentTab = 'post';
      }
    }
  }, [_vm._v("Manage Post")]), _vm._v(" "), _c('button', {
    class: {
      'active-tab': _vm.currentTab === 'results', tab: true
    },
    on: {
      "click": function($event) {
        _vm.currentTab = 'results';
        _vm.getResults();
      }
    }
  }, [_vm._v("View Results")])])]) : _vm._e(), _vm._v(" "), _c('grid-x', {
    attrs: {
      "col": "2fr 0.5fr",
      "rows": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-2-1"
  }, [(_vm.selectedCompetitionKey) ? _c('div', [(_vm.currentTab == 'post') ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetition.title),
      expression: "selectedCompetition.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.selectedCompetition.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedCompetition, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('froala-editor', {
    model: {
      value: (_vm.selectedCompetition.writtenContent),
      callback: function($$v) {
        _vm.$set(_vm.selectedCompetition, "writtenContent", $$v)
      },
      expression: "selectedCompetition.writtenContent"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "fb-editor"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'results') ? _c('div', [(_vm.results && _vm.results.length > 0) ? _c('div', [_c('button', {
    on: {
      "click": function($event) {
        _vm.exportCsv()
      }
    }
  }, [_vm._v("Export To CSV")]), _vm._v(" "), _c('table', [_vm._l((_vm.results[0]), function(field, key, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(key))])
  }), _vm._v(" "), _vm._l((_vm.results), function(row, index) {
    return _c('tr', {
      key: index
    }, _vm._l((row), function(data, index) {
      return _c('td', {
        key: index
      }, [_vm._v(_vm._s(data))])
    }))
  })], 2)]) : _c('div', [_vm._v("No results")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [(_vm.selectedCompetition.status == 'draft' || _vm.selectedCompetition.status == 'preview') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.publishCompetition();
      }
    }
  }, [_vm._v("Publish")]) : _vm._e(), _vm._v(" "), (_vm.selectedCompetition.status == 'draft') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.previewCompetition();
      }
    }
  }, [_vm._v("Preview")]) : _vm._e(), _vm._v(" "), (_vm.selectedCompetition.status == 'publish' || _vm.selectedCompetition.status == 'preview') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.unpublishCompetition();
      }
    }
  }, [_vm._v("Unpublish")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.saveCompData(_vm.selectedCompetition)
      }
    }
  }, [_vm._v("SAVE")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-2-2"
  }, [(_vm.currentTab == 'post' && _vm.selectedCompetitionKey) ? _c('div', [_c('h1', [_vm._v("Meta")]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Slug")]), _vm._v(" "), _c('div', {
    class: 'input-box slug-input ' + _vm.slugValid
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetition.slug),
      expression: "selectedCompetition.slug"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Slug"
    },
    domProps: {
      "value": (_vm.selectedCompetition.slug)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedCompetition, "slug", $event.target.value)
      }, _vm.checkSlug]
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-top": "5px",
      "padding-right": "5px"
    }
  }, [_vm._v(_vm._s(_vm.slugValid))])]), _vm._v(" "), (_vm.selectedCompetition.meta) ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetition.meta.title),
      expression: "selectedCompetition.meta.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Title"
    },
    domProps: {
      "value": (_vm.selectedCompetition.meta.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedCompetition.meta, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Description")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetition.meta.description),
      expression: "selectedCompetition.meta.description"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Description"
    },
    domProps: {
      "value": (_vm.selectedCompetition.meta.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedCompetition.meta, "description", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('div', {
    staticClass: "tag-input-container"
  }, [_c('tag-input', {
    attrs: {
      "options": _vm.tags,
      "placeholder": "Enter tags",
      "value": _vm.selectedCompetition.tags,
      "multiple": true
    },
    on: {
      "value": _vm.updateTags
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Select Category")]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetition.parentCategory),
      expression: "selectedCompetition.parentCategory"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedCompetition, "parentCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.selectCategory()
      }]
    }
  }, _vm._l((_vm.categories), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": item.name
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), (_vm.categoryChanged) ? _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCompetition.subCategory),
      expression: "selectedCompetition.subCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedCompetition, "subCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.subCategories), function(subitem, subkey) {
    return _c('option', {
      key: subkey,
      domProps: {
        "value": subitem.name
      }
    }, [_vm._v(_vm._s(subitem.name))])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "featured-images"
  }, [_c('h3', [_vm._v("Featured Image")]), _vm._v(" "), (_vm.selectedCompetition.image) ? _c('img', {
    attrs: {
      "src": _vm.selectedCompetition.image
    }
  }) : _vm._e(), _vm._v(" "), _c('ic-firebase-upload', {
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": function($event) {
        _vm.onUploadedCompImage($event, 'image')
      },
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    },
    model: {
      value: (_vm.selectedCompetition.image),
      callback: function($$v) {
        _vm.$set(_vm.selectedCompetition, "image", $$v)
      },
      expression: "selectedCompetition.image"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "social-images"
  }, [_c('h3', [_vm._v("Social Image")]), _vm._v(" "), (_vm.selectedCompetition.socialImage) ? _c('img', {
    attrs: {
      "src": _vm.selectedCompetition.socialImage
    }
  }) : _vm._e(), _vm._v(" "), _c('ic-firebase-upload', {
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": function($event) {
        _vm.onUploadedCompImage($event, 'socialImage')
      },
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    },
    model: {
      value: (_vm.selectedCompetition.socialImage),
      callback: function($$v) {
        _vm.$set(_vm.selectedCompetition, "socialImage", $$v)
      },
      expression: "selectedCompetition.socialImage"
    }
  })], 1)])]) : _vm._e()])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('multiselect', {
    attrs: {
      "value": _vm.selected ? _vm.selected : _vm.formattedValue,
      "placeholder": _vm.placeholder,
      "options": _vm.formattedOptions,
      "label": "item",
      "track-by": "item",
      "multiple": _vm.multiple,
      "taggable": true,
      "showNoResults": true
    },
    on: {
      "input": _vm.updateValue,
      "tag": _vm.create
    }
  })
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up"
  }, [_c('p', [_vm._v("Let's create a new account !")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.signUp
    }
  }, [_vm._v("Sign Up")]), _vm._v(" "), _c('span', [_vm._v("or go back to "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("login")]), _vm._v(".")], 1)])
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selectedItem.slug || _vm.mode.edit) ? _c('div', [(_vm.selectedItem.slug) ? _c('div', {
    staticClass: "upload-container"
  }, [_c('ic-firebase-upload', {
    ref: "upload",
    staticClass: "upload-btn",
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": _vm.onUploaded,
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.previewImage,
      "alt": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('hero-preview', {
    attrs: {
      "item": _vm.selectedItem,
      "previewImage": _vm.previewImage
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "840px",
      "margin": "10px auto"
    }
  }, [_c('div', {
    staticClass: "image-parent"
  }, [_c('img', {
    attrs: {
      "src": _vm.value.image.mobile || 'https://firebasestorage.googleapis.com/v0/b/mamamia-pwa.appspot.com/o/images%2FAMamamiasStory_Image-01.png129?alt=media&token=15b9cc5d-63c5-49e6-b253-d6a88cba0814'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-uploader"
  }, [_c('button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": _vm.changeImage
    }
  }, [_vm._v("CHANGE IMAGE")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.caption),
      expression: "value.caption"
    }],
    attrs: {
      "placeholder": "Enter a caption..."
    },
    domProps: {
      "value": (_vm.value.caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "caption", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.source),
      expression: "value.source"
    }],
    attrs: {
      "placeholder": "Enter a source..."
    },
    domProps: {
      "value": (_vm.value.source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "source", $event.target.value)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              BRANDED ARTICLE DETAILS\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n              Location\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand.location),
      expression: "newBrand.location"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newBrand, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Please Select Location")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.text,
      domProps: {
        "value": state.text
      }
    }, [_vm._v("\n                    " + _vm._s(state.text) + "\n                  ")])
  })], 2)]), _vm._v("\n              Branded article slug\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand.url),
      expression: "newBrand.url"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newBrand.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBrand, "url", $event.target.value)
      }
    }
  })]), _vm._v("\n              Pageviews needed\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand.pageviews),
      expression: "newBrand.pageviews"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newBrand.pageviews)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBrand, "pageviews", $event.target.value)
      }
    }
  })]), _vm._v("\n              Current pageviews\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand.currentPageviews),
      expression: "newBrand.currentPageviews"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newBrand.currentPageviews)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBrand, "currentPageviews", $event.target.value)
      }
    }
  })]), _vm._v("\n              Pageviews needed by which date?\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand.endDate),
      expression: "newBrand.endDate"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.newBrand.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBrand, "endDate", $event.target.value)
      }
    }
  })]), _vm._v("\n              Probability\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBrand.probability),
      expression: "newBrand.probability"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.newBrand.probability)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBrand, "probability", $event.target.value)
      }
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.addNewBrand
    }
  }, [_vm._v("\n                ADD ARTICLE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "latest-stories-container"
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.processImg($event)
      }
    }
  }), _vm._v(" "), (_vm.initialOrder.length !== 0) ? _c('draggable', {
    staticClass: "latest-stories-draggable",
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      },
      "change": _vm.reorderItems
    },
    model: {
      value: (_vm.initialOrder),
      callback: function($$v) {
        _vm.initialOrder = $$v
      },
      expression: "initialOrder"
    }
  }, _vm._l((_vm.initialOrder), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "border flex-row"
    }, [_c('svg', {
      staticClass: "draggable-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card flex-row"
    }, [_c('a', {
      staticClass: "post-link flex-column-ats",
      attrs: {
        "href": "#"
      }
    }, [(!item.image) ? _c('img', {
      staticClass: "object-fit lazyload-images loaded",
      attrs: {
        "src": item.tempImage
      }
    }) : _vm._e(), _vm._v(" "), (item.image) ? _c('div', {
      staticClass: "new-image-container"
    }, [_c('img', {
      staticClass: "upload-image",
      attrs: {
        "src": item.image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "new-image-details"
    }, [(item.image) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.deleteImage(item.image, key)
        }
      }
    }, [_vm._v("Remove Item")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('span', {
      staticClass: "card-category btn btn-pink"
    }, [_vm._v("tv")]), _vm._v(" "), (!_vm.showEditText || _vm.currentIndex !== key) ? _c('h3', {
      on: {
        "click": function($event) {
          _vm.selectTextInput(key)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), _c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.getText(key)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showEditText && _vm.currentIndex === key),
        expression: "showEditText && currentIndex === key"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.form.newTitle),
        expression: "form.newTitle"
      }, {
        name: "focus",
        rawName: "v-focus"
      }],
      ref: "titleInput",
      refInFor: true,
      staticClass: "title-input",
      attrs: {
        "type": "text",
        "placeholder": item.title,
        "required": ""
      },
      domProps: {
        "value": (_vm.form.newTitle)
      },
      on: {
        "blur": function($event) {
          _vm.showEditText = false
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "newTitle", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "post-author flex-row-ats flex-align-end flex-justify-center flex1"
    }, [_c('div', {
      staticClass: "author-meta flex-column flex-justify-space-between flex-align-center top-story-meta"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "card-menu"
    }, [_c('svg', {
      staticClass: "add-photo",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      },
      on: {
        "click": function($event) {
          _vm.selectImg(key)
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "remove-x",
      on: {
        "click": function($event) {
          _vm.removeItem(key)
        }
      }
    }, [_vm._v("×")])])])
  })) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              Tick the permissions required\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.permission),
      expression: "passedObject.permission"
    }],
    attrs: {
      "type": "checkbox",
      "id": "admin",
      "value": "admin"
    },
    domProps: {
      "checked": Array.isArray(_vm.passedObject.permission) ? _vm._i(_vm.passedObject.permission, "admin") > -1 : (_vm.passedObject.permission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.passedObject.permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "admin",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.passedObject.permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.passedObject.permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.passedObject, "permission", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "admin"
    }
  }, [_vm._v("admin")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.permission),
      expression: "passedObject.permission"
    }],
    attrs: {
      "type": "checkbox",
      "id": "role-editor",
      "value": "editor"
    },
    domProps: {
      "checked": Array.isArray(_vm.passedObject.permission) ? _vm._i(_vm.passedObject.permission, "editor") > -1 : (_vm.passedObject.permission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.passedObject.permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "editor",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.passedObject.permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.passedObject.permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.passedObject, "permission", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "role-editor"
    }
  }, [_vm._v("editor")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.permission),
      expression: "passedObject.permission"
    }],
    attrs: {
      "type": "checkbox",
      "id": "podcast",
      "value": "podcast"
    },
    domProps: {
      "checked": Array.isArray(_vm.passedObject.permission) ? _vm._i(_vm.passedObject.permission, "podcast") > -1 : (_vm.passedObject.permission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.passedObject.permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "podcast",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.passedObject.permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.passedObject.permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.passedObject, "permission", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "podcast"
    }
  }, [_vm._v("podcast")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.permission),
      expression: "passedObject.permission"
    }],
    attrs: {
      "type": "checkbox",
      "id": "video",
      "value": "video"
    },
    domProps: {
      "checked": Array.isArray(_vm.passedObject.permission) ? _vm._i(_vm.passedObject.permission, "video") > -1 : (_vm.passedObject.permission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.passedObject.permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "video",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.passedObject.permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.passedObject.permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.passedObject, "permission", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "video"
    }
  }, [_vm._v("video")])]), _vm._v(" "), _c('div', {
    staticClass: "user-edit-screen"
  }, [_c('md-autocomplete', {
    attrs: {
      "md-options": _vm.authors || []
    },
    on: {
      "md-changed": _vm.getAuthors,
      "md-opened": _vm.getAuthors
    },
    scopedSlots: _vm._u([{
      key: "md-autocomplete-empty",
      fn: function(ref) {
        var term = ref.term;

        return [_vm._v("\n                    No Authors matching \"" + _vm._s(term) + "\" were found.\n                  ")]
      }
    }, {
      key: "md-autocomplete-item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticStyle: {
            "font-size": "initial"
          }
        }, [_vm._v(_vm._s(item))])]
      }
    }]),
    model: {
      value: (_vm.passedObject.defaultAuthor),
      callback: function($$v) {
        _vm.$set(_vm.passedObject, "defaultAuthor", $$v)
      },
      expression: "passedObject.defaultAuthor"
    }
  }, [_c('label', [_vm._v("Author")])])], 1)])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.editUser
    }
  }, [_vm._v("\n                UPDATE USER\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button cancel-delete-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.parentClass,
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('img', {
    attrs: {
      "id": "image",
      "src": _vm.cropImageUrl
    }
  })]), _vm._v(" "), (_vm.aspectRatio && _vm.aspectRatio['desktop']) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    class: _vm.crops.mobile.done ? 'done' : '',
    on: {
      "click": function($event) {
        _vm.cropMode = 'mobile'
      }
    }
  }, [_vm._v("MOBILE")]), _vm._v(" "), _c('button', {
    class: _vm.crops.desktop.done ? 'done' : '',
    on: {
      "click": function($event) {
        _vm.cropMode = 'desktop'
      }
    }
  }, [_vm._v("DESKTOP")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('md-app', [_c('md-app-drawer', {
    attrs: {
      "md-permanent": "clipped"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent",
    attrs: {
      "md-elevation": "0"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(254)
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Mamamia Management System")])])]), _vm._v(" "), _c('md-list', [_c('md-divider'), _vm._v(" "), (_vm.permissionLookup('articlesSection', _vm.permission)) ? _c('md-subheader', [_vm._v("Articles")]) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('create-article', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'create-article' ? 'active-item' : 'z',
    on: {
      "click": function($event) {
        _vm.currentTab = 'create-article'
      }
    }
  }, [_c('md-icon', [_vm._v("note_add")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Create Article")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Create Article")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('articleList', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'articleList' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'articleList'
      }
    }
  }, [_c('md-icon', [_vm._v("list")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("List Articles")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("List Articles")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('articlesSection', _vm.permission)) ? _c('md-divider') : _vm._e(), _vm._v(" "), (_vm.permissionLookup('verticalsSection', _vm.permission)) ? _c('md-subheader', [_vm._v("Verticals")]) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('widgets', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'widgets' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'widgets'
      }
    }
  }, [_c('md-icon', [_vm._v("view_agenda")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Widgets")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Widgets")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('seo', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'seo' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'seo'
      }
    }
  }, [_c('md-icon', [_vm._v("pageview")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("SEO")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("SEO")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('categories', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'categories' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'categories'
      }
    }
  }, [_c('md-icon', [_vm._v("category")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Manage")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Manage Categories")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('verticalsSection', _vm.permission)) ? _c('md-divider') : _vm._e(), _vm._v(" "), (_vm.permissionLookup('videosSection', _vm.permission)) ? _c('md-subheader', [_vm._v("Videos")]) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('videos', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'videos' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'videos'
      }
    }
  }, [_c('md-icon', [_vm._v("video_library")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Playlists")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Video Playlists")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('videosSection', _vm.permission)) ? _c('md-divider') : _vm._e(), _vm._v(" "), (_vm.permissionLookup('podcastsSection', _vm.permission)) ? _c('md-subheader', [_vm._v("Podcasts")]) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('podcasts', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'podcasts' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'podcasts'
      }
    }
  }, [_c('md-icon', [_vm._v("playlist_add")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Add Podcast")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Add Podcast")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('podcasts', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'podcasts' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'podcasts'
      }
    }
  }, [_c('md-icon', [_vm._v("playlist_play")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("List Podcasts")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("List Podcasts")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('podcastsSection', _vm.permission)) ? _c('md-divider') : _vm._e(), _vm._v(" "), (_vm.permissionLookup('competitionsSection', _vm.permission)) ? _c('md-subheader', [_vm._v("Branded")]) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('branded', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'branded' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'branded'
      }
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("AJAX Tracker")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("AJAX Tracker")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('competitions', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'competitions' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'competitions'
      }
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Create Competition")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Create Competition")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('competitions', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'competitions' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'competitions'
      }
    }
  }, [_c('md-icon', [_vm._v("view_list")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("List Competitions")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("List Competitions")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('competitionsSection', _vm.permission)) ? _c('md-divider') : _vm._e(), _vm._v(" "), (_vm.permissionLookup('adminSection', _vm.permission)) ? _c('md-subheader', [_vm._v("Admin")]) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('tags', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'tags' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'tags'
      }
    }
  }, [_c('md-icon', [_vm._v("label")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Tag Management")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('users', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'users' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'users'
      }
    }
  }, [_c('md-icon', [_vm._v("supervisor_account")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Users")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("User Management")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('authors', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'authors' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'authors'
      }
    }
  }, [_c('md-icon', [_vm._v("person_outline")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Authors")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Author Management")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('adminSection', _vm.permission)) ? _c('md-divider') : _vm._e()], 1)], 1), _vm._v(" "), _c('md-app-content', [_c(_vm.currentTab, {
    tag: "component"
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "add-user-button",
    on: {
      "click": _vm.showModalAddUser
    }
  }, [_vm._v("ADD NEW USER")]), _vm._v(" "), (_vm.showUserModal) ? _c('modal-user', {
    attrs: {
      "modal": _vm.showUserModal
    },
    on: {
      "update:modal": function($event) {
        _vm.showUserModal = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("USER EMAIL")]), _vm._v(" "), _c('md-table-head', [_vm._v("AUTHOR")]), _vm._v(" "), _c('md-table-head', [_vm._v("PERMISSION")]), _vm._v(" "), _c('md-table-head'), _vm._v(" "), _c('md-table-head')], 1), _vm._v(" "), _vm._l((_vm.userData), function(item, key) {
    return _c('md-table-row', {
      key: key
    }, [_c('md-table-cell', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.defaultAuthor))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.permission))]), _vm._v(" "), _c('md-table-cell', [_c('modal-edituser', {
      attrs: {
        "passedItem": item
      }
    }, [_vm._v("EDIT USER")])], 1), _vm._v(" "), _c('md-table-cell', [_c('modal-deluser', {
      attrs: {
        "passedItem": item
      }
    }, [_vm._v("REMOVE USER")])], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              Update the fields which need change\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n              Change Location\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.data.location),
      expression: "passedObject.data.location"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.passedObject.data, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.text,
      domProps: {
        "value": state.text
      }
    }, [_vm._v("\n                    " + _vm._s(state.text) + "\n                  ")])
  }))]), _vm._v("\n              Change Active status\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.data.active),
      expression: "passedObject.data.active"
    }],
    staticClass: "radio-active",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.passedObject.data.active, true)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.passedObject.data, "active", true)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-active-span"
  }, [_vm._v("ACTIVE")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.data.active),
      expression: "passedObject.data.active"
    }],
    staticClass: "radio-active",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.passedObject.data.active, false)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.passedObject.data, "active", false)
      }
    }
  }), _c('span', {
    staticClass: "radio-active-span"
  }, [_vm._v("INACTIVE")])]), _vm._v("\n              Change Targeted Pageviews\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.data.pageviews),
      expression: "passedObject.data.pageviews"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.passedObject.data.pageviews)
    },
    on: {
      "change": _vm.pvChangeDetected,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject.data, "pageviews", $event.target.value)
      }
    }
  })]), _vm._v("\n              Change Campaign End Date\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.data.endDate),
      expression: "passedObject.data.endDate"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.passedObject.data.endDate)
    },
    on: {
      "change": _vm.dateChangeDetected,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject.data, "endDate", $event.target.value)
      }
    }
  })]), _vm._v("\n              Change Probability\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.data.probability),
      expression: "passedObject.data.probability"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.passedObject.data.probability)
    },
    on: {
      "change": _vm.probChangeDetected,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject.data, "probability", $event.target.value)
      }
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.editBrand
    }
  }, [_vm._v("\n                UPDATE ARTICLE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button cancel-delete-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "grid",
    staticClass: "grid"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.mode.add && _vm.currentWidget.type !== 'hero' && _vm.currentWidget.type !== 'author-carousel') ? _c('button', {
    staticClass: "add-item",
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("Add Item")]) : _vm._e(), _vm._v(" "), (_vm.currentWidget.type === 'top-stories') ? _c('latest-story-preview', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "mode": _vm.mode,
      "storage": _vm.storage
    },
    on: {
      "orderChange": _vm.orderChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentWidget.type === 'vertical-article-block') ? _c('latest-story-preview', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "mode": _vm.mode,
      "storage": _vm.storage
    },
    on: {
      "orderChange": _vm.orderChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentWidget.type === 'three-row-column') ? _c('lifestyle-preview', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "mode": _vm.mode,
      "maxItems": 3,
      "storage": _vm.storage
    },
    on: {
      "orderChange": _vm.orderChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentWidget.type === 'author-carousel') ? _c('author-carousel', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "mode": _vm.mode,
      "maxItems": 20,
      "storage": _vm.storage
    },
    on: {
      "orderChange": _vm.orderChange,
      "setWidgetData": function($event) {
        _vm.$emit('setWidgetData', $event)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "grid",
    staticClass: "grid"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.articleToEditKey) ? _c('div', [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Articles")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticStyle: {
      "width": "200px",
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Filter by Status")]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    attrs: {
      "label": "Status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "draft"
    }
  }, [_vm._v("draft")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "publish"
    }
  }, [_vm._v("published")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "preview"
    }
  }, [_vm._v("preview")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "200px",
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Filter by Category")]), _vm._v(" "), (_vm.showCategory) ? _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterCategory),
      expression: "filterCategory"
    }],
    attrs: {
      "label": "Category"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateSubcategories]
    }
  }, _vm._l((_vm.categories), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.subCategories) ? _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterSubcategory),
      expression: "filterSubcategory"
    }],
    attrs: {
      "label": "Subcategory"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterSubcategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.subCategories), function(subitem, subkey) {
    return _c('option', {
      key: subkey,
      domProps: {
        "value": subitem
      }
    }, [_vm._v(_vm._s(subitem))])
  }))]) : _vm._e()]), _vm._v(" "), (_vm.showTags) ? _c('div', {
    staticStyle: {
      "width": "200px",
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Filter by Tag")]), _vm._v(" "), _c('div', {
    staticClass: "input-box tag-input-container",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('tag-input', {
    attrs: {
      "options": _vm.tags,
      "placeholder": "Enter tag",
      "multiple": false
    },
    on: {
      "value": _vm.updateTag
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Article Published")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('md-datepicker', {
    attrs: {
      "md-immediately": ""
    },
    model: {
      value: (_vm.filterByTimestamp),
      callback: function($$v) {
        _vm.filterByTimestamp = $$v
      },
      expression: "filterByTimestamp"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('button', {
    staticStyle: {
      "margin-top": "20px",
      "height": "30px"
    },
    on: {
      "click": function($event) {
        _vm.clearFilters();
      }
    }
  }, [_vm._v("CLEAR FILTERS")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-1"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Search")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "modal-input",
    attrs: {
      "placeholder": "Start typing to search..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }, _vm.searchForTerm]
    }
  })])])])]), _vm._v(" "), _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("TITLE")]), _vm._v(" "), _c('md-table-head', [_vm._v("AUTHOR")]), _vm._v(" "), _c('md-table-head', [_vm._v("STATUS")]), _vm._v(" "), _c('md-table-head', [_vm._v("CATEGORY")]), _vm._v(" "), _c('md-table-head', [_vm._v("TAGS")]), _vm._v(" "), _c('md-table-head', [_vm._v("DATE")])], 1), _vm._v(" "), (_vm.searchResults.length == 0) ? _vm._l((_vm.posts), function(item, key) {
    return _c('md-table-row', {
      key: key,
      on: {
        "click": function($event) {
          _vm.editArticle(item)
        }
      }
    }, [_c('md-table-cell', {
      staticStyle: {
        "min-width": "30%"
      },
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v(_vm._s(item.authorSlug))]), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(item.status))]), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v(_vm._s(item.parentCategory) + _vm._s(item.subCategory ? " | " + item.subCategory : ""))]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "tags",
      staticStyle: {
        "min-width": "30%"
      }
    }, _vm._l((item.tags), function(tag, tagkey) {
      return _c('span', {
        key: tagkey
      }, [_vm._v(_vm._s(tag) + " ")])
    })), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(_vm._f("moment")(_vm.$moment(item.timestamp * 1000), "hh:mm DD/MM/YYYY")))])], 1)
  }) : _vm._l((_vm.searchResults), function(item, key) {
    return _c('md-table-row', {
      key: key,
      on: {
        "click": function($event) {
          _vm.editArticle(item)
        }
      }
    }, [_c('md-table-cell', {
      staticStyle: {
        "min-width": "30%"
      },
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v(_vm._s(item.author))]), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v("publish")]), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v(_vm._s(item.categories))]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "tags",
      staticStyle: {
        "min-width": "30%"
      }
    }, _vm._l((item.tags.split(',')), function(tag, tagkey) {
      return _c('span', {
        key: tagkey
      }, [_vm._v(_vm._s(tag))])
    })), _vm._v(" "), _c('md-table-cell', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(_vm._f("moment")(_vm.$moment(item.timestamp * 1000), "hh:mm DD/MM/YYYY")))])], 1)
  })], 2), _vm._v(" "), (_vm.posts.length == 20) ? _c('button', {
    staticStyle: {
      "margin": "5px auto",
      "display": "block",
      "width": "300px"
    },
    on: {
      "click": _vm.morePosts
    }
  }, [_vm._v("MORE ITEMS")]) : _vm._e()], 1) : _c('div', [_c('div', [_c('md-button', {
    staticClass: "md-icon-button md-primary",
    on: {
      "click": function($event) {
        _vm.articleToEditKey = false
      }
    }
  }, [_c('md-icon', [_vm._v("arrow_back_ios")])], 1)], 1), _vm._v(" "), _c('article-editor', {
    ref: "editor",
    on: {
      "not-found": function($event) {
        _vm.articleToEditKey = false
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "flex center-flex-y",
    on: {
      "click": _vm.showModalDeleteBrand
    }
  }, [_vm._v("REMOVE ARTICLE")]), _vm._v(" "), (_vm.showBrandDeleteModal) ? _c('modal-branddelete', {
    attrs: {
      "modal": _vm.showBrandDeleteModal,
      "passedObject": _vm.objectToPass
    },
    on: {
      "update:modal": function($event) {
        _vm.showBrandDeleteModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "flex center-flex-y",
    on: {
      "click": _vm.showModalEditAuthor
    }
  }, [_vm._v("EDIT AUTHOR")]), _vm._v(" "), (_vm.showAuthorEditModal) ? _c('modal-authoredit', {
    attrs: {
      "modal": _vm.showAuthorEditModal,
      "passedObject": _vm.objectToPass
    },
    on: {
      "update:modal": function($event) {
        _vm.showAuthorEditModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lifestyle-container"
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.processImg($event)
      }
    }
  }), _vm._v(" "), (_vm.initialOrder.length !== 0) ? _c('draggable', {
    staticClass: "lifestyle-draggable",
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      },
      "change": _vm.reorderItems
    },
    model: {
      value: (_vm.initialOrder),
      callback: function($$v) {
        _vm.initialOrder = $$v
      },
      expression: "initialOrder"
    }
  }, _vm._l((_vm.initialOrder), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "card"
    }, [_c('div', {
      staticClass: "image-bg flex center-flex"
    }, [(!item.image) ? _c('img', {
      staticClass: "object-fit lazyload-images loaded",
      attrs: {
        "src": item.tempImage
      }
    }) : _vm._e(), _vm._v(" "), (item.image) ? _c('div', {
      staticClass: "new-image-container"
    }, [_c('img', {
      staticClass: "new-image",
      attrs: {
        "src": item.image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "new-image-details"
    }, [(item.image) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.deleteImage(item.image, key)
        }
      }
    }, [_vm._v("Remove Item")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (!_vm.showEditText || _vm.currentIndex !== key) ? _c('h3', {
      on: {
        "click": function($event) {
          _vm.selectTextInput(key)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), _c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.getText(key)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showEditText && _vm.currentIndex === key),
        expression: "showEditText && currentIndex === key"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.form.newTitle),
        expression: "form.newTitle"
      }, {
        name: "focus",
        rawName: "v-focus"
      }],
      ref: "titleInput",
      refInFor: true,
      staticClass: "title-input",
      attrs: {
        "type": "text",
        "placeholder": item.title,
        "required": ""
      },
      domProps: {
        "value": (_vm.form.newTitle)
      },
      on: {
        "blur": function($event) {
          _vm.showEditText = false
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "newTitle", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "icon-container"
    }, [_c('svg', {
      staticClass: "add-photo",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      },
      on: {
        "click": function($event) {
          _vm.selectImg(key)
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    })]), _vm._v(" "), _c('svg', {
      staticClass: "draggable-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "remove-x",
      on: {
        "click": function($event) {
          _vm.removeItem(key)
        }
      }
    }, [_vm._v("×")])])])
  })) : _vm._e(), _vm._v(" "), (_vm.initialOrder.length < _vm.maxItems) ? _c('div', {
    staticClass: "placeholder flex"
  }, _vm._l((_vm.limit), function(i) {
    return _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "image-bg flex center-flex"
    }, [_c('img', {
      staticClass: "lazyload-images",
      attrs: {
        "src": i
      }
    })]), _vm._v(" "), _c('h3', [_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ex.")])])])
  })) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "froala",
    staticClass: "fr-view"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-2 content-area"
  }, [_c('grid-x', {
    attrs: {
      "col": "2fr 0.5fr",
      "rows": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-2-1"
  }, [_c('div', {
    staticClass: "widget-buttons"
  }, [(_vm.article.status == 'draft' || _vm.article.status == 'preview') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.publishPost();
      }
    }
  }, [_vm._v("PUBLISH")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.openPreviewModal();
      }
    }
  }, [_vm._v("PREVIEW")]), _vm._v(" "), (_vm.article.status == 'publish' || _vm.article.status == 'preview') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.unpublishPost();
      }
    }
  }, [_vm._v("UNPUBLISH")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pub-buttons",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.savePostData(_vm.article)
      }
    }
  }, [_vm._v("UPDATE")]), _vm._v(" "), (_vm.articleKey) ? _c('button', {
    staticClass: "pub-buttons",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.toggleHistoryModal()
      }
    }
  }, [_vm._v("HISTORY")]) : _vm._e(), _vm._v(" "), (_vm.autosaved && _vm.article.lastAutosave) ? _c('span', [_vm._v("AUTOSAVED VERSION " + _vm._s(_vm._f("moment")(_vm.$moment(_vm.article.lastAutosave.timestamp * 1000), "HH:mm DD/MM/YYYY")))]) : _vm._e()]), _vm._v(" "), _c('h3', [_vm._v("Article")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.title),
      expression: "article.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.article.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.article.layout == 'article-layout-evergreen' && (_vm.article.toc && _vm.article.toc.length > 0)) ? _c('div', [_c('h3', [_vm._v("Table of contents")]), _vm._v(" "), _c('ul', {
    staticClass: "toc"
  }, _vm._l((_vm.article.toc), function(item, index) {
    return _c('li', {
      key: ("item-" + index)
    }, [_c('a', {
      attrs: {
        "href": item.anchor
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.subContents.length > 0) ? _c('ul', _vm._l((item.subContents), function(subItem, index) {
      return _c('li', {
        key: ("subitem-" + index)
      }, [_c('a', {
        attrs: {
          "href": subItem.anchor
        }
      }, [_vm._v(_vm._s(subItem.title))])])
    })) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), (_vm.article.layout == 'article-layout-evergreen' || _vm.article.layout == 'article-layout-featured') ? _c('div', {
    staticClass: "editor-area-parent"
  }, [_c('md-tabs', {
    on: {
      "md-changed": _vm.changeWidgetsTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "contentEditor",
      "md-label": "Edit Content"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "layoutEditor",
      "md-label": "Edit Layout"
    }
  })], 1), _vm._v(" "), _c('md-content', {
    staticClass: "editor-area"
  }, [('contentEditor' == _vm.currentTab) ? _c('div', _vm._l((_vm.article.widgets), function(item, key) {
    return _c('div', {
      key: key
    }, [(item.dropcap) ? _c('div', {
      staticStyle: {
        "margin": "0 auto",
        "text-align": "center"
      }
    }, [_vm._v("DROPCAP ENABLED")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_vm._v("Widget " + _vm._s(key))]), _vm._v(" "), _c(item.type, {
      tag: "component",
      on: {
        "changeImage": function($event) {
          _vm.changeImage($event, item)
        },
        "toggle-images-modal": _vm.toggleImagesModal,
        "toggle-dropcap": function($event) {
          item.dropcap = !item.dropcap
        }
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), ('layoutEditor' == _vm.currentTab) ? _c('div', [_c('draggable', {
    staticStyle: {
      "width": "600px",
      "margin": "0 auto"
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.article.widgets),
      callback: function($$v) {
        _vm.$set(_vm.article, "widgets", $$v)
      },
      expression: "article.widgets"
    }
  }, _vm._l((_vm.article.widgets), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items flex center-flex-y flex-space-between"
    }, [_c('div', {
      staticClass: "flex center-flex-y"
    }, [_c('svg', {
      staticClass: "draggable-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(key) + " - " + _vm._s(item.type))])]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.removeWidget(key)
        }
      }
    }, [_vm._v("Remove")])])
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "width": "400px",
      "margin": "0 auto",
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWidgetType),
      expression: "newWidgetType"
    }],
    attrs: {
      "placeholder": "Current Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newWidgetType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Widget Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "froala-editor"
    }
  }, [_vm._v("Text Editor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "code-editor"
    }
  }, [_vm._v("HTML Editor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "image-full-width"
    }
  }, [_vm._v("Full Width Image")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "video-full-width"
    }
  }, [_vm._v("Full Width Video")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "video-scroller"
    }
  }, [_vm._v("Video Scroller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "image-double"
    }
  }, [_vm._v("Double Image Row")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "image-featured"
    }
  }, [_vm._v("Featured Image")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "featured-quote"
    }
  }, [_vm._v("Featured Quote")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "image-standard"
    }
  }, [_vm._v("Standard Image")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "image-circle"
    }
  }, [_vm._v("Circle Image")])])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "200px",
      "height": "30px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.createWidget
    }
  }, [_vm._v("New Widget")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.article.layout == 'article-layout-default' || !_vm.article.layout) ? _c('div', {
    staticClass: "editor-area-parent"
  }, [_c('froala-editor', {
    on: {
      "toggle-modal": _vm.toggleImagesModal
    },
    model: {
      value: (_vm.article.content),
      callback: function($$v) {
        _vm.$set(_vm.article, "content", $$v)
      },
      expression: "article.content"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "margin-top": "26px"
    }
  }, [_c('div', {
    staticClass: "widget-buttons",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-17px"
    }
  }, [(_vm.article.status == 'draft' || _vm.article.status == 'preview') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.publishPost();
      }
    }
  }, [_vm._v("PUBLISH")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.articlePreviewModalOpen = true
      }
    }
  }, [_vm._v("PREVIEW")]), _vm._v(" "), (_vm.article.status == 'publish' || _vm.article.status == 'preview') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.unpublishPost();
      }
    }
  }, [_vm._v("UNPUBLISH")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pub-buttons",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.savePostData(_vm.article)
      }
    }
  }, [_vm._v("UPDATE")]), _vm._v(" "), (_vm.articleKey) ? _c('button', {
    staticClass: "pub-buttons",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.toggleHistoryModal()
      }
    }
  }, [_vm._v("HISTORY")]) : _vm._e()]), _vm._v(" "), _c('h2', [_vm._v("SEO Scorecard")]), _vm._v(" "), _c('div', {
    staticClass: "scorecard"
  }, [_c('md-list', [_c('md-subheader', [_vm._v("Metadata")]), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "titleContainsPhrase"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Title Contains Phrase")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "slugContainsPhrase"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Slug Contains Phrase")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "seoDescriptionLength"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("SEO Description 120-156 Chars")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "seoTitleContainsPhrase"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("SEO Title Contains Phrase")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "seoTitleStartsWithPhrase"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("SEO Title Starts With Phrase")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "relatedTags"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Similar Phrase In Tags")])], 1)], 1), _vm._v(" "), _c('md-list', [_c('md-subheader', [_vm._v("Images")]), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "containsImage"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("At Least 1 Article Image")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "imageWithPhraseInAlt"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Image With Phrase In Alt")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "imageWithPhraseInCaption"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Image With Phrase In Caption")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "imageIsBelowTargetSize"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("All Images Sized Appropriately")])], 1)], 1), _vm._v(" "), _c('md-list', [_c('md-subheader', [_vm._v("Content")]), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "phraseInFirst100Words"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Phrase In First 100 Words")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "headingWithTargetPhrase"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Heading with target phrase")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "phraseMentioned4Times"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Phrase Mentioned x4")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "similarPhraseMentioned10Times"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Similar Phrases Mentioned x10")])], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-2-2",
    staticStyle: {
      "min-width": "460px"
    }
  }, [_c('div', [_c('h3', [_vm._v("Status")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("Status: " + _vm._s(_vm.article.status))]), _vm._v(" "), (_vm.article.lastUpdated) ? _c('div', [_vm._v("Last Updated: " + _vm._s(_vm._f("moment")(_vm.$moment(_vm.article.lastUpdated * 1000), "HH:mm DD/MM/YYYY")))]) : _vm._e(), _vm._v(" "), (_vm.article.timestamp) ? _c('div', [_vm._v("Published: " + _vm._s(_vm._f("moment")(_vm.$moment(_vm.article.timestamp * 1000), "HH:mm DD/MM/YYYY")))]) : _vm._e()]), _vm._v(" "), _c('h3', [_vm._v("Target Phrase")]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Target Phrase")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.targetPhrase),
      expression: "article.targetPhrase"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Phrase"
    },
    domProps: {
      "value": (_vm.article.targetPhrase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "targetPhrase", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "height": "30px",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.openTrends(_vm.article.targetPhrase)
      }
    }
  }, [_vm._v("TRENDS")])]), _vm._v(" "), _c('h3', [_vm._v("Meta")]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Slug")]), _vm._v(" "), _c('div', {
    class: 'input-box slug-input ' + _vm.slugValid
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.slug),
      expression: "article.slug"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Slug"
    },
    domProps: {
      "value": (_vm.article.slug)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "slug", $event.target.value)
      }, _vm.checkSlug]
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-top": "5px",
      "padding-right": "5px"
    }
  }, [_vm._v(_vm._s(_vm.slugValid))])]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Author")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('md-autocomplete', {
    attrs: {
      "md-options": _vm.authors || []
    },
    on: {
      "md-changed": _vm.getAuthors,
      "md-opened": _vm.getAuthors
    },
    scopedSlots: _vm._u([{
      key: "md-autocomplete-empty",
      fn: function(ref) {
        var term = ref.term;

        return [_vm._v("\n                  No Authors matching \"" + _vm._s(term) + "\" were found.\n                ")]
      }
    }, {
      key: "md-autocomplete-item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticStyle: {
            "font-size": "initial"
          }
        }, [_vm._v(_vm._s(item))])]
      }
    }]),
    model: {
      value: (_vm.article.authorSlug),
      callback: function($$v) {
        _vm.$set(_vm.article, "authorSlug", $$v)
      },
      expression: "article.authorSlug"
    }
  }, [_c('label')])], 1), _vm._v(" "), (_vm.article.meta) ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Social Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.meta['og:title']),
      expression: "article.meta['og:title']"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.article.meta['og:title'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.meta, 'og:title', $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('google-preview', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "slug": _vm.article.slug
    },
    model: {
      value: (_vm.article.meta),
      callback: function($$v) {
        _vm.$set(_vm.article, "meta", $$v)
      },
      expression: "article.meta"
    }
  }), _vm._v(" "), (_vm.showTags) ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('div', {
    staticClass: "input-box tag-input-container",
    staticStyle: {
      "height": "auto"
    }
  }, [(_vm.showTags) ? _c('tag-input', {
    attrs: {
      "options": _vm.tags,
      "placeholder": "Enter tags",
      "value": _vm.article.tags,
      "multiple": true
    },
    on: {
      "value": _vm.setTags
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Select Category")]), _vm._v(" "), (_vm.showCategory) ? _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.parentCategory),
      expression: "article.parentCategory"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.article, "parentCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateSubcategories]
    }
  }, _vm._l((_vm.categories), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.subCategories) ? _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.subCategory),
      expression: "article.subCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.article, "subCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.subCategories), function(subitem, subkey) {
    return _c('option', {
      key: subkey,
      domProps: {
        "value": subitem
      }
    }, [_vm._v(_vm._s(subitem))])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Select Layout")]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.layout),
      expression: "article.layout"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.article, "layout", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.layouts), function(layout, layoutkey) {
    return _c('option', {
      key: layoutkey,
      domProps: {
        "value": layout
      }
    }, [_vm._v(_vm._s(layout))])
  }))]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Branded Details")]), _vm._v(" "), (!_vm.article.sponsored_post_data) ? _c('div', [_c('button', {
    on: {
      "click": function($event) {
        _vm.article.sponsored_post_data = {
          brand_name: '',
          brand_image_url: ''
        }
      }
    }
  }, [_vm._v("Enable Branding")])]) : _vm._e(), _vm._v(" "), (_vm.article.sponsored_post_data) ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Link")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.sponsored_post_data.brand_image_click_link),
      expression: "article.sponsored_post_data.brand_image_click_link"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Link"
    },
    domProps: {
      "value": (_vm.article.sponsored_post_data.brand_image_click_link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.sponsored_post_data, "brand_image_click_link", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Brand Name")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.sponsored_post_data.brand_name),
      expression: "article.sponsored_post_data.brand_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Brand Name"
    },
    domProps: {
      "value": (_vm.article.sponsored_post_data.brand_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.sponsored_post_data, "brand_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Brand Text")]), _vm._v(" "), _c('div', {
    staticClass: "input-box",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.sponsored_post_data.brand_text),
      expression: "article.sponsored_post_data.brand_text"
    }],
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Brand Text"
    },
    domProps: {
      "value": (_vm.article.sponsored_post_data.brand_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.sponsored_post_data, "brand_text", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.article.sponsored_post_data.brand_image_url) ? _c('img', {
    attrs: {
      "src": _vm.article.sponsored_post_data.brand_image_url
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.toggleImagesModal({
          type: 'branded'
        })
      }
    }
  }, [_vm._v("Change Image")])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        _vm.article.sponsored_post_data = false
      }
    }
  }, [_vm._v("Remove Branding")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "featured-images"
  }, [_c('h3', [_vm._v("Featured Image")]), _vm._v(" "), (_vm.article.image && _vm.article.image.desktop) ? _c('div', {}, [_c('div', [_vm._v("Desktop")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.article.image.desktop
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.article.image && _vm.article.image.mobile) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', [_vm._v("Mobile")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.article.image.mobile
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.toggleImagesModal({
          type: 'preview-' + _vm.article.layout
        })
      }
    }
  }, [_vm._v("Change Image")])])]), _vm._v(" "), _c('div', {
    staticClass: "social-images"
  }, [_c('h3', [_vm._v("Social Image")]), _vm._v(" "), (_vm.article.socialImage) ? _c('img', {
    attrs: {
      "src": _vm.article.socialImage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.toggleImagesModal({
          type: 'social'
        })
      }
    }
  }, [_vm._v("Change Image")])])])])], 1)])]), _vm._v(" "), (_vm.historyModalOpen) ? _c('modal-history', {
    ref: "modalhistory",
    attrs: {
      "id": _vm.articleKey
    },
    on: {
      "restore": _vm.replaceArticle,
      "close": function($event) {
        _vm.historyModalOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articlePreviewModalOpen) ? _c('modal-article-preview', {
    ref: "modalarticlepreview",
    attrs: {
      "slug": _vm.article['slug'],
      "password": _vm.article['password']
    },
    on: {
      "close": function($event) {
        _vm.articlePreviewModalOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('modal-image-workflow', {
    ref: "imageWorkflow"
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.searchResults.length == 0) ? [_c('button', {
    staticClass: "add-author-button",
    on: {
      "click": _vm.showModalAddAuthor
    }
  }, [_vm._v("ADD NEW AUTHOR")]), _vm._v(" "), (_vm.showAuthorModal) ? _c('modal-author', {
    attrs: {
      "modal": _vm.showAuthorModal
    },
    on: {
      "update:modal": function($event) {
        _vm.showAuthorModal = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "searching-author"
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEARCH AUTHOR")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "modal-input",
    attrs: {
      "placeholder": "Start typing to search author..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }, function($event) {
        _vm.isTyping = true
      }]
    }
  })])]), _vm._v(" "), _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("SLUG")]), _vm._v(" "), _c('md-table-head', [_vm._v("DISPLAY NAME")]), _vm._v(" "), _c('md-table-head', [_vm._v("TAGLINE")])], 1), _vm._v(" "), _vm._l((_vm.authorData), function(item, key) {
    return _c('md-table-row', {
      key: key
    }, [_c('md-table-cell', [_vm._v(_vm._s(item.slug))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.displayName))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.authorTagline))]), _vm._v(" "), _c('md-table-cell', [_c('modal-editauthor', {
      attrs: {
        "passedItem": item
      }
    })], 1), _vm._v(" "), _c('md-table-cell', [_c('modal-delauthor', {
      attrs: {
        "passedItem": item
      }
    })], 1)], 1)
  })], 2), _vm._v(" "), (_vm.authorData.length == 20) ? _c('button', {
    staticStyle: {
      "margin": "5px auto",
      "display": "block",
      "width": "300px"
    },
    on: {
      "click": _vm.moreAuthors
    }
  }, [_vm._v("GET MORE AUTHORS")]) : _vm._e()] : [(_vm.showAuthorModal) ? _c('modal-author', {
    attrs: {
      "modal": _vm.showAuthorModal
    },
    on: {
      "update:modal": function($event) {
        _vm.showAuthorModal = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "searching-author"
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEARCH AUTHOR")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "modal-input",
    attrs: {
      "placeholder": "Start typing to search author..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }, function($event) {
        _vm.isTyping = true
      }]
    }
  })])]), _vm._v(" "), _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("SLUG")]), _vm._v(" "), _c('md-table-head', [_vm._v("DISPLAY NAME")]), _vm._v(" "), _c('md-table-head', [_vm._v("TAGLINE")])], 1), _vm._v(" "), _vm._l((_vm.searchResults), function(item, key) {
    return _c('md-table-row', {
      key: key
    }, [_c('md-table-cell', [_vm._v(_vm._s(item.slug))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.displayName))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.authorTagline))]), _vm._v(" "), _c('md-table-cell', [_c('modal-editauthor', {
      attrs: {
        "passedItem": item
      }
    })], 1), _vm._v(" "), _c('md-table-cell', [_c('modal-delauthor', {
      attrs: {
        "passedItem": item
      }
    })], 1)], 1)
  })], 2)]], 2)
},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('grid-x', {
    attrs: {
      "col": "1fr 1fr",
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Categories")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.updateCacheCategories()
      }
    }
  }, [_vm._v("Update Category Cache")])]), _vm._v(" "), _c('ul', [_vm._l((_vm.categories), function(cat, key) {
    return [_c('li', {
      key: key,
      class: _vm.activeClass(cat, _vm.currentCat),
      on: {
        "click": function($event) {
          _vm.currentCat = cat;
          _vm.currentCatObj = cat;
        }
      }
    }, [_vm._v(_vm._s(cat.name))]), _vm._v(" "), _vm._l((cat.subcategories), function(subcat, subkey) {
      return _c('li', {
        key: key + '-' + subkey,
        class: _vm.activeClass(subcat, _vm.currentCat),
        on: {
          "click": function($event) {
            _vm.currentCat = subcat;
            _vm.currentCatObj = cat;
          }
        }
      }, [_vm._v(_vm._s(cat.name) + " || " + _vm._s(subcat.name))])
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("Podcast")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": _vm.addPodcast
    }
  }, [_vm._v("Add podcast")])]), _vm._v(" "), _vm._l((_vm.currentCat.podcasts), function(podcast, podkey) {
    return _c('div', {
      key: podkey,
      staticClass: "flex-row"
    }, [_c('div', {
      staticClass: "input-box down-caret"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (podcast.playlist),
        expression: "podcast.playlist"
      }],
      key: '--' + podkey,
      ref: "addPodcastSelector",
      refInFor: true,
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(podcast, "playlist", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.selected()
        }],
        "focus": function($event) {
          _vm.changeColor()
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v("Select a podcast")]), _vm._v(" "), _vm._l((_vm.podcasts), function(item, optionkey) {
      return _c('option', {
        key: optionkey,
        domProps: {
          "value": {
            slug: item['.key'],
            title: item.title
          }
        }
      }, [_vm._v(_vm._s(item.title))])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "widget-buttons"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.currentCat.podcasts.splice(podkey, 1)
        }
      }
    }, [_vm._v("Remove")]), _vm._v(" "), _c('button', {
      on: {
        "click": _vm.saveCurrentCat
      }
    }, [_vm._v("Save")])])])
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'full-width ' + _vm.value.captionStyle
  }, [_c('div', {
    staticClass: "image-parent"
  }, [_c('img', {
    attrs: {
      "src": _vm.value.image.mobile || 'https://firebasestorage.googleapis.com/v0/b/mamamia-pwa.appspot.com/o/images%2FAMamamiasStory_Image-01.png129?alt=media&token=15b9cc5d-63c5-49e6-b253-d6a88cba0814'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-uploader"
  }, [_c('button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": _vm.changeImage
    }
  }, [_vm._v("CHANGE IMAGE")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.caption),
      expression: "value.caption"
    }],
    staticClass: "caption",
    attrs: {
      "placeholder": "Enter a caption..."
    },
    domProps: {
      "value": (_vm.value.caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "caption", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.source),
      expression: "value.source"
    }],
    staticClass: "source",
    attrs: {
      "placeholder": "Enter a source.."
    },
    domProps: {
      "value": (_vm.value.source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "source", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "selectHolder"
  }, [_c('span', [_vm._v("Caption Style")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.captionStyle),
      expression: "value.captionStyle"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.value, "captionStyle", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "layout-1"
    }
  }, [_vm._v("Standard")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "layout-2"
    }
  }, [_vm._v("Over Image")])])])])
},staticRenderFns: []}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    ref: "fileform",
    on: {
      "click": _vm.selectImage
    }
  }, [_c('span', {
    staticClass: "drop-files"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    attrs: {
      "id": "photopea",
      "src": "https://www.photopea.com/"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              ARE YOU SURE YOU WANT TO DELETE AUTHOR ?\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.deleteAuthor
    }
  }, [_vm._v("\n                YES, DELETE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button cancel-delete-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-width"
  }, [_c('div', [_c('h3', {
    staticStyle: {
      "color": "#444",
      "border-bottom": "1px solid #444"
    }
  }, [_vm._v("Video Scroller")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.url),
      expression: "value.url"
    }],
    attrs: {
      "placeholder": "Enter the video URL"
    },
    domProps: {
      "value": (_vm.value.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "url", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.thumbnail),
      expression: "value.thumbnail"
    }],
    attrs: {
      "placeholder": "Enter thumbnail URL"
    },
    domProps: {
      "value": (_vm.value.thumbnail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "thumbnail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.videoLength),
      expression: "value.videoLength"
    }],
    attrs: {
      "placeholder": "Enter the length of the video"
    },
    domProps: {
      "value": (_vm.value.videoLength)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "videoLength", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.value.items), function(html, index) {
    return _c('div', {
      key: index
    }, [_c('froala', {
      staticStyle: {
        "width": "100%",
        "margin": "0",
        "min-height": "100%",
        "margin-top": "10px"
      },
      attrs: {
        "config": _vm.froalaConfig
      },
      model: {
        value: (_vm.value.items[index]),
        callback: function($$v) {
          _vm.$set(_vm.value.items, index, $$v)
        },
        expression: "value.items[index]"
      }
    }), _vm._v(" "), _c('button', {
      staticStyle: {
        "margin": "0 auto",
        "margin-top": "10px"
      },
      on: {
        "click": function($event) {
          _vm.value.items.splice(index, 1)
        }
      }
    }, [_vm._v("Remove Text Box")])], 1)
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin": "0 auto",
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        _vm.value.items.push('')
      }
    }
  }, [_vm._v("Add Text Box")])], 2)])
},staticRenderFns: []}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-list"
  }, [_c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    ref: "pageSelector",
    staticClass: "page-list-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selected()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a page")]), _vm._v(" "), _vm._l((_vm.dataPages), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.data.name))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "flex center-flex-y",
    on: {
      "click": _vm.showModalDeleteAuthor
    }
  }, [_vm._v("REMOVE AUTHOR")]), _vm._v(" "), (_vm.showAuthorDeleteModal) ? _c('modal-authordelete', {
    attrs: {
      "modal": _vm.showAuthorDeleteModal,
      "passedObject": _vm.objectToPass
    },
    on: {
      "update:modal": function($event) {
        _vm.showAuthorDeleteModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              ARE YOU SURE YOU WANT TO REMOVE THIS ARTICLE ?\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.deleteBrand
    }
  }, [_vm._v("\n                YES, REMOVE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button cancel-delete-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              Update the fields which need change\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n              Change Author Display Name\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.displayName),
      expression: "passedObject.displayName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.displayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "displayName", $event.target.value)
      }
    }
  })]), _vm._v("\n              Change About author - Biographical information\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.aboutAuthor),
      expression: "passedObject.aboutAuthor"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.aboutAuthor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "aboutAuthor", $event.target.value)
      }
    }
  })]), _vm._v("\n              Change Author Tagline\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.authorTagline),
      expression: "passedObject.authorTagline"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.authorTagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "authorTagline", $event.target.value)
      }
    }
  })]), _vm._v("\n              Change SEO Title for author page\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.authorSeoTitle),
      expression: "passedObject.authorSeoTitle"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.authorSeoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "authorSeoTitle", $event.target.value)
      }
    }
  })]), _vm._v("\n              Change SEO Description for author page\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.authorSeoDesc),
      expression: "passedObject.authorSeoDesc"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.authorSeoDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "authorSeoDesc", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.passedObject.customAvatar) ? _c('div', [_vm._v("\n                Current Author Image\n                "), _c('img', {
    staticStyle: {
      "width": "50px",
      "height": "auto"
    },
    attrs: {
      "src": _vm.passedObject.customAvatar
    }
  })]) : _c('div', [_vm._v("The Author does not have custom image")]), _vm._v("\n              Upload new image to change author image\n              "), _c('ic-firebase-upload', {
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": _vm.onUploadedAuthorImage,
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.editAuthor
    }
  }, [_vm._v("\n                UPDATE AUTHOR\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button cancel-delete-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid-x', {
    attrs: {
      "col": "1fr 1fr",
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "redirect-strings"
  }, [_c('h1', [_vm._v("Redirect Strings")]), _vm._v(" "), _c('div', {
    staticClass: "redirect-input"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRedirectString.from),
      expression: "newRedirectString.from"
    }],
    attrs: {
      "type": "text",
      "placeholder": "From"
    },
    domProps: {
      "value": (_vm.newRedirectString.from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRedirectString, "from", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRedirectString.to),
      expression: "newRedirectString.to"
    }],
    attrs: {
      "type": "text",
      "placeholder": "To"
    },
    domProps: {
      "value": (_vm.newRedirectString.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRedirectString, "to", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "click": _vm.createRedirectString
    }
  }, [_vm._v("Create Redirect String")])]), _vm._v(" "), _c('div', {
    staticClass: "flex redirect"
  }, [_c('span', {
    staticClass: "flex-3"
  }, [_c('b', [_vm._v("From")])]), _vm._v(" "), _c('span', {
    staticClass: "flex-3"
  }, [_c('b', [_vm._v("To")])]), _vm._v(" "), _c('span', {
    staticClass: "flex-1"
  })]), _vm._v(" "), _vm._l((_vm.redirectStrings), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items redirect flex flex-space-between center-flex-y"
    }, [_c('span', {
      staticClass: "flex-3"
    }, [_vm._v(_vm._s(item.from))]), _vm._v(" "), _c('span', {
      staticClass: "flex-3"
    }, [_vm._v(_vm._s(item.to))]), _vm._v(" "), _c('span', {
      staticClass: "flex-1"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.removeRedirectString(item)
        }
      }
    }, [_vm._v("Remove")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "redirect-regex"
  }, [_c('h1', [_vm._v("Redirect Regex")]), _vm._v(" "), _c('div', {
    staticClass: "redirect-input"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRedirectRegex.from),
      expression: "newRedirectRegex.from"
    }],
    attrs: {
      "type": "text",
      "placeholder": "From"
    },
    domProps: {
      "value": (_vm.newRedirectRegex.from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRedirectRegex, "from", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRedirectRegex.to),
      expression: "newRedirectRegex.to"
    }],
    attrs: {
      "type": "text",
      "placeholder": "To"
    },
    domProps: {
      "value": (_vm.newRedirectRegex.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRedirectRegex, "to", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "click": _vm.createRedirectRegex
    }
  }, [_vm._v("Create Redirect Regex")])]), _vm._v(" "), _c('div', {
    staticClass: "flex redirect"
  }, [_c('span', {
    staticClass: "flex-3"
  }, [_c('b', [_vm._v("From")])]), _vm._v(" "), _c('span', {
    staticClass: "flex-3"
  }, [_c('b', [_vm._v("To")])]), _vm._v(" "), _c('span', {
    staticClass: "flex-1"
  })]), _vm._v(" "), _vm._l((_vm.redirectRegex), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items redirect flex center-flex-y"
    }, [_c('span', {
      staticClass: "flex-3"
    }, [_vm._v(_vm._s(item.from))]), _vm._v(" "), _c('span', {
      staticClass: "flex-3"
    }, [_vm._v(_vm._s(item.to))]), _vm._v(" "), _c('span', {
      staticClass: "flex-1"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.removeRedirectRegex(item)
        }
      }
    }, [_vm._v("Remove")])])])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex",
    staticStyle: {
      "width": "840px",
      "margin": "10px auto"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('div', {
    staticClass: "image-parent"
  }, [_c('img', {
    attrs: {
      "src": _vm.value.objects[0].image.mobile || 'https://firebasestorage.googleapis.com/v0/b/mamamia-pwa.appspot.com/o/images%2FAMamamiasStory_Image-01.png129?alt=media&token=15b9cc5d-63c5-49e6-b253-d6a88cba0814'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-uploader"
  }, [_c('button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.changeImage(0)
      }
    }
  }, [_vm._v("CHANGE IMAGE")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.objects[0].caption),
      expression: "value.objects[0].caption"
    }],
    attrs: {
      "placeholder": "Enter a caption..."
    },
    domProps: {
      "value": (_vm.value.objects[0].caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value.objects[0], "caption", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.objects[0].source),
      expression: "value.objects[0].source"
    }],
    attrs: {
      "placeholder": "Enter a source..."
    },
    domProps: {
      "value": (_vm.value.objects[0].source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value.objects[0], "source", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10px",
      "flex": "1"
    }
  }, [_c('div', {
    staticClass: "image-parent"
  }, [_c('img', {
    attrs: {
      "src": _vm.value.objects[1].image.mobile || 'https://firebasestorage.googleapis.com/v0/b/mamamia-pwa.appspot.com/o/images%2FAMamamiasStory_Image-01.png129?alt=media&token=15b9cc5d-63c5-49e6-b253-d6a88cba0814'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-uploader"
  }, [_c('button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.changeImage(1)
      }
    }
  }, [_vm._v("CHANGE IMAGE")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.objects[1].caption),
      expression: "value.objects[1].caption"
    }],
    attrs: {
      "placeholder": "Enter a caption..."
    },
    domProps: {
      "value": (_vm.value.objects[1].caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value.objects[1], "caption", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.objects[1].source),
      expression: "value.objects[1].source"
    }],
    attrs: {
      "placeholder": "Enter a source..."
    },
    domProps: {
      "value": (_vm.value.objects[1].source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value.objects[1], "source", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex",
    style: ('width:880px;margin:10px auto;padding:20px;background-color:' + _vm.value.backgroundColor.hex + ';')
  }, [_c('div', {
    staticStyle: {
      "margin-right": "10px",
      "flex": "1"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.quote),
      expression: "value.quote"
    }],
    staticStyle: {
      "width": "100%",
      "height": "120px"
    },
    attrs: {
      "placeholder": "Enter a quote..."
    },
    domProps: {
      "value": (_vm.value.quote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "quote", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('slider-picker', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    model: {
      value: (_vm.value.backgroundColor),
      callback: function($$v) {
        _vm.$set(_vm.value, "backgroundColor", $$v)
      },
      expression: "value.backgroundColor"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.backgroundColor.hex),
      expression: "value.backgroundColor.hex"
    }],
    attrs: {
      "placeholder": "Hex colour"
    },
    domProps: {
      "value": (_vm.value.backgroundColor.hex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value.backgroundColor, "hex", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "3"
    }
  }, [_c('froala-editor', {
    staticStyle: {
      "width": "100%",
      "margin": "0",
      "min-height": "100%"
    },
    model: {
      value: (_vm.value.wysiwyg),
      callback: function($$v) {
        _vm.$set(_vm.value, "wysiwyg", $$v)
      },
      expression: "value.wysiwyg"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "flex center-flex-y",
    on: {
      "click": _vm.showModalEditUser
    }
  }, [_vm._v("EDIT USER")]), _vm._v(" "), (_vm.showUserEditModal) ? _c('modal-useredit', {
    attrs: {
      "modal": _vm.showUserEditModal,
      "passedObject": _vm.objectToPass
    },
    on: {
      "update:modal": function($event) {
        _vm.showUserEditModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(254)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "rounded",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "rounded",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.signIn($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "rounded",
    on: {
      "click": _vm.signIn
    }
  }, [_vm._v("Sign In")])])
},staticRenderFns: []}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid-x', {
    attrs: {
      "col": "1fr 1fr",
      "rows": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Pages")]), _vm._v(" "), _c('page-list', {
    ref: "pageList",
    attrs: {
      "data-pages": _vm.pages
    },
    on: {
      "page-data": function($event) {
        _vm.selectPageSEO($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("Manage SEO / Header Tags")]), _vm._v(" "), (_vm.selected.page) ? _c('p', [_vm._v("Selected Page: " + _vm._s(this.selected.page))]) : _vm._e(), _vm._v(" "), (_vm.selected.tag) ? _c('p', [_vm._v("Selected Tag: " + _vm._s(this.selected.tag))]) : _vm._e(), _vm._v(" "), (!_vm.currentPageSEO.disable) ? _c('div', [_c('seo-tag-input', {
    model: {
      value: (_vm.currentPageSEO),
      callback: function($$v) {
        _vm.currentPageSEO = $$v
      },
      expression: "currentPageSEO"
    }
  }), _vm._v(" "), (!_vm.editTagSEO) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.savePageSEO()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.editTagSEO) ? _c('button', {
    on: {
      "click": _vm.updateSearchedTag
    }
  }, [_vm._v("Save")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Tags")]), _vm._v(" "), (_vm.currentPageSEO.disable) ? _c('div', [_c('h4', [_vm._v("New Tag")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Tag"
    },
    domProps: {
      "value": (_vm.newTag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTag = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.createTagSeo()
      }
    }
  }, [_vm._v("Create")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('search-dropdown', {
    attrs: {
      "placeholder": "Please Search For Tag",
      "options": _vm.tags
    },
    on: {
      "value": _vm.getDropdownQuery
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              AUTHOR DETAILS\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n              Author Display Name\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAuthor.displayName),
      expression: "newAuthor.displayName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newAuthor.displayName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAuthor, "displayName", $event.target.value)
      }, _vm.fillSlug]
    }
  })]), _vm._v("\n              About author - Biographical information\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAuthor.aboutAuthor),
      expression: "newAuthor.aboutAuthor"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newAuthor.aboutAuthor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAuthor, "aboutAuthor", $event.target.value)
      }
    }
  })]), _vm._v("\n              Author Tagline\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAuthor.authorTagline),
      expression: "newAuthor.authorTagline"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newAuthor.authorTagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAuthor, "authorTagline", $event.target.value)
      }
    }
  })]), _vm._v("\n              Author Slug\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAuthor.slug),
      expression: "newAuthor.slug"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newAuthor.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAuthor, "slug", $event.target.value)
      }
    }
  })]), _vm._v("\n              SEO Title for author page\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAuthor.authorSeoTitle),
      expression: "newAuthor.authorSeoTitle"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newAuthor.authorSeoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAuthor, "authorSeoTitle", $event.target.value)
      }
    }
  })]), _vm._v("\n              SEO Description for author page\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAuthor.authorSeoDesc),
      expression: "newAuthor.authorSeoDesc"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newAuthor.authorSeoDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAuthor, "authorSeoDesc", $event.target.value)
      }
    }
  })]), _vm._v("\n              Author Image Upload\n              "), _c('ic-firebase-upload', {
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": _vm.onUploadedAuthorImage,
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.addNewAuthor
    }
  }, [_vm._v("\n                ADD AUTHOR\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.currentWidget.type === 'author-carousel') ? _c('author-carousel', {
    attrs: {
      "selectedItem": _vm.selectedItem,
      "currentWidget": _vm.currentWidget,
      "mode": _vm.mode,
      "maxItems": 20,
      "storage": _vm.storage
    },
    on: {
      "orderChange": _vm.orderChange,
      "setWidgetData": function($event) {
        _vm.$emit('setWidgetData', $event)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[364]);


// WEBPACK FOOTER //
// static/js/app.1db9cec209f2a0e4c938.js